import { $4, $$4, $id4, debounce } from '@theme/utilities';
import { getterAdd, getterGet, getterRunFn, btnTooltip, DrawerComponent, VariantChangeBase } from "@theme/global";
import { ThemeEvents } from '@theme/events';
const {dialogClose, dialogOpen} = ThemeEvents;

// WISHLIST
var $wishlist_list = $id4('hdt_wishlist_list'),
  $compare_list = $id4('hdt_compare_list'),
  nameCachedWishlist = 'theme4:wishlist:id',
  nameCachedCompare = 'theme4:compare:id';
// if exit $wishlist_list is use app wishlist the4
if ($wishlist_list) {
  var arr_wishlist_list = $wishlist_list.textContent ? $wishlist_list.textContent.split(' ') : [];
}
else {
  var arr_wishlist_list = (!localStorage.getItem(nameCachedWishlist)) ? [] : localStorage.getItem(nameCachedWishlist).split(',');  // remove id: and conver array
}
if ($compare_list){
  var arr_compare_list = $compare_list.textContent ? $compare_list.textContent.split(' ') : [];
}
else {
  var arr_compare_list = (!localStorage.getItem(nameCachedCompare)) ? [] : localStorage.getItem(nameCachedCompare).split(',');  // remove id: and conver array
}
// arr_wishlist_list = [1234, 5678, 9011]
// arr_compare_list = [1234, 5678, 9011]

var linkWishlistApp = '/apps/ecomrise/wishlist',
  linkCompareApp = '/apps/ecomrise/compare',
  actionAfterWishlistAdded = themeHDN.extras.AddedWishlistRemove ? 'remove' : 'added',
  actionAfterCompareAdded = themeHDN.extras.AddedCompareRemove ? 'remove' : 'added',
  limitWishlist = $wishlist_list ? 100 : 50,
  limitCompare = 5,
  conver_to_link_fn = function (prefix = this.textFn, array = this.array) {
    const x = themeHDN.routes.search_url + `/?view=${prefix}`,
      y = x + '&type=product&options[unavailable_products]=last&q=';
    return (array.length) ? y + encodeURI(`id:${array.join(' OR id:')}`) : x;
  };
// Reset if limit change
if (arr_wishlist_list.length > limitWishlist) {
  arr_wishlist_list.splice(limitWishlist - 1, arr_wishlist_list.length - 1);
  localStorage.setItem(nameCachedWishlist, arr_wishlist_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageWishlist) {
  if (arr_wishlist_list.length && !window.isWishlistPerformed) {
    window.location.href = conver_to_link_fn('wishlist', arr_wishlist_list)
  } else {
    window.history.replaceState({}, document.title, conver_to_link_fn('wishlist', []));
  }
  themeHDN.wisHref = conver_to_link_fn('wishlist', arr_wishlist_list);
}

// Reset if limit change
if (arr_compare_list.length > limitCompare) {
  arr_compare_list.splice(limitCompare - 1, arr_compare_list.length - 1);
  localStorage.setItem(nameCachedCompare, arr_compare_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageCompare) {
  if (arr_compare_list.length && !window.isComparePerformed) {
    window.location.href = conver_to_link_fn('compare', arr_compare_list)
  } else {
    window.history.replaceState({}, document.title, conver_to_link_fn('compare', []));
  }
}
var _wishlist_id, _wishlist_handle,
  _update_wis_text, update_wis_text_fn,
  _update_wis_btns, update_wis_btns_fn,
  _click_wis, click_wis_fn,
  _add_wis, add_wis_fn,
  _remove_wis, remove_wis_fn,
  _action_after_remove_add, action_after_remove_add_fn,
  _show_popup_compare, show_popup_compare_fn,
  _conver_to_link;
class Wishlist extends btnTooltip {
  constructor() {
    super();
    getterAdd(_wishlist_id, this, this.dataset.id);
    getterAdd(_wishlist_handle, this, this.dataset.handle);
    getterAdd(_update_wis_text, this);
    getterAdd(_update_wis_btns, this);
    getterAdd(_click_wis, this);
    getterAdd(_add_wis, this);
    getterAdd(_remove_wis, this);
    getterAdd(_action_after_remove_add, this);
    getterAdd(_show_popup_compare, this);
    getterAdd(_conver_to_link, this);
    this.tabIndex = 0;
    this.addEventListener("click", (event) => getterRunFn(_click_wis, this, click_wis_fn).call(this, event));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter") getterRunFn(_click_wis, this, click_wis_fn).call(this, event)
    });
  }
  static get observedAttributes() {
    return ["action"];
  }
  get isFnWishlist() {
    return true;
  }
  get textFn() {
    return 'wishlist';
  }
  get isPageWishlistorCompare() {
    //add code check page
    return this.isFnWishlist ? window.isPageWishlist : window.isPageCompare;
  }
  get limit() {
    return this.isFnWishlist ? limitWishlist : limitCompare;
  }
  get nameCached() {
    return this.isFnWishlist ? nameCachedWishlist : nameCachedCompare;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get actionAfterAdded() {
    return this.isFnWishlist ? actionAfterWishlistAdded : actionAfterCompareAdded;
  }
  get action() {
    return this.getAttribute('action');
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || (oldValue === null && newValue === 'add')) return;
    getterRunFn(_update_wis_text, this, update_wis_text_fn).call(this, newValue);
    super.attributeChangedCallback(name, oldValue, newValue);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.array.indexOf(getterGet(_wishlist_id, this)) > -1) {
      if (this.hasAttribute('remove-on-page')) {
        return
      }
      this.setAttribute('action', this.actionAfterAdded);
    }
  }
};
_wishlist_id = new WeakMap();
_wishlist_handle = new WeakMap();
_update_wis_text = new WeakSet();
_update_wis_btns = new WeakSet();
_click_wis = new WeakSet();
_add_wis = new WeakSet();
_remove_wis = new WeakSet();
_action_after_remove_add = new WeakSet();
_conver_to_link = new WeakSet();
_show_popup_compare = new WeakSet();
update_wis_text_fn = function (value) {
  if (this.hasAttribute('remove-on-page')) return;
  const text = themeHDN.extras[`text_${this.isFnWishlist ? 'wis' : 'cp'}_${value}`],
    icon = themeHDN.extras[`icon_${this.isFnWishlist ? 'wis' : 'cp'}_${value}`];
  if (icon) this.firstElementChild.replaceWith(document.createRange().createContextualFragment(icon));
  if (text) {
    this.lastElementChild.textContent = text;
    this.setAttribute('data-txt-tt',text)
  }
};
update_wis_btns_fn = function (_action) {
  // Update Button
  $$4(`hdt-${this.textFn}[data-id="${getterGet(_wishlist_id, this)}"]`).forEach(btn => {
    btn.setAttribute('action', _action);
  });
  // Update Count and link
  document.dispatchEvent(new CustomEvent(`theme4:${this.textFn}:update`, {
    bubbles: true,
    detail: 'the4'  // arr_wishlist_list
  }));
  if ((window.isPageWishlist)) themeHDN.wisHref = conver_to_link_fn('wishlist', arr_wishlist_list);
};
click_wis_fn = function (e) {

  if (this.action == 'add') {
    // ADD
    getterRunFn(_add_wis, this, add_wis_fn).call(this);
  } else if (this.action === 'added') {
    // ADDED: go to page wishlist
    if (!this.isFnWishlist && themeHDN.extras.enableComparePopup) {
      getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    } else {
      window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
    }
  } else {
    // REMOVE
    getterRunFn(_remove_wis, this, remove_wis_fn).call(this, e);
  }
};
add_wis_fn = function (e) {
  if ($wishlist_list && this.isFnWishlist || $compare_list && !this.isFnWishlist) {
    // app wishlist
    this.setAttribute('aria-busy', true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: 'add'
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status != 'success') {
        console.error(data.message || 'Unknow error');
        return;
      }
      if(this.isFnWishlist) {
        arr_wishlist_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
        if (!Array.isArray(arr_wishlist_list)) {
          arr_wishlist_list = arr_wishlist_list.split(',');
        }
      }
      if (!this.isFnWishlist) {
        arr_compare_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
        if (!Array.isArray(arr_compare_list)) {
          arr_compare_list = arr_compare_list.split(',');
        }
        getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
      }
      getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, this.actionAfterAdded);
    })
    .catch(function (error) {
      console.log('Error: ' + error);
    })
    .finally(() => {
      this.setAttribute('aria-busy', false);
    });
  }
  else {
    // local wishlist
    // adds the specified elements to the beginning of an array
    this.array.unshift(getterGet(_wishlist_id, this));
    //console.log(this.array, getterGet(_wishlist_id, this))
    if (this.array.length > this.limit) {
      // if over limit remove element on last array
      let arraySplice = this.array.splice(this.limit, 1);
      // arraySplice: allway has 1 element
      $$4(`hdt-${this.textFn}[data-id="${arraySplice[0]}"]`).forEach(btn => {
        btn.setAttribute('action', 'add');
      });
    }
    if (!this.isFnWishlist) getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, this.actionAfterAdded);
    localStorage.setItem(this.nameCached, this.array.toString());
  }
};
remove_wis_fn = function (e) {
  e.preventDefault();
  e.stopPropagation();
  // REMOVE
  if ($wishlist_list && this.isFnWishlist || $compare_list && !this.isFnWishlist) {
    // app wishlist
    this.setAttribute('aria-busy', true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: 'add',
        _method: 'DELETE'
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status != 'success') {
        console.error(data.message || 'Unknow error');
        return;
      }
      arr_wishlist_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
      if (!Array.isArray(arr_wishlist_list)) {
        arr_wishlist_list = arr_wishlist_list.split(',');
      }
      getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, 'add');
    })
    .catch(function (error) {
      console.log('Error: ' + error);
    })
    .finally(() => {
      this.setAttribute('aria-busy', false);
    });
  } else {
    // local wishlist
    this.array.splice(this.array.indexOf(getterGet(_wishlist_id, this)), 1);
    localStorage.setItem(this.nameCached, this.array.toString());

    getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, 'add');
  }
};
action_after_remove_add_fn = function (action) {

  if (this.getAttribute('action') == 'remove' && this.hasAttribute('remove-on-page')) {
    if (this.isFnWishlist) {      
      this.setAttribute('aria-busy', true);
      if (this.isPageWishlistorCompare) window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
      // this.closest('.hdt-card-product').remove();
    } else {
      $$4(`.hdt-compare-item-${getterGet(_wishlist_id, this)}`).forEach(item => {
        item.remove();
        // console.log("Remove compare item");
      });
    }
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    if (this.array.length == 0) {
      $id4('drawerCompare')?.closest('hdt-drawer')?.close();
      if (this.isPageWishlistorCompare) window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
    }
    //this.setAttribute('action', action);
  } else {
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    // is page wishlist or compare reload page
    if (this.isPageWishlistorCompare) window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
  }
};
show_popup_compare_fn = function (event) {
  if (!themeHDN.extras.enableComparePopup || this.isPageWishlistorCompare) return;
  // add code if want show popup compare
  $id4('drawerCompare')?.closest('hdt-drawer')?.open();
  fetch(conver_to_link_fn('compare', arr_compare_list) + "&section_id=compare-offcanvas")
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const prds = html.querySelector('offcanvas-compare');

      if (prds && prds.innerHTML.trim().length) {

        $4("offcanvas-compare").innerHTML = prds.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    });
};
var _clear_all, clear_all_fn;
class ClearAll extends HTMLElement {
  constructor() {
    super();
    getterAdd(_clear_all, this);
    this.tabIndex = 0;
    this.addEventListener("click", getterRunFn(_clear_all, this, clear_all_fn));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter") getterRunFn(_clear_all, this, clear_all_fn).call(this)
    });
  }
  get ofFn() {
    return this.getAttribute('of-fn'); //'compare', 'wishlist'
  }
  get nameCached() {
    return this.ofFn == 'compare' ? nameCachedCompare : nameCachedWishlist;
  }
  set array(value) {
    this.ofFn == 'compare' ? arr_compare_list = value : arr_wishlist_list = value;
  }
};
_clear_all = new WeakSet();
clear_all_fn = function () {
  localStorage.removeItem(this.nameCached);
  // Update Buttons
  $$4(`hdt-${this.ofFn}[action="added"]`).forEach(btn => {
    btn.setAttribute('action', 'add');
  });
  // Update Count and link
  document.dispatchEvent(new CustomEvent(`theme4:${this.ofFn}:update`, {
    bubbles: true,
    detail: 'the4'
  }));
  this.array = [];
  $id4(`drawerCompare`)?.closest('hdt-drawer')?.close();
  if ($4(`#drawerCompare offcanvas-compare`)){
    $4(`#drawerCompare offcanvas-compare`).innerHTML = "";
  }
};
customElements.define("hdt-clear-all", ClearAll);
// eg: <hdt-clear-all role="button" of-fn="compare">Clear All </hdt-clear-all>

// Update count
class WishlistCount extends HTMLElement {
  constructor() {
    super();
    this.textContent = this.array.length;
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      //console.log(this.prefix + ' count update.');
      this.textContent = this.array.length;
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? 'wishlist' : 'compare';
  }
}
// Update link page
class WishlistLink extends HTMLElement {
  constructor() {
    super();
    $4('a', this).href = conver_to_link_fn(this.prefix, this.array);
    //console.log('WishlistLink', this.href)
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      $4('a', this).href = conver_to_link_fn(this.prefix, this.array);
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? 'wishlist' : 'compare';
  }
}
customElements.define("hdt-wishlist", Wishlist);
customElements.define("hdt-wishlist-count", WishlistCount);
customElements.define("hdt-wishlist-a", WishlistLink);

// COMPARE
class Compare extends Wishlist {
  get isFnWishlist() {
    return false;
  }
  get textFn() {
    return 'compare';
  }
}
// Update count
class CompareCount extends WishlistCount {
  get isFnWishlist() {
    return false;
  }
}
// Update link page
class CompareLink extends WishlistLink {
  get isFnWishlist() {
    return false;
  }
}
customElements.define("hdt-compare", Compare);
customElements.define("hdt-compare-count", CompareCount);
customElements.define("hdt-compare-a", CompareLink);

// footer accodion
function handleAccordionClick() {
  let accordion = this.parentElement;
  accordion.classList.toggle('open');
  if (window.innerWidth < 768) {
    let content = accordion.querySelector('.hdt-collapse-content');
    if (accordion.classList.contains('open')) {
      content.style.height = content.scrollHeight + 'px';
    } else {
      content.style.height = '0';
    }
  }
}
function updateMaxHeight() {
  if (window.innerWidth >= 768) {
    document.querySelectorAll('.hdt-footer-section .hdt-collapse-content').forEach(function(content) {
      content.style.height = '';
    });
  }
}
document.querySelectorAll('.hdt-footer-section .hdt-footer-heading').forEach(function(element) {

  element.addEventListener('click', handleAccordionClick);
});
window.addEventListener('resize', function() {
  if (window.innerWidth < 768) {
    document.querySelectorAll('.hdt-footer-section .hdt-footer-heading').forEach(function(element) {
      element.removeEventListener('click',handleAccordionClick);
      element.addEventListener('click',handleAccordionClick);
    });
  } else {
    document.querySelectorAll('.hdt-footer-section .hdt-footer-heading').forEach(function(element) {
      element.removeEventListener('click',handleAccordionClick);
    });
    updateMaxHeight();
  }
});


// --------------------------
// Back to top
// --------------------------
class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    if (window.innerWidth < 768 && this.config.hiddenMobile) return;
    this.debounce_timer = 0;
    this.debounce_timer2 = 0;
    this.circlechart = this.querySelector('.hdt-circle-css');
    this.addEventListener("click", this.goTop.bind(this));
    window.addEventListener("scroll", this.backToTop.bind(this));
  }
  goTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  backToTop() {
    let self = this;
    if (this.debounce_timer) { clearTimeout(this.debounce_timer); }
    this.debounce_timer = setTimeout(function () {
      if (window.scrollY > self.config.scrollTop) {
        self.classList.add('is--show');
      } else {
        self.classList.remove('is--show');
      }
    }, 40);

    if (!this.circlechart) return;

    if (this.debounce_timer2) { clearTimeout(this.debounce_timer2); }

    this.debounce_timer2 = setTimeout(function () {
      let scrollTop2 = window.scrollY,
        docHeight = document.body.offsetHeight,
        winHeight = window.innerHeight,
        scrollPercent = scrollTop2 / (docHeight - winHeight),
        degrees = scrollPercent * 360;
      self.circlechart.style.setProperty("--cricle-degrees", degrees + 'deg');
    }, 6);
  }
}

customElements.define('back-to-top', BackToTop);

// --------------------------
// Form status
// --------------------------


const contactForm = $$4('form[action^="/contact"]');
contactForm.forEach(function(form) {
  form.addEventListener("submit", function(event){
    sessionStorage.setItem("the4:recentform", this.getAttribute("id"));
  })
});
var recentform = sessionStorage.getItem("the4:recentform") || "";

if (location.href.indexOf('contact_posted=true') > 0 && recentform !== "") {
  document.dispatchEvent( new CustomEvent('the4:recentform', { detail: { recentform: recentform }, bubbles: true, cancelable: true }) );
  $id4(recentform)?.classList.add("on-live");
  if (recentform.indexOf('ContactFormAsk') >= 0 && $id4(recentform).length > 0) {
    let modal_id = document.getElementById(recentform).getAttribute('data-modal');
    document.getElementById(modal_id).closest('hdt-modal').open();
    sessionStorage.removeItem("the4:recentform");
  }
  if ($4('.form-status-mirror-'+ recentform)) {
    $4('.form-status-mirror-'+ recentform).style.cssText = "display: block;";
  }
}

else if (location.href.indexOf('customer_posted=true') > 0 && recentform !== "") {
  document.addEventListener('the4:recentform', (event)=>{
    let modal_id = document.getElementById(event.detail.recentform).getAttribute('data-id');
    document.getElementById(modal_id).closest('hdt-modal').open();
  })
  document.dispatchEvent( new CustomEvent('the4:recentform', { detail: { recentform: recentform }, bubbles: true, cancelable: true }) );
  $id4(recentform)?.classList.add("on-live");
}
else if (location.href.indexOf('contact_posted=true') > 0 && location.href.indexOf('#') > 0 ) {
  var recentform = location.href.split("#")[1];
  if ($id4(recentform).length > 0) {
    sessionStorage.setItem("the4:recentform", recentform);
    $id4(recentform).classList.add("on-live");
    if ($4('.form-status-mirror-'+ recentform)) {
      $4('.form-status-mirror-'+ recentform).style.cssText = "display: block;";
    }
  }
}

// --------------------------
// numberRandom
// --------------------------
class numberRandom extends HTMLElement {
  constructor() {
    super();
    let config = JSON.parse(this.getAttribute("config"));
    this.min = config.min;
    this.max = config.max;
    this.interval = config.interval;
    this.number = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    this.ofset = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"];
    this.prioritize = ["10", "20", "15"];
    this.h = "";
    this.e = "";
    this.M = "";
    this.liveViewInt();
    setInterval(this.liveViewInt.bind(this), this.interval);
  }

  liveViewInt() {
    if (this.h = Math.floor(Math.random() * this.ofset.length), this.e = this.ofset[this.h], this.number = parseInt(this.number) + parseInt(this.e), this.min >= this.number) {
      this.M = Math.floor(Math.random() * this.prioritize.length);
      var a = this.prioritize[this.M];
      this.number += a
    }
    if (this.number < this.min || this.number > this.max) {
      this.number = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    }
    this.innerHTML = parseInt(this.number);
  }
}

customElements.define('number-random', numberRandom);

// --------------------------
// Total sold flash
// --------------------------
class flashSold extends VariantChangeBase {
  constructor() {
    super();
    var self = this;
    this.time = this.getAttribute("time");
    this.config = JSON.parse(this.getAttribute("flash-sold"));
    this.mins = this.config.mins;
    this.maxs = this.config.maxs;
    this.mint = this.config.mint;
    this.maxt = this.config.maxt;
    this.dataID = this.config.id;
    this.getS = sessionStorage.getItem("soldS" + this.dataID) || this.getRandomInt(this.mins, this.maxs);
    this.getT = sessionStorage.getItem("soldT" + this.dataID) || this.getRandomInt(this.mint, this.maxt);
    this.numS = parseInt(this.getS);
    this.numT = parseInt(this.getT);
    this.intervalTime = parseInt(this.config.time);
    this.$sold = this.querySelector('[data-sold]');
    this.$hour = this.querySelector('[data-hour]');
    this.limitMinMax();
    this.updateSold(this.numS, this.numT);
    setInterval(function () {
      this.numS = this.numS + self.getRandomInt(1, 4);
      this.numT = this.numT + (Math.random() * (0.8 - 0.1) + 0.1).toFixed(1) * 1;
      self.limitMinMax();
      self.updateSold(self.numS, self.numT);
    }, this.intervalTime);
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  updateSold(num1, num2) {
    this.$sold.innerHTML = num1;
    this.$hour.innerHTML = Math.floor(this.numT);
    sessionStorage.setItem("soldS" + this.dataID, num1);
    sessionStorage.setItem("soldT" + this.dataID, num2);
  }
  limitMinMax() {
    if (this.numS > this.maxs) this.numS = self.getRandomInt(this.mins, this.maxs)
    if (this.numT > this.maxt) this.numT = self.getRandomInt(this.mins, this.maxt)
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.closest(".hdt-product-info__item").style.display = "block"
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('flash-sold', flashSold);

// ======================================
//    pages/brands -  filter isotope 
// ======================================
class filterIsotope extends HTMLElement{
  constructor(){
    super();
    this.btns = this.querySelectorAll('button');
    this.id = this.id;
    if(!this.btns){
      return;
    }
    this.handleButtonClick();
  }
  handleButtonClick(){
    this.btns.forEach(btn =>{
      btn.addEventListener('click',()=>{
        this.querySelector('button.active').classList.remove('active');
        btn.classList.add('active');

        let selectedFilter = btn.getAttribute('data-filter');
        let itemsToHide = $$4(`#${this.id} .hdt-brand-item:not(${selectedFilter})`);
        let itemsToShow = $$4(`#${this.id} ${selectedFilter}`);

        if (selectedFilter == '._filter-show-all') {
          itemsToHide = [];
          itemsToShow = $$4(`#${this.id} .hdt-brand-item`);
        }

        itemsToShow.forEach(el => {
          el.classList.remove('animate-filter-hide','hdt-hidden');
          el.classList.add('animate-filter-show'); 
        });
        
        itemsToHide.forEach(el => {
          el.classList.add('animate-filter-hide','hdt-hidden');
          el.classList.remove('animate-filter-show');
        });
      })
    })
  }
}
customElements.define('hdt-brands',filterIsotope);

// ======================================
//   countryFilter 
// ======================================
class countryFilter extends HTMLElement {
  constructor() {
    super();
    this.search = $4('[name=country_filter]', this);
    this.reset = $4(".hdt-country_filter__reset", this);
    if (this.search) {
      this.search.addEventListener(
        'input',
        debounce((event) => {
          this.filterCountries();
        }, 200).bind(this)
      );
    }
    this.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));

  }
  filterCountries(){
    const searchValue = this.search.value.toLowerCase();
    const allCountries = this.closest("hdt-popover").querySelectorAll('hdt-richlist button');
    let visibleCountries = allCountries.length;
    allCountries.forEach((item) => {
      const countryName = item.getAttribute('data-name').toLowerCase();
      if (countryName.indexOf(searchValue) > -1) {
        item.classList.remove('hdt-d-none');
        visibleCountries++;
      } else {
        item.classList.add('hdt-d-none');
        visibleCountries--;
      }
    });
    if (window.innerWidth >768) this.closest("hdt-popover").updatePos();
    this.closest("hdt-popover").querySelector('.hdt-current-scrollbar').scrollTop = 0;
  }

  onSearchKeyDown(event) {
    if (event.code.toUpperCase() === 'ENTER') {
      event.preventDefault();
    }
  }
}

customElements.define('country-filter', countryFilter);



// --------------------------
// Product Recommendations
// --------------------------
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsObserver = null;
    this.recommendationsAbortController = null;
    this.recommendationsIdleId = null;
    this.recommendationsRetryId = null;
    this.handleEagerOpen = null;
    this.handleCartIntent = null;
    this.handleCartRefresh = null;
    this.handleWindowLoad = null;
  }

  connectedCallback() {
    if (!this.dataset.url || this.dataset.loaded === 'true' || this.dataset.loading === 'true') return;

    if (this.hasAttribute('data-eager')) {
      this.handleEagerOpen = (event) => {
        const openedDialog = event.target;
        if (openedDialog?.id !== 'CartDrawer' && !openedDialog?.closest?.('#CartDrawer')) return;
        this.loadRecommendations();
      };
      document.addEventListener('dialog:open', this.handleEagerOpen);

      this.handleCartIntent = (event) => {
        const trigger = event.target?.closest?.('[aria-controls="CartDrawer"], [data-open-cart], a[href$="/cart"]');
        if (!trigger) return;
        this.loadRecommendations();
      };
      document.addEventListener('pointerdown', this.handleCartIntent, true);
      document.addEventListener('pointerover', this.handleCartIntent, true);
      document.addEventListener('focusin', this.handleCartIntent, true);

      this.handleCartRefresh = () => {
        if (this.dataset.loaded === 'true') return;
        this.dataset.retryCount = '0';
        this.loadRecommendations();
      };
      document.addEventListener('cart:update', this.handleCartRefresh);
      document.addEventListener('cart:reload', this.handleCartRefresh);
      document.addEventListener('cart:drawer:render', this.handleCartRefresh);
      document.addEventListener('cart:main:render', this.handleCartRefresh);

      const drawer = this.closest('#CartDrawer');
      if (drawer?.hasAttribute('open')) {
        queueMicrotask(() => this.loadRecommendations());
      }

      const queueBackgroundPreload = () => {
        this.handleWindowLoad = null;
        if (!this.isConnected || this.dataset.loaded === 'true') return;
        const runPreload = () => {
          this.recommendationsIdleId = null;
          this.loadRecommendations();
        };
        if ('requestIdleCallback' in window) {
          this.recommendationsIdleId = window.requestIdleCallback(runPreload, { timeout: 5000 });
        } else {
          this.recommendationsIdleId = window.setTimeout(runPreload, 2500);
        }
      };

      if (document.readyState === 'complete') {
        queueBackgroundPreload();
      } else {
        this.handleWindowLoad = queueBackgroundPreload;
        window.addEventListener('load', this.handleWindowLoad, { once: true });
      }
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadRecommendations();
    };

    this.recommendationsObserver = new IntersectionObserver(
      handleIntersection.bind(this),
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.recommendationsObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.recommendationsObserver) {
      this.recommendationsObserver.disconnect();
      this.recommendationsObserver = null;
    }
    if (this.recommendationsAbortController) {
      this.recommendationsAbortController.abort();
      this.recommendationsAbortController = null;
    }
    if (this.recommendationsIdleId !== null) {
      if ('cancelIdleCallback' in window) window.cancelIdleCallback(this.recommendationsIdleId);
      else window.clearTimeout(this.recommendationsIdleId);
      this.recommendationsIdleId = null;
    }
    if (this.recommendationsRetryId !== null) {
      window.clearTimeout(this.recommendationsRetryId);
      this.recommendationsRetryId = null;
    }
    if (this.handleEagerOpen) {
      document.removeEventListener('dialog:open', this.handleEagerOpen);
      this.handleEagerOpen = null;
    }
    if (this.handleCartIntent) {
      document.removeEventListener('pointerdown', this.handleCartIntent, true);
      document.removeEventListener('pointerover', this.handleCartIntent, true);
      document.removeEventListener('focusin', this.handleCartIntent, true);
      this.handleCartIntent = null;
    }
    if (this.handleCartRefresh) {
      document.removeEventListener('cart:update', this.handleCartRefresh);
      document.removeEventListener('cart:reload', this.handleCartRefresh);
      document.removeEventListener('cart:drawer:render', this.handleCartRefresh);
      document.removeEventListener('cart:main:render', this.handleCartRefresh);
      this.handleCartRefresh = null;
    }
    if (this.handleWindowLoad) {
      window.removeEventListener('load', this.handleWindowLoad);
      this.handleWindowLoad = null;
    }
    if (this.recommendationsRetryId !== null) {
      window.clearTimeout(this.recommendationsRetryId);
      this.recommendationsRetryId = null;
    }
    delete this.dataset.loading;
    this.removeAttribute('aria-busy');
  }

  async loadRecommendations() {
    if (!this.dataset.url || this.dataset.loading === 'true' || this.dataset.loaded === 'true') return;

    if (this.recommendationsIdleId !== null) {
      if ('cancelIdleCallback' in window) window.cancelIdleCallback(this.recommendationsIdleId);
      else window.clearTimeout(this.recommendationsIdleId);
      this.recommendationsIdleId = null;
    }
    if (this.handleEagerOpen) {
      document.removeEventListener('dialog:open', this.handleEagerOpen);
      this.handleEagerOpen = null;
    }
    if (this.handleWindowLoad) {
      window.removeEventListener('load', this.handleWindowLoad);
      this.handleWindowLoad = null;
    }

    this.dataset.loading = 'true';
    this.setAttribute('aria-busy', 'true');
    if (this.hasAttribute('data-eager')) {
      this.closest('[data-bt-cart-recommendations]')?.removeAttribute('hidden');
    }
    const abortController = new AbortController();
    this.recommendationsAbortController = abortController;

    let requestTimedOut = false;
    const requestTimeout = window.setTimeout(() => {
      requestTimedOut = true;
      abortController.abort();
    }, 8000);

    try {
      const response = await fetch(this.dataset.url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
        signal: abortController.signal
      });
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);

      const text = await response.text();
      if (!this.isConnected || abortController.signal.aborted) return;

      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('product-recommendations');
      const hasDrawerItems = !this.hasAttribute('data-eager') ||
        recommendations?.querySelector('.hdt-minicart-recommendations__item');
      const hasContent = recommendations && recommendations.innerHTML.trim().length && hasDrawerItems;

      if (hasContent) {
        this.innerHTML = recommendations.innerHTML;
        this.dataset.loaded = 'true';
        this.dataset.retryCount = '0';
        this.closest('[data-bt-cart-recommendations]')?.removeAttribute('hidden');
        this.dispatchEvent(new CustomEvent('products:update', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('currency:update'));
      } else if (this.hasAttribute('data-eager')) {
        this.dataset.loaded = 'true';
        this.closest('[data-bt-cart-recommendations]')?.setAttribute('hidden', '');
      }
    } catch (error) {
      const mayRetry = this.isConnected && (requestTimedOut || error.name !== 'AbortError');
      const retryCount = Number(this.dataset.retryCount || 0);
      if (mayRetry && retryCount < 1) {
        this.dataset.retryCount = String(retryCount + 1);
        this.recommendationsRetryId = window.setTimeout(() => {
          this.recommendationsRetryId = null;
          this.loadRecommendations();
        }, 320);
      } else if (error.name !== 'AbortError' || requestTimedOut) {
        console.error(error);
        if (this.hasAttribute('data-eager')) {
          this.closest('[data-bt-cart-recommendations]')?.setAttribute('hidden', '');
        }
      }
    } finally {
      window.clearTimeout(requestTimeout);
      if (this.recommendationsAbortController === abortController) {
        delete this.dataset.loading;
        this.removeAttribute('aria-busy');
        this.recommendationsAbortController = null;
      }
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// --------------------------
// Product Recently
// --------------------------
class ProductRecently extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      let handleProducts = localStorage.getItem("theme4:recently:id");
      let prdId = this.dataset.id;
      if (handleProducts !== null) {
        let products = handleProducts.split(',');
        if(prdId == products[0] && products.length == 1){
          this.closest('.section').style.display = 'none';
          return;
        }
        let url = this.dataset.url.replace('q=', 'q=id:' + products.join("%20OR%20id:"));
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text.replace('hdt-slider-wait', 'hdt-slider');
            const recently = html.querySelector('product-recently');

            if (recently && recently.innerHTML.trim().length) {
              this.innerHTML = recently.innerHTML;
              // html.innerHTML = text.replace('hdt-slider-wait', 'hdt-slider');
            }
            document.dispatchEvent(new CustomEvent("currency:update"));
          })
          .catch((e) => {
            console.error(e);
          });

      }
      let arrayProducts = handleProducts !== null ? handleProducts.split(',') : new Array;
      if (!arrayProducts.includes(prdId + '')) {
        if (arrayProducts.length >= 10) {
          arrayProducts.pop();
        }
        function prepend(value, array) {
          var newArray = array.slice();
          newArray.unshift(value);
          return newArray;
        }
        arrayProducts = prepend(prdId, arrayProducts);
        arrayProducts = arrayProducts.toString();
        localStorage.setItem("theme4:recently:id", arrayProducts);
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recently', ProductRecently);


// --------------------------
// Product Ask Question
// --------------------------

const modalAsk = document.getElementById('modal-contactFormAsk');
modalAsk.addEventListener('dialog:opening', function(event) {
  let askBtn = modalAsk.closest('hdt-modal').dialog.btnOpening;
  let product = askBtn.getAttribute('data-product');
  let product_info = askBtn.parentElement.querySelector('.hdt-pr-popup__ask-product');
  if (product_info) {
    const modalHeader = modalAsk.querySelector('.hdt-dialog-modal__header');
    if (modalHeader && product_info) {
      const oldProductInfo = modalHeader.querySelector('.hdt-pr-popup__ask-product');
      if (oldProductInfo) {
        oldProductInfo.remove();
      }
      modalHeader.prepend(product_info.cloneNode(true));
    }
  }
  let productAsk = modalAsk.querySelector('[name="contact[product]"]');
  if (productAsk) {
    let currentValue = productAsk.value || '';
    let newValue = product || '';
    
    if (currentValue !== newValue) {
      let formMessage = modalAsk.querySelector('.hdt-form-message');
      if (formMessage) {
        formMessage.remove();
      }
    }
    if (currentValue !== newValue || currentValue === '') {
      productAsk.value = newValue;
    }
  }
})

// --------------------------
// Predictive Search
// --------------------------
let btSearchVendorsCache;

function btNormalizeSearchText(value) {
  return String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f\u064B-\u065F\u0670]/g, '')
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ي')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي')
    .toLocaleLowerCase()
    .replace(/[\s._'’"()\-–—/&+]+/g, '');
}

function btGetSearchVendors() {
  if (btSearchVendorsCache) return btSearchVendorsCache;

  const source = document.querySelector('[data-bt-search-vendors]');
  try {
    const vendors = JSON.parse(source?.textContent || '[]');
    btSearchVendorsCache = Array.isArray(vendors)
      ? vendors.filter((vendor) => typeof vendor === 'string' && vendor.trim())
      : [];
  } catch (error) {
    btSearchVendorsCache = [];
  }

  return btSearchVendorsCache;
}

function btFindMatchingVendors(term) {
  const normalizedTerm = btNormalizeSearchText(term);
  if (!normalizedTerm) return [];

  return btGetSearchVendors()
    .map((name) => ({ name, normalized: btNormalizeSearchText(name) }))
    .filter((vendor) => vendor.normalized.includes(normalizedTerm))
    .sort((first, second) => {
      const firstStarts = first.normalized.startsWith(normalizedTerm);
      const secondStarts = second.normalized.startsWith(normalizedTerm);
      if (firstStarts !== secondStarts) return firstStarts ? -1 : 1;
      return first.name.localeCompare(second.name, undefined, { sensitivity: 'base' });
    })
    .slice(0, 20)
    .map((vendor) => vendor.name);
}

function btEscapeSearchValue(value) {
  return `"${String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
}

function btBuildProductSearchQuery(variants) {
  const parts = [];

  variants.forEach((variant) => {
    const value = /\s/.test(variant) ? btEscapeSearchValue(variant) : variant;
    parts.push(
      `title:${value}`,
      `body:${value}`,
      `tag:${value}`,
      `product_type:${value}`,
      `vendor:${value}`,
      value
    );
  });

  return Array.from(new Set(parts)).join(' OR ');
}

class PredictiveSearch extends DrawerComponent {
  constructor() {
    super();
    // console.log(!this.hasAttribute('enabled'))
    if (!this.hasAttribute('enabled')) return;
    // this.action = themeHDN.routes.predictive_search_url;
    // if (!this.hasAttribute('enabled')) {
    //   this.action = themeHDN.routes.search_url;
    // };
    this.cachedResults = {};
    this.predictiveSearchResults = $4('[data-results-search]', this);
    this.select = $4('[data-cat-search]>select', this);
    this.input = $4('input[type="search"]', this);
    this.sectionIdResults = this.getAttribute('data-section-id-results') || 'hdt_predictive-search';
    this.allPredictiveSearchInstances = $$4('hdt-predictive-search');
    this.skeleton = $4('[data-skeleton-search]', this);
    this.noResults = $4('.hdt-cart-no-results', this);
    this.hideWrapper = $4('.hdt-cart-hide-has-results', this);
    this.showWrapper = $4('.hdt-cart-show-has-results', this);
    this.btn_viewall = $4('.hdt-view_all', this);
    this.href = this.btn_viewall?.getAttribute("href");
    this.btn_viewall_replace_text = $4('[data-replace-text]',this);
    this.isOpen = false;
    this.abortController2 = new AbortController();
    this.searchTerm = '';

    if (this.input) {
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
    if (this.select) {
      this.select.addEventListener(
        'change',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    const formData = new FormData(this.input.form);
    this.params = "";
    for (const [key, value] of formData) {
      if (key === 'q') break;
      this.params += `${key}=${value}&`;
    }

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    //this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    var currentValue = this.input.value.trim();
    if (this.select) {
      this.selectVal = this.select.value || '*';
      var valSelected = this.selectVal.trim();
      //console.log(valSelected)
      if (valSelected != '*') {
        if(currentValue !== '') {
          currentValue = `product_type:${valSelected} AND ${currentValue}`;
        } else {
          currentValue = `product_type:${valSelected}`;
        }
      }
    }

    return currentValue;
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    // console.log(newSearchTerm)
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      // this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;
    this.btn_viewall?.setAttribute("href", this.href.replace(/\/search\?q=.*/g, "/search?q=" + this.searchTerm));
    this.btn_viewall_replace_text ? this.btn_viewall_replace_text.innerText = themeHDN.extras.search.view_all + ` ${this.searchTerm}` : null;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    const currentQuery = this.getQuery();
    if (!currentQuery.length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
      return;
    }

    const matchingVendors = btFindMatchingVendors(this.input.value.trim());
    if (!matchingVendors.length) return;

    event.preventDefault();
    const resolvedTerm = matchingVendors
      .map((vendor) => `vendor:${btEscapeSearchValue(vendor)}`)
      .join(' OR ');
    const searchUrl = new URL(this.input.form.action, window.location.origin);
    searchUrl.searchParams.set('q', resolvedTerm);
    searchUrl.searchParams.set('type', 'product');
    searchUrl.searchParams.set('options[prefix]', 'last');
    searchUrl.searchParams.set(
      'options[unavailable_products]',
      this.input.form.querySelector('[name="options[unavailable_products]"]')?.value || 'last'
    );
    window.location.assign(searchUrl.pathname + searchUrl.search);
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;
    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.openSearch();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    // switch (event.code) {
    //   case 'ArrowUp':
    //     this.switchOption('up');
    //     break;
    //   case 'ArrowDown':
    //     this.switchOption('down');
    //     break;
    //   case 'Enter':
    //     this.selectOption();
    //     break;
    // }
  }

  // onKeydown(event) {
  //   // Prevent the cursor from moving in the input when using the up and down arrow keys
  //   if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
  //     event.preventDefault();
  //   }
  // }
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText && previousTerm) {
      const escapedPreviousTerm = previousTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const matches = currentButtonText.match(new RegExp(escapedPreviousTerm, 'g')) || [];
      if (matches.length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

getSearchResults(searchTerm) {
  const rawTerm = searchTerm.trim();
  if (!rawTerm) {
    this.close(true);
    return;
  }

  const normalizedArabicTerm = rawTerm
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ي')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي');
  const variants = Array.from(new Set([rawTerm, normalizedArabicTerm].filter(Boolean)));
  const matchingVendors = btFindMatchingVendors(rawTerm);
  const queryKey = `${variants.join('-')}|${matchingVendors.join('-')}`
    .replace(/\s+/g, '-')
    .toLowerCase();

  if (this.abortController2) this.abortController2.abort();
  this.abortController2 = new AbortController();
  const activeController = this.abortController2;

  this.setLiveRegionLoadingState();

  if (this.cachedResults[queryKey]) {
    this.activeResolvedSearchTerm = this.cachedResults[queryKey].resolvedTerm || rawTerm;
    this.activeVendorSearch = Boolean(this.cachedResults[queryKey].vendorSearch);
    this.renderSearchResults(this.cachedResults[queryKey].markup || this.cachedResults[queryKey]);
    return;
  }

  const sectionId = this.sectionIdResults;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const locale = (
    (window.Shopify && Shopify.locale) ||
    document.documentElement.lang ||
    'en'
  ).toLowerCase();
  const unavailableProducts = this.input.form.querySelector(
    '[name="resources[options][unavailable_products]"]'
  )?.value || 'last';

  const requestParams = new URLSearchParams();
  const fallbackParams = new URLSearchParams();
  let resolvedTerm = rawTerm;
  let primaryUrl;
  let fallbackUrl;

  if (matchingVendors.length) {
    const vendorQueries = matchingVendors.map(
      (vendor) => `vendor:${btEscapeSearchValue(vendor)}`
    );

    resolvedTerm = vendorQueries.join(' OR ');
    requestParams.set('q', resolvedTerm);
    requestParams.set('type', 'product');
    requestParams.set('options[prefix]', 'last');
    requestParams.set('options[unavailable_products]', unavailableProducts);
    requestParams.set('locale', locale);
    requestParams.set('section_id', sectionId);

    fallbackParams.set('q', resolvedTerm);
    fallbackParams.set('type', 'product');
    fallbackParams.set('options[prefix]', 'last');
    fallbackParams.set('options[unavailable_products]', unavailableProducts);
    fallbackParams.set('locale', locale);
    fallbackParams.set('sections', sectionId);

    primaryUrl = `${root}search?${requestParams.toString()}`;
    fallbackUrl = `${root}search?${fallbackParams.toString()}`;
  } else if (locale.startsWith('ar')) {
    resolvedTerm = btBuildProductSearchQuery(variants);
    requestParams.set('q', resolvedTerm);
    requestParams.set('type', 'product');
    requestParams.set('options[prefix]', 'last');
    requestParams.set('options[unavailable_products]', unavailableProducts);
    requestParams.set('locale', locale);
    requestParams.set('section_id', sectionId);

    fallbackParams.set('q', resolvedTerm);
    fallbackParams.set('type', 'product');
    fallbackParams.set('options[prefix]', 'last');
    fallbackParams.set('options[unavailable_products]', unavailableProducts);
    fallbackParams.set('locale', locale);
    fallbackParams.set('sections', sectionId);

    primaryUrl = `${root}search?${requestParams.toString()}`;
    fallbackUrl = `${root}search?${fallbackParams.toString()}`;
  } else {
    requestParams.set('q', rawTerm);
    requestParams.set('resources[type]', 'product,query,article,collection,page');
    requestParams.set('resources[limit]', '10');
    requestParams.set('resources[limit_scope]', 'each');
    requestParams.set(
      'resources[options][fields]',
      'title,body,tag,product_type,variants.title,vendor,variants.sku,variants.barcode'
    );
    requestParams.set('resources[options][prefix]', 'last');
    requestParams.set('resources[options][unavailable_products]', unavailableProducts);
    requestParams.set('section_id', sectionId);

    fallbackParams.set('q', btBuildProductSearchQuery(variants));
    fallbackParams.set('type', 'product');
    fallbackParams.set('options[prefix]', 'last');
    fallbackParams.set('options[unavailable_products]', unavailableProducts);
    fallbackParams.set('locale', locale);
    fallbackParams.set('sections', sectionId);

    primaryUrl = `${root}search/suggest?${requestParams.toString()}`;
    fallbackUrl = `${root}search?${fallbackParams.toString()}`;
  }

  this.activeResolvedSearchTerm = resolvedTerm;
  this.activeVendorSearch = matchingVendors.length > 0;

  if (this.btn_viewall && this.href) {
    try {
      const viewAllUrl = new URL(this.href, window.location.origin);
      viewAllUrl.searchParams.set('q', resolvedTerm);
      viewAllUrl.searchParams.set('type', 'product');
      this.btn_viewall.setAttribute('href', viewAllUrl.pathname + viewAllUrl.search);
    } catch (error) {
      // Keep the theme's original link if its URL cannot be parsed.
    }
  }

  const fetchOptions = {
    signal: activeController.signal,
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  };

  const extractSectionHTML = (responseText) => {
    try {
      const parsed = JSON.parse(responseText);
      return parsed[sectionId] || Object.values(parsed)[0] || responseText;
    } catch (error) {
      return responseText;
    }
  };

  const renderHTML = (responseText) => {
    if (activeController.signal.aborted || activeController !== this.abortController2) return;

    const html = extractSectionHTML(responseText);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const wrap = doc.querySelector(`#shopify-section-${sectionId}`);
    const scope = wrap || doc.body;
    const productsBlock = scope.querySelector('.hdt-search-products');

    if (productsBlock) {
      const resultParent = productsBlock.parentElement;
      const earlierContent = resultParent?.querySelector(
        ':scope > .hdt-search-queries, :scope > .ps-acc-scope, :scope > .hdt-search-articles, :scope > .hdt-search-collections, :scope > .hdt-search-pages'
      );
      if (earlierContent && earlierContent !== productsBlock) {
        resultParent.insertBefore(productsBlock, earlierContent);
      }
    }

    let resultsMarkup = wrap ? wrap.innerHTML : scope.innerHTML;
    if (!resultsMarkup.trim()) resultsMarkup = html;

    const cacheEntry = {
      markup: resultsMarkup,
      resolvedTerm,
      vendorSearch: matchingVendors.length > 0
    };

    this.allPredictiveSearchInstances.forEach((instance) => {
      instance.cachedResults[queryKey] = cacheEntry;
    });
    this.cachedResults[queryKey] = cacheEntry;
    this.renderSearchResults(resultsMarkup);
  };

  const fetchText = (url) => fetch(url, fetchOptions).then((response) => {
    if (!response.ok) throw new Error(String(response.status));
    return response.text();
  });

  fetchText(primaryUrl)
    .catch((error) => {
      if (activeController.signal.aborted) throw error;
      return fetchText(fallbackUrl);
    })
    .then(renderHTML)
    .catch((error) => {
      if (error?.name !== 'AbortError' && !activeController.signal.aborted) this.close();
    });
}




  setLiveRegionLoadingState() {
    this.hideWrapper.style.cssText = "display: none;";
    this.showWrapper.style.cssText = "display: block;";
    this.skeleton.classList.remove("hdt-hidden");

    this.setAttribute('loading', true);
  }

renderSearchResults(resultsMarkup) {
  this.predictiveSearchResults.innerHTML = resultsMarkup;
  this.setAttribute('results', true);

  // 👇 تنظيف رابط "عرض المزيد" أو أي رابط يفتح صفحة /search
  const term = (this.input && this.input.value || '').trim();
  const resolvedTerm = this.activeResolvedSearchTerm || term;
  if (term) {
    const links = this.predictiveSearchResults.querySelectorAll('a[href*="/search"]');
    links.forEach(link => {
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('q', resolvedTerm);
        url.searchParams.set('type', 'product');

        link.href = url.pathname + url.search;
      } catch (e) {
        // لو صار خطأ في URL (نادر) نتجاهله
      }
    });
  }

  this.setLiveRegionResults();
  this.openSearch();
  document.dispatchEvent(new CustomEvent("currency:update"));
}


  setLiveRegionResults() {
    this.removeAttribute('loading');
  }

  openSearch() {
    //this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.skeleton.classList.add("hdt-hidden");
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.hideWrapper.style.cssText = "display: block;";
      this.showWrapper.style.cssText = "display: none;";
      this.predictiveSearchResults.innerHTML = "";
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    //this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('hdt-predictive-search', PredictiveSearch);

/* Beauty Time visual search
 * - Image search reuses the app service, then feeds the matched title back into
 *   the existing predictive search so product cards stay consistent.
 * - Barcode scanning is lazy-loaded only after the shopper opens the scanner. */
(() => {
  const configNode = document.getElementById('bt-visual-search-config');
  if (!configNode) return;

  let config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (_) {
    return;
  }

  const strings = config.strings || {};
  const state = {
    modal: null,
    activeInput: null,
    returnFocus: null,
    mode: '',
    imageController: null,
    imageSearchId: 0,
    stageTimers: [],
    scanner: null,
    scannerStarting: false,
    scannerAttempt: 0,
    barcodeFileAttempt: 0,
    scannerLocked: false,
    scannerPromise: null,
    ocrPromise: null,
    ocrWorker: null,
    ocrWorkerPromise: null,
    ocrGeneration: 0,
    ocrProgressCallback: null,
    lottiePromise: null,
    clockAnimation: null,
    dragStartY: null,
    dragOffset: 0
  };

  const imageIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.25" y="4.25" width="17.5" height="15.5" rx="3" stroke="currentColor" stroke-width="1.6"/>
      <circle cx="9" cy="9.2" r="1.55" stroke="currentColor" stroke-width="1.5"/>
      <path d="m5.7 17 4-4 2.8 2.55 2.2-2.2 3.6 3.65" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.3 2.15v3.1M16.75 3.7h3.1" stroke="currentColor" stroke-width="1.45" stroke-linecap="round"/>
    </svg>`;
  const barcodeIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 8V5.8A1.8 1.8 0 0 1 5.8 4H8M16 4h2.2A1.8 1.8 0 0 1 20 5.8V8M20 16v2.2a1.8 1.8 0 0 1-1.8 1.8H16M8 20H5.8A1.8 1.8 0 0 1 4 18.2V16" stroke="currentColor" stroke-width="1.65" stroke-linecap="round"/>
      <path d="M7.25 8.2v7.6M9.5 8.2v7.6M12.4 8.2v7.6M14.15 8.2v7.6M16.75 8.2v7.6" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/>
    </svg>`;
  const cameraIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M8.4 5.5 9.7 3.8h4.6l1.3 1.7h2.9A2.5 2.5 0 0 1 21 8v8.5a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 16.5V8a2.5 2.5 0 0 1 2.5-2.5h2.9Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
      <circle cx="12" cy="12.2" r="3.25" stroke="currentColor" stroke-width="1.6"/>
    </svg>`;
  const galleryIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="4" stroke="currentColor" stroke-width="1.6"/>
      <circle cx="9" cy="8.5" r="1.6" stroke="currentColor" stroke-width="1.5"/>
      <path d="m5.5 18 4.2-4.4 3.15 2.9 2.15-2.2 3.5 3.7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  const uploadIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 15V4m0 0L8.5 7.5M12 4l3.5 3.5M5 14.5v3.2A2.3 2.3 0 0 0 7.3 20h9.4a2.3 2.3 0 0 0 2.3-2.3v-3.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  const closeIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`;
  const arrowIcon = `
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true"><path d="m7.5 4.5 5.5 5.5-5.5 5.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const tipIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3.5a6.5 6.5 0 0 0-3.65 11.88c.7.48 1.15 1.22 1.15 2.07V18h5v-.55c0-.85.45-1.59 1.15-2.07A6.5 6.5 0 0 0 12 3.5Z" stroke="currentColor" stroke-width="1.55"/><path d="M10 21h4" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/></svg>`;
  const clockFallback = `
    <span class="bt-visual-search__clock-fallback" aria-hidden="true">
      <svg viewBox="0 0 64 64" fill="none"><circle cx="32" cy="32" r="26" fill="#fff3ed" stroke="currentColor" stroke-width="2.5"/><path d="M32 17v16l10 6" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><circle cx="32" cy="32" r="3" fill="#f0b79e"/></svg>
    </span>`;

  const escapeHTML = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const ensureSearchFields = (form) => {
    if (!form) return;
    let field = form.querySelector('input[name="resources[options][fields]"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'resources[options][fields]';
      field.value = 'title,body,tag,product_type,variants.title,vendor,variants.sku,variants.barcode';
      form.prepend(field);
      return;
    }
    const values = String(field.value || '').split(',').map((value) => value.trim()).filter(Boolean);
    ['variants.sku', 'variants.barcode'].forEach((value) => {
      if (!values.includes(value)) values.push(value);
    });
    field.value = values.join(',');
  };

  const injectSearchTools = (root = document) => {
    const inputs = [];
    if (root.matches?.('[data-input-search]')) inputs.push(root);
    root.querySelectorAll?.('[data-input-search]').forEach((input) => inputs.push(input));

    inputs.forEach((input) => {
      const form = input.form;
      const inner = input.closest('.hdt-search-inner, .hdt-search_inner');
      if (!form || !inner || inner.querySelector('.bt-search-tools')) return;

      ensureSearchFields(form);
      const group = document.createElement('span');
      group.className = 'bt-search-tools';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', `${strings.imageLabel || 'Image search'}, ${strings.barcodeLabel || 'Barcode search'}`);
      group.innerHTML = `
        <button type="button" class="bt-search-tool bt-search-tool--image" data-bt-visual-search="image" aria-label="${escapeHTML(strings.imageLabel || 'Search by image')}" title="${escapeHTML(strings.imageLabel || 'Search by image')}">${imageIcon}</button>
        <button type="button" class="bt-search-tool bt-search-tool--barcode" data-bt-visual-search="barcode" aria-label="${escapeHTML(strings.barcodeLabel || 'Search by barcode')}" title="${escapeHTML(strings.barcodeLabel || 'Search by barcode')}">${barcodeIcon}</button>`;

      const submit = inner.querySelector('button[type="submit"], [data-submit-search]');
      inner.insertBefore(group, submit || null);
    });
  };

  const createModal = () => {
    if (state.modal) return state.modal;
    const modal = document.createElement('dialog');
    modal.className = 'bt-visual-search';
    modal.hidden = true;
    modal.dataset.btVisualSearchModal = '';
    modal.setAttribute('aria-labelledby', 'bt-visual-search-title');
    modal.innerHTML = `
      <button type="button" class="bt-visual-search__backdrop" data-bt-vs-close tabindex="-1" aria-label="${escapeHTML(strings.close || 'Close')}"></button>
      <section class="bt-visual-search__sheet" tabindex="-1">
        <span class="bt-visual-search__handle" data-bt-vs-handle aria-hidden="true"></span>
        <header class="bt-visual-search__header">
          <div class="bt-visual-search__title-wrap">
            <span class="bt-visual-search__title-icon" data-bt-vs-title-icon>${imageIcon}</span>
            <h2 class="bt-visual-search__title" id="bt-visual-search-title" data-bt-vs-title></h2>
          </div>
          <button type="button" class="bt-visual-search__close" data-bt-vs-close aria-label="${escapeHTML(strings.close || 'Close')}">${closeIcon}</button>
        </header>
        <div class="bt-visual-search__body">
          <div class="bt-visual-search__notice" data-bt-vs-notice role="alert" hidden></div>
          <div class="bt-visual-search__status" data-bt-vs-status role="status" aria-live="polite" hidden>
            <span class="bt-visual-search__clock" data-bt-vs-clock>${clockFallback}</span>
            <strong data-bt-vs-status-text></strong>
            <small data-bt-vs-status-detail></small>
          </div>

          <div class="bt-visual-search__panel" data-bt-vs-panel="image" hidden>
            <p class="bt-visual-search__description" data-bt-vs-description></p>
            <div class="bt-visual-search__options">
              <button type="button" class="bt-visual-search__option" data-bt-vs-pick="camera">
                <span class="bt-visual-search__option-icon">${cameraIcon}</span>
                <span class="bt-visual-search__option-copy"><strong>${escapeHTML(strings.takePhoto)}</strong><small>${escapeHTML(strings.takePhotoHint)}</small></span>
                <span class="bt-visual-search__option-arrow">${arrowIcon}</span>
              </button>
              <button type="button" class="bt-visual-search__option" data-bt-vs-pick="gallery">
                <span class="bt-visual-search__option-icon">${galleryIcon}</span>
                <span class="bt-visual-search__option-copy"><strong>${escapeHTML(strings.chooseImage)}</strong><small>${escapeHTML(strings.chooseImageHint)}</small></span>
                <span class="bt-visual-search__option-arrow">${arrowIcon}</span>
              </button>
            </div>
            <p class="bt-visual-search__tip">${tipIcon}<span>${escapeHTML(strings.imageTip)}</span></p>
          </div>

          <div class="bt-visual-search__panel" data-bt-vs-panel="barcode" hidden>
            <p class="bt-visual-search__description" data-bt-vs-description></p>
            <div class="bt-visual-search__barcode-stage" data-bt-vs-barcode-stage>
              <div class="bt-visual-search__reader" id="bt-visual-search-reader"></div>
              <span class="bt-visual-search__scan-frame" aria-hidden="true"><span class="bt-visual-search__scan-corners"></span><span class="bt-visual-search__scan-line"></span></span>
            </div>
            <div class="bt-visual-search__barcode-actions">
              <button type="button" class="bt-visual-search__button" data-bt-vs-start-camera>${cameraIcon}<span>${escapeHTML(strings.startCamera)}</span></button>
              <button type="button" class="bt-visual-search__button bt-visual-search__button--secondary" data-bt-vs-pick="barcode-file">${uploadIcon}<span>${escapeHTML(strings.chooseBarcodeImage)}</span></button>
            </div>
            <form class="bt-visual-search__manual" data-bt-vs-manual-form>
              <label for="bt-visual-search-barcode">${escapeHTML(strings.manualLabel)}</label>
              <div class="bt-visual-search__manual-row">
                <input id="bt-visual-search-barcode" class="bt-visual-search__manual-input" data-bt-vs-manual-input type="text" inputmode="numeric" autocomplete="off" maxlength="80" placeholder="${escapeHTML(strings.manualPlaceholder)}">
                <button type="submit" class="bt-visual-search__button bt-visual-search__manual-submit">${escapeHTML(strings.search)}</button>
              </div>
            </form>
          </div>
        </div>
      </section>
      <input class="bt-visual-search__sr-input" data-bt-vs-image-camera type="file" accept="image/*" capture="environment" tabindex="-1">
      <input class="bt-visual-search__sr-input" data-bt-vs-image-file type="file" accept="image/*" tabindex="-1">
      <input class="bt-visual-search__sr-input" data-bt-vs-barcode-camera type="file" accept="image/*" capture="environment" tabindex="-1">
      <input class="bt-visual-search__sr-input" data-bt-vs-barcode-file type="file" accept="image/*" tabindex="-1">`;
    document.body.appendChild(modal);
    state.modal = modal;
    bindModalEvents(modal);
    return modal;
  };

  const modalElement = (selector) => state.modal?.querySelector(selector);

  const clearStageTimers = () => {
    state.stageTimers.forEach((timer) => window.clearTimeout(timer));
    state.stageTimers = [];
  };

  const setNotice = (message = '') => {
    const notice = modalElement('[data-bt-vs-notice]');
    if (!notice) return;
    notice.textContent = message;
    notice.hidden = !message;
  };

  const destroyClock = () => {
    try { state.clockAnimation?.destroy?.(); } catch (_) {}
    state.clockAnimation = null;
    const clock = modalElement('[data-bt-vs-clock]');
    if (clock) {
      clock.dataset.lottieReady = 'false';
      clock.querySelector(':scope > svg')?.remove();
    }
  };

  const runtimeGlobal = (name) => {
    if (name === 'Html5Qrcode' && !window.Html5Qrcode && window.__Html5QrcodeLibrary__?.Html5Qrcode) {
      window.Html5Qrcode = window.__Html5QrcodeLibrary__.Html5Qrcode;
      window.Html5QrcodeSupportedFormats = window.__Html5QrcodeLibrary__.Html5QrcodeSupportedFormats;
    }
    return window[name];
  };

  const waitForGlobal = (name, timeout = 10000) => new Promise((resolve, reject) => {
    const started = Date.now();
    const check = () => {
      const runtime = runtimeGlobal(name);
      if (runtime) return resolve(runtime);
      if (Date.now() - started >= timeout) return reject(new Error(`${name} runtime timeout`));
      window.setTimeout(check, 40);
    };
    check();
  });

  const loadRuntime = (source, globalName, marker) => {
    const existingRuntime = runtimeGlobal(globalName);
    if (existingRuntime) return Promise.resolve(existingRuntime);
    const promiseKey = globalName === 'Html5Qrcode'
      ? 'scannerPromise'
      : (globalName === 'Tesseract' ? 'ocrPromise' : 'lottiePromise');
    if (state[promiseKey]) return state[promiseKey];
    if (!source) return Promise.reject(new Error(`${globalName} source unavailable`));

    state[promiseKey] = new Promise((resolve, reject) => {
      const absoluteSource = new URL(source, window.location.href).href;
      let script = Array.from(document.scripts).find((item) => item.src === absoluteSource || item.hasAttribute(marker));
      const runtimeTimeout = globalName === 'Tesseract' ? 20000 : 10000;
      const finish = () => waitForGlobal(globalName, runtimeTimeout).then(resolve, reject);
      if (!script) {
        script = document.createElement('script');
        script.src = absoluteSource;
        script.defer = true;
        script.setAttribute(marker, '');
        document.head.appendChild(script);
      }
      script.addEventListener('load', finish, { once: true });
      script.addEventListener('error', () => reject(new Error(`${globalName} load failed`)), { once: true });
      waitForGlobal(globalName, runtimeTimeout).then(resolve, reject);
    }).catch((error) => {
      state[promiseKey] = null;
      const failedScript = document.querySelector(`script[${marker}]`);
      if (failedScript && !runtimeGlobal(globalName)) failedScript.remove();
      throw error;
    });
    return state[promiseKey];
  };

  const ensureOcrWorker = () => {
    if (state.ocrWorker) return Promise.resolve(state.ocrWorker);
    if (state.ocrWorkerPromise) return state.ocrWorkerPromise;
    const generation = state.ocrGeneration;
    let pending;
    pending = loadRuntime(config.ocrAsset, 'Tesseract', 'data-bt-image-ocr-runtime')
      .then((tesseract) => tesseract.createWorker('eng', 1, {
        logger: (message) => state.ocrProgressCallback?.(message)
      }))
      .then(async (worker) => {
        try {
          if (generation !== state.ocrGeneration) throw new DOMException('OCR cancelled', 'AbortError');
          await worker.setParameters({
            tessedit_pageseg_mode: '11',
            preserve_interword_spaces: '1',
            user_defined_dpi: '300'
          });
          if (generation !== state.ocrGeneration) throw new DOMException('OCR cancelled', 'AbortError');
          state.ocrWorker = worker;
          return worker;
        } catch (error) {
          try { await worker.terminate(); } catch (_) {}
          throw error;
        }
      })
      .finally(() => {
        if (state.ocrWorkerPromise === pending) state.ocrWorkerPromise = null;
      });
    state.ocrWorkerPromise = pending;
    return pending;
  };

  const terminateOcrWorker = () => {
    state.ocrGeneration += 1;
    const worker = state.ocrWorker;
    state.ocrWorker = null;
    state.ocrWorkerPromise = null;
    if (worker) Promise.resolve(worker.terminate?.()).catch(() => {});
  };

  const mountClock = async () => {
    const clock = modalElement('[data-bt-vs-clock]');
    if (!clock || state.clockAnimation) return;
    try {
      const lottie = await loadRuntime(config.lottieAsset, 'lottie', 'data-bt-visual-search-lottie');
      if (!clock.isConnected || state.clockAnimation) return;
      state.clockAnimation = lottie.loadAnimation({
        container: clock,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: config.clockAsset,
        rendererSettings: { preserveAspectRatio: 'xMidYMid meet', progressiveLoad: true }
      });
      clock.dataset.lottieReady = 'true';
    } catch (_) {
      /* The branded static clock remains visible if Lottie cannot initialize. */
    }
  };

  const showStatus = (message, detail = '') => {
    const status = modalElement('[data-bt-vs-status]');
    if (!status) return;
    modalElement('[data-bt-vs-panel="image"]')?.setAttribute('hidden', '');
    modalElement('[data-bt-vs-panel="barcode"]')?.setAttribute('hidden', '');
    modalElement('[data-bt-vs-status-text]').textContent = message || '';
    const detailNode = modalElement('[data-bt-vs-status-detail]');
    detailNode.textContent = detail || '';
    detailNode.hidden = !detail;
    status.hidden = false;
    mountClock();
  };

  const showActivePanel = () => {
    const status = modalElement('[data-bt-vs-status]');
    if (status) status.hidden = true;
    destroyClock();
    modalElement('[data-bt-vs-panel="image"]')?.toggleAttribute('hidden', state.mode !== 'image');
    modalElement('[data-bt-vs-panel="barcode"]')?.toggleAttribute('hidden', state.mode !== 'barcode');
  };

  const stopScanner = async (unlock = true) => {
    const scanner = state.scanner;
    state.scanner = null;
    if (unlock) state.scannerLocked = false;
    modalElement('[data-bt-vs-barcode-stage]')?.classList.remove('is-scanning');
    if (scanner) {
      try { await scanner.stop(); } catch (_) {}
      try { await scanner.clear(); } catch (_) {}
    }
    const reader = modalElement('#bt-visual-search-reader');
    if (reader) reader.innerHTML = '';
  };

  const closeModal = (restoreFocus = true) => {
    if (!state.modal || state.modal.hidden) return;
    clearStageTimers();
    state.imageSearchId += 1;
    state.barcodeFileAttempt += 1;
    state.imageController?.abort();
    state.imageController = null;
    state.ocrProgressCallback = null;
    terminateOcrWorker();
    stopScanner();
    destroyClock();
    if (state.modal.open && typeof state.modal.close === 'function') {
      try { state.modal.close(); } catch (_) { state.modal.removeAttribute('open'); }
    } else {
      state.modal.removeAttribute('open');
    }
    state.modal.hidden = true;
    state.modal.querySelector('.bt-visual-search__sheet')?.style.removeProperty('--bt-vs-drag-y');
    document.body.classList.remove('bt-visual-search-open');
    setNotice('');
    const focusTarget = state.returnFocus;
    state.mode = '';
    state.activeInput = null;
    state.returnFocus = null;
    if (restoreFocus && focusTarget?.isConnected) focusTarget.focus({ preventScroll: true });
  };

  const applySearchQuery = (query) => {
    const cleanQuery = String(query || '').trim().slice(0, 220);
    const input = state.activeInput;
    if (!cleanQuery) return;

    closeModal(false);
    if (!input?.isConnected) {
      const url = new URL(config.rootUrl || '/', window.location.origin);
      url.pathname = `${url.pathname.replace(/\/$/, '')}/search`;
      url.searchParams.set('q', cleanQuery);
      url.searchParams.set('type', 'product');
      window.location.assign(url.pathname + url.search);
      return;
    }

    input.value = cleanQuery;
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    try { input.focus({ preventScroll: true }); } catch (_) { input.focus(); }

    const predictive = input.closest('hdt-predictive-search');
    const mainSearch = input.closest('#hdt-search-form, .hdt-main-search');
    if (!predictive && !mainSearch && input.form) {
      window.setTimeout(() => input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit(), 80);
    }
  };

  const decodeImage = async (file) => {
    if ('createImageBitmap' in window) {
      try {
        const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
        return { image: bitmap, width: bitmap.width, height: bitmap.height, revoke: () => bitmap.close?.() };
      } catch (_) {}
    }
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();
      image.onload = () => resolve({ image, width: image.naturalWidth, height: image.naturalHeight, revoke: () => URL.revokeObjectURL(url) });
      image.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('image decode failed'));
      };
      image.src = url;
    });
  };

  const prepareImage = async (file) => {
    if (!file || !String(file.type || '').startsWith('image/')) throw new Error('INVALID_IMAGE');
    let decoded;
    try {
      decoded = await decodeImage(file);
      const maxDimension = 1400;
      const scale = Math.min(1, maxDimension / Math.max(decoded.width, decoded.height));
      const width = Math.max(1, Math.round(decoded.width * scale));
      const height = Math.max(1, Math.round(decoded.height * scale));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d', { alpha: false });
      if (!context) throw new Error('CANVAS_UNAVAILABLE');
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, width, height);
      context.drawImage(decoded.image, 0, 0, width, height);
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', .84));
      if (!blob) throw new Error('IMAGE_COMPRESSION_FAILED');
      if (blob.size > 6.8 * 1024 * 1024) throw new Error('IMAGE_TOO_LARGE');
      return new File([blob], 'beauty-time-image-search.jpg', { type: 'image/jpeg', lastModified: Date.now() });
    } catch (error) {
      if (file.size <= 6.8 * 1024 * 1024 && error?.message === 'image decode failed') return file;
      throw error;
    } finally {
      decoded?.revoke?.();
    }
  };

  const cleanImageSearchText = (value, maxWords = 80) => String(value || '')
    .replace(/[^\p{L}\p{N}+\-&'\s]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .filter((word) => word.length > 1 || /\d/.test(word))
    .slice(0, maxWords)
    .join(' ');

  const imageFilenameQuery = (name) => {
    const text = cleanImageSearchText(String(name || '')
      .replace(/\.[^.]+$/, '')
      .replace(/[_-]+/g, ' ')
      .replace(/\b(?:img|image|photo|picture|screenshot|screen shot|camera|download|whatsapp|pxl|dsc)\b/gi, ' ')
      .replace(/\b\d{8,}\b/g, ' '), 10);
    return /\p{L}/u.test(text) ? text : '';
  };

  const scoreImageText = (text, confidence = 0) => {
    const words = String(text || '').split(/\s+/).filter(Boolean);
    const usefulWords = new Set(words.map((word) => word.toLowerCase()));
    let score = (Number(confidence) || 0) / 10 + usefulWords.size;
    if (/\b(?:serum|cream|toner|cleanser|mask|lotion|ampoule|gel|spf|collagen|retinol|panthenol|peptide|repair|glow|hair|skin)\b/i.test(text)) score += 8;
    if (/\b(?:ml|fl|oz)\b/i.test(text)) score += 1;
    return score;
  };

  const IMAGE_SEARCH_NOISE = new Set([
    'the', 'and', 'for', 'with', 'from', 'all', 'new', 'original', 'official',
    'made', 'ingredients', 'directions', 'warning', 'clinically', 'tested',
    'skin', 'hair', 'beauty', 'cream', 'serum', 'lotion', 'gel', 'toner',
    'cleanser', 'shampoo', 'conditioner', 'mask', 'ampoule', 'spf', 'ml', 'fl', 'oz'
  ]);

  const normalizeImageMatchText = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const imageMatchWords = (value) => Array.from(new Set(
    normalizeImageMatchText(value).split(' ').filter((word) => word.length >= 2)
  ));

  const imageWordSimilarity = (source, target) => {
    if (source === target) return 1;
    if (!source || !target || /^\d+$/.test(source) || /^\d+$/.test(target)) return 0;
    if (Math.abs(source.length - target.length) > 2) return 0;
    const previous = Array.from({ length: target.length + 1 }, (_, index) => index);
    for (let row = 1; row <= source.length; row += 1) {
      let diagonal = previous[0];
      previous[0] = row;
      for (let column = 1; column <= target.length; column += 1) {
        const above = previous[column];
        previous[column] = Math.min(
          previous[column] + 1,
          previous[column - 1] + 1,
          diagonal + (source[row - 1] === target[column - 1] ? 0 : 1)
        );
        diagonal = above;
      }
    }
    return 1 - previous[target.length] / Math.max(source.length, target.length);
  };

  const bestImageWordMatch = (word, productWords) => {
    let similarity = 0;
    let exact = false;
    productWords.forEach((productWord) => {
      const isUsefulPrefix = Math.min(word.length, productWord.length) >= 4
        && (productWord.startsWith(word) || word.startsWith(productWord));
      const current = isUsefulPrefix ? .94 : imageWordSimilarity(word, productWord);
      if (current > similarity) similarity = current;
      if (word === productWord) exact = true;
    });
    const threshold = word.length >= 7 ? .72 : (word.length >= 5 ? .80 : .90);
    return { matched: similarity >= threshold, similarity, exact };
  };

  const collectOcrLines = (data = {}) => {
    let sourceLines = Array.isArray(data.lines) ? data.lines : [];
    if (!sourceLines.length && Array.isArray(data.blocks)) {
      sourceLines = data.blocks.flatMap((block) => (block.paragraphs || []).flatMap((paragraph) => paragraph.lines || []));
    }
    const lines = sourceLines.map((line) => {
      const text = cleanImageSearchText(line?.text || (line?.words || []).map((word) => word.text || '').join(' '), 14);
      const box = line?.bbox || line?.boundingBox || {};
      const x0 = Number(box.x0 ?? box.left ?? 0) || 0;
      const y0 = Number(box.y0 ?? box.top ?? 0) || 0;
      const x1 = Number(box.x1 ?? ((box.left || 0) + (box.width || 0))) || x0;
      const y1 = Number(box.y1 ?? ((box.top || 0) + (box.height || 0))) || y0;
      return { text, confidence: Number(line?.confidence) || 0, x0, y0, x1, y1 };
    }).filter((line) => line.text && /\p{L}/u.test(line.text));

    if (lines.length) return lines;
    return String(data.text || '').split(/[\r\n]+/).map((text, index) => ({
      text: cleanImageSearchText(text, 14),
      confidence: Number(data.confidence) || 0,
      x0: 0,
      y0: index * 20,
      x1: 0,
      y1: index * 20 + 16
    })).filter((line) => line.text && /\p{L}/u.test(line.text));
  };

  const buildOcrCandidate = (data, canvas) => {
    const lines = collectOcrLines(data);
    const ranked = lines.map((line) => {
      const normalizedWords = imageMatchWords(line.text);
      const confidence = Math.max(0, Math.min(100, Number(line.confidence) || 0));
      const widthRatio = Math.max(0, line.x1 - line.x0) / Math.max(1, canvas.width);
      const heightRatio = Math.max(0, line.y1 - line.y0) / Math.max(1, canvas.height);
      const words = normalizedWords.length;
      const hasProductTerm = /\b(?:serum|cream|toner|cleanser|mask|lotion|ampoule|gel|spf|collagen|retinol|panthenol|peptide|repair|glow|hair|skin|shampoo|conditioner)\b/i.test(line.text);
      const isMetadata = /\b(?:ingredients|directions|warning|manufactured|distributed|caution|external|batch|expiry|made|www|com)\b/i.test(line.text);
      const isUnitOnly = words <= 3 && /\b\d+(?:\.\d+)?\s*(?:ml|fl|oz|g|kg)\b/i.test(line.text);
      const repeatedNoise = normalizedWords.some((word) => /(.)\1{3,}/u.test(word));
      const centerX = ((line.x0 + line.x1) / 2) / Math.max(1, canvas.width);
      const centerBonus = 8 * (1 - Math.min(1, Math.abs(centerX - .5) * 2));
      const brandLike = words <= 3 && /\p{L}{3,}/u.test(line.text);
      const isSmallPrint = isMetadata || isUnitOnly || words > 9;
      const score = confidence * .38 + Math.min(heightRatio, .12) * 180
        + Math.min(widthRatio, .8) * 14 + Math.min(words, 5) * 2 + centerBonus
        + (hasProductTerm ? 12 : 0) + (brandLike ? 10 : 0)
        - (isSmallPrint ? 22 : 0) - (confidence < 25 ? 12 : 0)
        - (repeatedNoise ? 24 : 0) - Math.max(0, words - 6) * 3;
      return { ...line, confidence, score, isSmallPrint };
    }).sort((first, second) => second.score - first.score);

    const primary = ranked[0];
    const secondary = ranked.find((line) => line !== primary && !line.isSmallPrint
      && line.confidence >= 25
      && Math.abs(((line.y0 + line.y1) - ((primary?.y0 || 0) + (primary?.y1 || 0))) / 2) <= canvas.height * .36
      && normalizeImageMatchText(line.text) !== normalizeImageMatchText(primary?.text));
    const titleLines = [primary, secondary].filter(Boolean).sort((first, second) => first.y0 - second.y0);
    const rawText = cleanImageSearchText(data?.text || lines.map((line) => line.text).join(' '), 40);
    const titleWithSecondaryQuery = cleanImageSearchText(titleLines.map((line) => line.text).join(' '), 10) || cleanImageSearchText(rawText, 10);
    const primaryTitleQuery = cleanImageSearchText(primary?.text || rawText, 6);
    const trustedLines = ranked.filter((line) => !line.isSmallPrint && line.confidence >= 22).slice(0, 5);
    const usefulLines = trustedLines.map((line) => line.text);
    const fullTextQuery = cleanImageSearchText(usefulLines.length ? [titleWithSecondaryQuery, ...usefulLines].join(' ') : rawText, 24);
    const titleConfidence = titleLines.length
      ? titleLines.reduce((sum, line) => sum + (Number(line.confidence) || 0), 0) / titleLines.length
      : Number(data?.confidence) || 0;
    const focusBox = titleLines.length && titleLines.every((line) => line.x1 > line.x0 && line.y1 > line.y0)
      ? {
          x0: Math.min(...titleLines.map((line) => line.x0)),
          y0: Math.min(...titleLines.map((line) => line.y0)),
          x1: Math.max(...titleLines.map((line) => line.x1)),
          y1: Math.max(...titleLines.map((line) => line.y1))
        }
      : null;
    return {
      fullTextQuery,
      titleWithSecondaryQuery,
      primaryTitleQuery,
      lineQueries: trustedLines.map((line) => cleanImageSearchText(line.text, 10)).filter(Boolean),
      confidence: titleConfidence,
      focusBox,
      focusLineCount: titleLines.length,
      score: (primary?.score || 0) + scoreImageText(titleWithSecondaryQuery, primary?.confidence || data?.confidence || 0)
    };
  };

  const ocrCandidateQuality = (candidate) => {
    if (!candidate) return { usable: false, strong: false, rank: -1 };
    const text = [candidate.titleWithSecondaryQuery, candidate.primaryTitleQuery].filter(Boolean).join(' ');
    const useful = imageMatchWords(text).filter((word) =>
      !IMAGE_SEARCH_NOISE.has(word) && word.length >= 3 && word.length <= 28 && !/(.)\1{3,}/u.test(word)
    );
    const confidence = Math.max(0, Math.min(100, Number(candidate.confidence) || 0));
    const hasModelNumber = useful.some((word) => /\d{2,}/.test(word));
    const hasProductTerm = /\b(?:serum|cream|toner|cleanser|mask|lotion|ampoule|gel|spf|collagen|retinol|panthenol|peptide|repair|shampoo|conditioner)\b/i.test(text);
    return {
      usable: (confidence >= 25 && useful.length >= 1) || useful.length >= 2,
      strong: (confidence >= 58 && useful.length >= 3)
        || (confidence >= 52 && useful.length >= 2 && (hasModelNumber || hasProductTerm))
        || (confidence >= 68 && useful.length >= 1 && hasProductTerm)
        || (confidence >= 78 && useful.length === 1 && useful[0].length >= 5),
      rank: confidence + useful.length * 14 + (hasModelNumber ? 12 : 0) + (hasProductTerm ? 8 : 0) + Math.min(20, Number(candidate.score) || 0) / 4
    };
  };

  const isConfidentOcrCandidate = (candidate) => ocrCandidateQuality(candidate).strong;

  const cropOcrCanvas = (source, box) => {
    if (!box || box.x1 <= box.x0 || box.y1 <= box.y0) return null;
    const boxWidth = box.x1 - box.x0;
    const boxHeight = box.y1 - box.y0;
    const padX = Math.max(12, boxWidth * .08);
    const padY = Math.max(12, boxHeight * .30);
    const x = Math.max(0, Math.floor(box.x0 - padX));
    const y = Math.max(0, Math.floor(box.y0 - padY));
    const width = Math.max(1, Math.min(source.width - x, Math.ceil(boxWidth + padX * 2)));
    const height = Math.max(1, Math.min(source.height - y, Math.ceil(boxHeight + padY * 2)));
    const scale = Math.max(1, Math.min(3.2, 1400 / Math.max(width, height)));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    const context = canvas.getContext('2d', { alpha: false });
    if (!context) throw new Error('CANVAS_UNAVAILABLE');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = 'high';
    context.drawImage(source, x, y, width, height, 0, 0, canvas.width, canvas.height);
    return canvas;
  };

  const mergeOcrCandidates = (candidates) => {
    const usable = candidates.filter(Boolean).sort((first, second) => ocrCandidateQuality(second).rank - ocrCandidateQuality(first).rank);
    if (!usable.length) return '';
    const best = usable[0];
    const lineQueries = [
      ...(best.lineQueries || []),
      ...usable.slice(1).flatMap((candidate) => [candidate.titleWithSecondaryQuery, candidate.primaryTitleQuery, ...(candidate.lineQueries || [])])
    ].map((value) => cleanImageSearchText(value, 10)).filter((value, index, list) => value && list.indexOf(value) === index).slice(0, 8);
    return {
      ...best,
      fullTextQuery: cleanImageSearchText([best.fullTextQuery, ...usable.slice(1).map((candidate) => candidate.titleWithSecondaryQuery)].join(' '), 24),
      lineQueries
    };
  };

  const renderOcrCanvas = (decoded, options = {}) => {
    const centerCrop = options.centerCrop === true;
    const source = centerCrop
      ? {
          x: Math.round(decoded.width * .02),
          y: Math.round(decoded.height * .01),
          width: Math.max(1, Math.round(decoded.width * .96)),
          height: Math.max(1, Math.round(decoded.height * .98))
        }
      : { x: 0, y: 0, width: decoded.width, height: decoded.height };
    const scale = Math.max(.12, Math.min(3.2, 1600 / Math.max(source.width, source.height)));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(source.width * scale));
    canvas.height = Math.max(1, Math.round(source.height * scale));
    const context = canvas.getContext('2d', { alpha: false, willReadFrequently: true });
    if (!context) throw new Error('CANVAS_UNAVAILABLE');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = 'high';
    const contrast = options.contrast || 1.12;
    const threshold = options.threshold || 0;
    const supportsCanvasFilter = !threshold && 'filter' in context;
    if (supportsCanvasFilter) context.filter = `grayscale(1) contrast(${contrast})`;
    context.drawImage(decoded.image, source.x, source.y, source.width, source.height, 0, 0, canvas.width, canvas.height);
    if (supportsCanvasFilter) {
      context.filter = 'none';
      return canvas;
    }

    const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
    const data = pixels.data;
    for (let index = 0; index < data.length; index += 4) {
      let gray = data[index] * .299 + data[index + 1] * .587 + data[index + 2] * .114;
      gray = Math.max(0, Math.min(255, (gray - 128) * contrast + 128));
      if (threshold) gray = gray < threshold ? 0 : 255;
      data[index] = gray;
      data[index + 1] = gray;
      data[index + 2] = gray;
    }
    context.putImageData(pixels, 0, 0);
    return canvas;
  };

  const readProductTextFromImage = async (file, searchId) => {
    let worker;
    let decoded;
    let canvas;
    let refinementCanvas;
    try {
      decoded = await decodeImage(file);
      if (searchId !== state.imageSearchId || state.modal?.hidden) return '';
      canvas = renderOcrCanvas(decoded, { centerCrop: true, contrast: 1.12, threshold: 0 });

      if (typeof window.TextDetector === 'function') {
        try {
          const detections = await new window.TextDetector().detect(canvas);
          const nativeData = {
            text: detections.map((item) => item.rawValue || '').filter(Boolean).join('\n'),
            lines: detections.map((item) => ({
              text: item.rawValue || '',
              confidence: 95,
              boundingBox: item.boundingBox || {}
            }))
          };
          const nativeCandidate = buildOcrCandidate(nativeData, canvas);
          if (isConfidentOcrCandidate(nativeCandidate)) return nativeCandidate;
        } catch (_) {}
      }

      let lastProgress = -5;
      state.ocrProgressCallback = (message) => {
        if (searchId !== state.imageSearchId || state.modal?.hidden || typeof message?.progress !== 'number') return;
        const progress = Math.min(99, Math.max(1, Math.round(message.progress * 100)));
        if (progress < 99 && progress - lastProgress < 5) return;
        lastProgress = progress;
        const detail = modalElement('[data-bt-vs-status-detail]');
        if (detail) {
          detail.textContent = `${strings.ocrProgress || 'Reading product name…'} ${progress}%`;
          detail.hidden = false;
        }
      };
      worker = await ensureOcrWorker();
      if (searchId !== state.imageSearchId || state.modal?.hidden) return '';
      const result = await worker.recognize(canvas, {}, { text: true, blocks: true });
      const candidates = [buildOcrCandidate(result?.data || {}, canvas)];
      if (!isConfidentOcrCandidate(candidates[0])) {
        refinementCanvas = cropOcrCanvas(canvas, candidates[0]?.focusBox) || canvas;
        try {
          await worker.setParameters({
            tessedit_pageseg_mode: candidates[0]?.focusLineCount > 1 ? '6' : '7',
            preserve_interword_spaces: '1',
            user_defined_dpi: '300'
          });
          if (searchId !== state.imageSearchId || state.modal?.hidden) return '';
          const refinedResult = await worker.recognize(refinementCanvas, {}, { text: true, blocks: true });
          candidates.push(buildOcrCandidate(refinedResult?.data || {}, refinementCanvas));
        } finally {
          await worker.setParameters({
            tessedit_pageseg_mode: '11',
            preserve_interword_spaces: '1',
            user_defined_dpi: '300'
          }).catch(() => {});
        }
      }
      const candidate = mergeOcrCandidates(candidates);
      return ocrCandidateQuality(candidate).usable ? candidate : '';
    } catch (_) {
      return '';
    } finally {
      if (canvas) {
        canvas.width = 1;
        canvas.height = 1;
      }
      if (refinementCanvas && refinementCanvas !== canvas) {
        refinementCanvas.width = 1;
        refinementCanvas.height = 1;
      }
      decoded?.revoke?.();
      state.ocrProgressCallback = null;
    }
  };

  const imageSearchQueries = (ocrResult, filename) => {
    const filenameQuery = imageFilenameQuery(filename);
    const fullTextQuery = cleanImageSearchText(ocrResult?.fullTextQuery || filenameQuery, 80);
    const titleWithSecondaryQuery = cleanImageSearchText(ocrResult?.titleWithSecondaryQuery || fullTextQuery, 10);
    const primaryTitleQuery = cleanImageSearchText(ocrResult?.primaryTitleQuery || filenameQuery || titleWithSecondaryQuery, 6);
    const lineQueries = Array.isArray(ocrResult?.lineQueries)
      ? ocrResult.lineQueries.map((value) => cleanImageSearchText(value, 10)).filter(Boolean)
      : [];
    const distinctiveWords = imageMatchWords([titleWithSecondaryQuery, primaryTitleQuery, ...lineQueries, fullTextQuery].join(' '))
      .filter((word) => !IMAGE_SEARCH_NOISE.has(word) && (word.length >= 4 || /^\d{3,}$/.test(word)))
      .slice(0, 6);
    const fuzzyPrefixes = distinctiveWords
      .filter((word) => !/^\d+$/.test(word) && word.length >= 6)
      .map((word) => word.slice(0, Math.max(4, word.length - 2)))
      .slice(0, 2);
    const candidateQueries = [
      titleWithSecondaryQuery,
      primaryTitleQuery,
      filenameQuery,
      distinctiveWords.slice(0, 3).join(' '),
      ...distinctiveWords.slice(0, 2),
      ...fuzzyPrefixes,
      ...lineQueries.slice(0, 2)
    ].map((value) => cleanImageSearchText(value, 10))
      .filter((value, index, list) => value.length >= 3 && list.indexOf(value) === index)
      .slice(0, 8);
    return {
      fullTextQuery,
      titleWithSecondaryQuery,
      primaryTitleQuery,
      lineQueries,
      candidateQueries,
      fallbackQueries: candidateQueries.slice(0, 3)
    };
  };

  const scoreThemeImageProduct = (product, candidate, evidenceWords, resultIndex) => {
    const title = normalizeImageMatchText(product?.title);
    const vendor = normalizeImageMatchText(product?.vendor);
    const body = normalizeImageMatchText(product?.body || product?.description);
    const haystack = `${title} ${vendor} ${body}`.trim();
    const productWords = imageMatchWords(haystack);
    const normalizedCandidate = normalizeImageMatchText(candidate);
    const candidateWords = imageMatchWords(candidate).filter((word) => !IMAGE_SEARCH_NOISE.has(word) && word.length >= 3);
    const candidateMatches = candidateWords.map((word) => ({ word, ...bestImageWordMatch(word, productWords) })).filter((match) => match.matched);
    const evidenceMatches = evidenceWords.map((word) => ({ word, ...bestImageWordMatch(word, productWords) })).filter((match) => match.matched);
    let score = Math.max(0, 4 - resultIndex);
    evidenceMatches.forEach((match) => {
      score += (/^\d+$/.test(match.word) ? 10 : Math.min(8, Math.max(3, match.word.length - 1))) * match.similarity;
    });
    candidateMatches.forEach((match) => { score += (/^\d+$/.test(match.word) ? 8 : 5) * match.similarity; });
    if (normalizedCandidate && candidateWords.length >= 2 && haystack.includes(normalizedCandidate)) score += 28;
    if (normalizedCandidate && title.includes(normalizedCandidate)) score += 18;
    if (normalizedCandidate && vendor === normalizedCandidate) score += 24;
    if (candidateWords.length) score += Math.round((candidateMatches.length / candidateWords.length) * 16);
    if (candidateWords.length === 1 && candidateMatches.length === 1 && (vendor.includes(candidateWords[0]) || title.includes(candidateWords[0]))) score += 16;
    return {
      score,
      matchedEvidence: evidenceMatches.length,
      matchedCandidate: candidateMatches.length,
      exactCandidate: candidateMatches.filter((match) => match.exact).length,
      longestMatched: candidateMatches.reduce((length, match) => Math.max(length, match.word.length), 0),
      bestSimilarity: candidateMatches.reduce((similarity, match) => Math.max(similarity, match.similarity), 0),
      candidateWords: candidateWords.length
    };
  };

  const findThemeImageMatch = async (queries, signal) => {
    const candidates = (queries.candidateQueries || [queries.titleWithSecondaryQuery, queries.primaryTitleQuery])
      .map((value) => cleanImageSearchText(value, 10))
      .filter((value, index, list) => value.length >= 3 && list.indexOf(value) === index)
      .slice(0, 8);
    if (!candidates.length) return '';

    const evidenceWords = imageMatchWords([
      queries.fullTextQuery,
      queries.titleWithSecondaryQuery,
      queries.primaryTitleQuery,
      ...(queries.lineQueries || [])
    ].join(' ')).filter((word) => !IMAGE_SEARCH_NOISE.has(word) && (word.length >= 3 || /^\d{3,}$/.test(word)));
    const rootPath = String(config.rootUrl || window.Shopify?.routes?.root || '/');
    const suggestPath = `${rootPath.endsWith('/') ? rootPath : `${rootPath}/`}search/suggest.json`.replace(/\/{2,}/g, '/');

    const resultGroups = await Promise.all(candidates.map(async (candidate) => {
      const url = new URL(suggestPath, window.location.origin);
      url.searchParams.set('q', candidate);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[options][fields]', 'title,body,tag,product_type,variants.title,vendor,variants.sku,variants.barcode');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      try {
        const response = await fetch(url.pathname + url.search, {
          credentials: 'same-origin',
          signal,
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) return { candidate, products: [] };
        const payload = await response.json();
        return { candidate, products: payload?.resources?.results?.products || [] };
      } catch (error) {
        if (error?.name === 'AbortError') throw error;
        return { candidate, products: [] };
      }
    }));

    const productMatches = new Map();
    resultGroups.forEach(({ candidate, products }) => {
      products.forEach((product, resultIndex) => {
        if (!product?.title) return;
        const scored = scoreThemeImageProduct(product, candidate, evidenceWords, resultIndex);
        const key = String(product.id || product.url || product.handle || `${product.title}|${product.vendor || ''}`);
        const current = productMatches.get(key);
        if (!current || scored.score > current.score) productMatches.set(key, { ...scored, candidate, product });
      });
    });
    const rankedProducts = Array.from(productMatches.values()).sort((first, second) => second.score - first.score);
    const best = rankedProducts[0];
    const second = rankedProducts[1];
    if (!best || best.score < 24 || !best.matchedCandidate) return '';
    const hasTwoSignals = best.matchedCandidate >= 2 && (best.exactCandidate >= 1 || best.matchedEvidence >= 3);
    const hasOneStrongSignal = best.matchedCandidate === 1 && (best.exactCandidate === 1 || best.bestSimilarity >= .90)
      && best.longestMatched >= 6 && best.score >= 38;
    if (!hasTwoSignals && !hasOneStrongSignal) return '';
    if (second && best.score - second.score < 6 && best.exactCandidate < 2) return '';
    return String(best.product.title).trim();
  };

  const imageSearchPayloadQuery = (payload) => {
    const products = Array.isArray(payload?.products) ? payload.products : [];
    return String(payload?.matchedQuery || payload?.topMatch || products[0]?.title || '').trim();
  };

  const requestImageSearch = async (prepared, options = {}) => {
    state.imageController?.abort();
    const controller = new AbortController();
    state.imageController = controller;
    const timeout = window.setTimeout(() => controller.abort(), options.timeout || 20000);
    const body = new FormData();
    const queries = options.queries || {};
    body.append('image', prepared, prepared.name || 'beauty-time-image-search.jpg');
    body.append('recognitionMode', options.mode || 'cloud');
    body.append('source', 'shopify_web');
    if (queries.fullTextQuery) body.append('query', queries.fullTextQuery);
    if (queries.fullTextQuery) body.append('fullTextQuery', queries.fullTextQuery);
    if (queries.titleWithSecondaryQuery) body.append('titleWithSecondaryQuery', queries.titleWithSecondaryQuery);
    if (queries.primaryTitleQuery) body.append('primaryTitleQuery', queries.primaryTitleQuery);
    if (Array.isArray(queries.fallbackQueries) && queries.fallbackQueries.length) {
      body.append('fallbackQueries', JSON.stringify(queries.fallbackQueries));
    }

    try {
      const response = await fetch(config.imageEndpoint, {
        method: 'POST',
        body,
        mode: 'cors',
        credentials: 'omit',
        signal: controller.signal,
        headers: { Accept: 'application/json' }
      });
      const payload = await response.json().catch(() => null);
      if (!response.ok) throw new Error(payload?.error || `IMAGE_SEARCH_${response.status}`);
      if (!payload?.ok) throw new Error(payload?.error || 'IMAGE_SEARCH_FAILED');
      return payload;
    } finally {
      window.clearTimeout(timeout);
      if (state.imageController === controller) state.imageController = null;
    }
  };

  const searchByImage = async (file) => {
    if (!file || !String(file.type || '').startsWith('image/')) {
      setNotice(strings.invalidImage);
      return;
    }
    clearStageTimers();
    const searchId = ++state.imageSearchId;
    setNotice('');
    const stages = Array.isArray(strings.imageStages) && strings.imageStages.length
      ? strings.imageStages
      : ['Preparing image…', 'Reading product…', 'Finding matches…'];
    showStatus(stages[0]);

    try {
      const prepared = await prepareImage(file);
      if (searchId !== state.imageSearchId || state.modal?.hidden) return;
      showStatus(stages[1] || stages[0]);
      let cloudPayload = null;
      try {
        cloudPayload = await requestImageSearch(prepared, { mode: 'cloud', timeout: 20000 });
      } catch (_) {
        /* The private on-device reader below remains available as a fallback. */
      }
      if (searchId !== state.imageSearchId || state.modal?.hidden) return;
      const cloudQuery = imageSearchPayloadQuery(cloudPayload);
      if (cloudQuery) {
        clearStageTimers();
        modalElement('[data-bt-vs-status-text]').textContent = strings.matchFound;
        state.stageTimers.push(window.setTimeout(() => applySearchQuery(cloudQuery), 320));
        return;
      }

      const ocrResult = await readProductTextFromImage(file, searchId);
      if (searchId !== state.imageSearchId || state.modal?.hidden) return;
      const queries = imageSearchQueries(ocrResult, file.name);
      showStatus(stages[2] || stages[stages.length - 1] || stages[0]);

      let fallbackPayload = null;
      try {
        fallbackPayload = await requestImageSearch(prepared, {
          mode: 'text_fallback',
          queries,
          timeout: 16000
        });
      } catch (_) {
        /* Shopify's local predictive search is the final fallback. */
      }
      if (searchId !== state.imageSearchId || state.modal?.hidden) return;
      const fallbackQuery = imageSearchPayloadQuery(fallbackPayload);
      if (fallbackQuery) {
        clearStageTimers();
        modalElement('[data-bt-vs-status-text]').textContent = strings.matchFound;
        state.stageTimers.push(window.setTimeout(() => applySearchQuery(fallbackQuery), 320));
        return;
      }

      const localController = new AbortController();
      state.imageController = localController;
      const localTimeout = window.setTimeout(() => localController.abort(), 12000);
      let themeMatch = '';
      try {
        themeMatch = await findThemeImageMatch(queries, localController.signal);
      } catch (error) {
        if (error?.name !== 'AbortError') throw error;
      } finally {
        window.clearTimeout(localTimeout);
        if (state.imageController === localController) state.imageController = null;
      }
      if (searchId !== state.imageSearchId || state.modal?.hidden) return;
      if (!themeMatch) {
        clearStageTimers();
        showActivePanel();
        setNotice(strings.imageNoResults);
        return;
      }
      clearStageTimers();
      modalElement('[data-bt-vs-status-text]').textContent = strings.matchFound;
      state.stageTimers.push(window.setTimeout(() => applySearchQuery(themeMatch), 320));
    } catch (error) {
      clearStageTimers();
      state.imageController = null;
      if ((error?.name === 'AbortError' && state.modal?.hidden) || searchId !== state.imageSearchId) return;
      showActivePanel();
      const message = ['IMAGE_TOO_LARGE', 'CANVAS_UNAVAILABLE', 'IMAGE_COMPRESSION_FAILED'].includes(error?.message)
        ? strings.imageTooLarge
        : (error?.message === 'INVALID_IMAGE' ? strings.invalidImage : strings.imageFailed);
      setNotice(message);
    }
  };

  const scannerConfig = () => {
    const formats = window.Html5QrcodeSupportedFormats;
    const settings = {
      fps: 10,
      qrbox(viewfinderWidth, viewfinderHeight) {
        const width = Math.max(160, Math.min(Math.floor(viewfinderWidth * .82), viewfinderWidth - 20));
        const height = Math.max(84, Math.min(145, Math.floor(viewfinderHeight * .38)));
        return { width, height };
      },
      disableFlip: false
    };
    if (formats) {
      settings.formatsToSupport = [
        formats.QR_CODE,
        formats.CODE_128,
        formats.CODE_39,
        formats.CODE_93,
        formats.CODABAR,
        formats.EAN_13,
        formats.EAN_8,
        formats.UPC_A,
        formats.UPC_E,
        formats.ITF,
        formats.DATA_MATRIX
      ].filter((format) => format !== undefined);
    }
    return settings;
  };

  const waitForReaderLayout = (reader, timeout = 1400) => new Promise((resolve, reject) => {
    const started = Date.now();
    const check = () => {
      if (!reader?.isConnected || state.modal?.hidden || state.mode !== 'barcode') {
        reject(new Error('SCANNER_CANCELLED'));
        return;
      }
      const bounds = reader.getBoundingClientRect();
      if (bounds.width >= 180 && bounds.height >= 110) {
        resolve();
        return;
      }
      if (Date.now() - started >= timeout) {
        reject(new Error('SCANNER_LAYOUT_NOT_READY'));
        return;
      }
      window.requestAnimationFrame(check);
    };
    window.requestAnimationFrame(() => window.requestAnimationFrame(check));
  });

  const preferredCamera = (cameras) => {
    if (!Array.isArray(cameras) || !cameras.length) return null;
    const rearPattern = /back|rear|environment|traseira|arrière|rück|posteriore|خلف/i;
    return cameras.find((camera) => rearPattern.test(camera.label || '')) || cameras[cameras.length - 1];
  };

  const startScannerWithFallback = async (reader, onSuccess) => {
    const candidates = [{ facingMode: { ideal: 'environment' } }];
    try {
      const cameras = await window.Html5Qrcode.getCameras();
      const preferred = preferredCamera(cameras);
      if (preferred?.id) candidates.push(preferred.id);
      cameras?.forEach((camera) => {
        if (camera?.id && !candidates.includes(camera.id)) candidates.push(camera.id);
      });
    } catch (_) {
      /* The facing-mode attempt below can still work when device enumeration is blocked. */
    }

    let lastError;
    for (const camera of candidates) {
      if (state.mode !== 'barcode' || state.modal?.hidden) throw new Error('SCANNER_CANCELLED');
      try {
        await stopScanner();
        reader.innerHTML = '';
        state.scanner = new window.Html5Qrcode(reader.id);
        await state.scanner.start(camera, scannerConfig(), onSuccess, () => {});
        return;
      } catch (error) {
        lastError = error;
        await stopScanner();
      }
    }
    throw lastError || new Error('CAMERA_UNAVAILABLE');
  };

  const normalizeBarcode = (value) => String(value || '').trim().replace(/\s+/g, '');

  const isValidGtin = (value) => {
    const code = String(value || '').replace(/\D/g, '');
    if (![8, 12, 13, 14].includes(code.length)) return false;
    let sum = 0;
    let weight = 3;
    for (let index = code.length - 2; index >= 0; index -= 1) {
      sum += Number(code[index]) * weight;
      weight = weight === 3 ? 1 : 3;
    }
    return (10 - (sum % 10)) % 10 === Number(code[code.length - 1]);
  };

  const barcodeCandidatesFromText = (value) => {
    const digitGroups = String(value || '').match(/\d+/g) || [];
    const compact = digitGroups.join('');
    if (!compact) return [];
    const supportedLengths = [14, 13, 12, 8];
    const exactGroups = digitGroups
      .filter((group) => supportedLengths.includes(group.length) && isValidGtin(group));
    if (exactGroups.length) {
      return exactGroups.filter((item, index, list) => list.indexOf(item) === index);
    }
    if (supportedLengths.includes(compact.length)) {
      return isValidGtin(compact) ? [compact] : [];
    }
    if (compact.length <= supportedLengths[0]) return [];

    for (const length of supportedLengths) {
      const candidates = [];
      for (let index = 0; index <= compact.length - length; index += 1) {
        const candidate = compact.slice(index, index + length);
        if (isValidGtin(candidate) && !candidates.includes(candidate)) candidates.push(candidate);
      }
      if (candidates.length) return candidates;
    }
    return [];
  };

  const barcodeFromVisionPayload = (payload) => {
    const values = [
      payload?.query,
      payload?.inferredText,
      ...(Array.isArray(payload?.visionQueries) ? payload.visionQueries : [])
    ];
    for (const value of values) {
      const barcode = barcodeCandidatesFromText(value)[0];
      if (barcode) return barcode;
    }
    return '';
  };

  const readBarcodeWithCloudVision = async (file) => {
    const prepared = await prepareImage(file);
    const payload = await requestImageSearch(prepared, {
      mode: 'cloud',
      timeout: 18000
    });
    return barcodeFromVisionPayload(payload);
  };

  const barcodeLookupCodes = (value) => {
    const code = normalizeBarcode(value);
    const codes = [code];
    if (/^\d{12}$/.test(code)) codes.push(`0${code}`);
    if (/^0\d{12}$/.test(code)) codes.push(code.slice(1));
    return codes.filter((item, index, list) => item && list.indexOf(item) === index);
  };

  const findProductByBarcode = async (code) => {
    for (const lookupCode of barcodeLookupCodes(code)) {
      const url = new URL('/en/search/suggest.json', window.location.origin);
      url.searchParams.set('q', lookupCode);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '3');
      url.searchParams.set('resources[options][fields]', 'variants.barcode,variants.sku,title');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      const response = await fetch(url.pathname + url.search, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) continue;
      const payload = await response.json();
      const product = payload?.resources?.results?.products?.[0] || null;
      if (product) return product;
    }
    return null;
  };

  const openBarcodeProduct = (product) => {
    const handle = String(product?.handle || '').trim();
    if (!handle) return false;
    const rootPath = new URL(config.rootUrl || '/', window.location.origin).pathname.replace(/\/$/, '');
    const targetPath = `${rootPath}/products/${encodeURIComponent(handle)}`.replace(/\/{2,}/g, '/');
    closeModal(false);
    window.location.assign(targetPath);
    return true;
  };

  const completeBarcode = async (value) => {
    const code = normalizeBarcode(value);
    if (code.length < 3 || code.length > 80) {
      showActivePanel();
      setNotice(strings.barcodeInvalid);
      return;
    }
    if (state.scannerLocked) return;
    state.scannerLocked = true;
    await stopScanner(false);
    state.scannerLocked = true;
    showStatus(strings.barcodeFound, code);
    try {
      const [product] = await Promise.all([
        findProductByBarcode(code),
        new Promise((resolve) => window.setTimeout(resolve, 280))
      ]);
      if (product && openBarcodeProduct(product)) return;
    } catch (_) {
      /* The predictive-search fallback below also works if the JSON endpoint is unavailable. */
    }
    applySearchQuery(code);
  };

  const startScanner = async () => {
    if (state.mode !== 'barcode' || state.modal?.hidden) return;
    const startButton = modalElement('[data-bt-vs-start-camera]');
    const startLabel = startButton?.querySelector('span');
    if (startButton?.dataset.btVsCameraFallback === 'true') {
      const cameraInput = modalElement('[data-bt-vs-barcode-camera]');
      if (cameraInput) {
        cameraInput.value = '';
        cameraInput.click();
      }
      return;
    }
    if (state.scannerStarting) return;
    const attempt = ++state.scannerAttempt;
    state.scannerStarting = true;
    if (startButton) startButton.disabled = true;
    setNotice('');

    if (typeof window.navigator?.mediaDevices?.getUserMedia !== 'function') {
      showActivePanel();
      const cameraInput = modalElement('[data-bt-vs-barcode-camera]');
      if (cameraInput) {
        cameraInput.value = '';
        cameraInput.click();
      } else {
        setNotice(strings.cameraFailed);
      }
      state.scannerStarting = false;
      if (startButton) startButton.disabled = false;
      return;
    }

    showStatus(strings.scannerLoading);

    try {
      await loadRuntime(config.scannerAsset, 'Html5Qrcode', 'data-bt-barcode-runtime');
      if (attempt !== state.scannerAttempt || state.mode !== 'barcode' || state.modal?.hidden) return;
      showActivePanel();
      await stopScanner();
      const reader = modalElement('#bt-visual-search-reader');
      if (!reader) throw new Error('SCANNER_READER_MISSING');
      await waitForReaderLayout(reader);
      state.scannerLocked = false;
      await startScannerWithFallback(reader, (decodedText) => completeBarcode(decodedText));
      if (attempt !== state.scannerAttempt || state.mode !== 'barcode' || state.modal?.hidden) {
        await stopScanner();
        return;
      }
      modalElement('[data-bt-vs-barcode-stage]')?.classList.add('is-scanning');
      if (startLabel) startLabel.textContent = strings.retryCamera;
    } catch (error) {
      await stopScanner();
      if (state.mode !== 'barcode' || state.modal?.hidden) return;
      showActivePanel();
      setNotice(window.Html5Qrcode ? strings.cameraFailed : strings.scannerFailed);
      if (startButton) startButton.dataset.btVsCameraFallback = 'true';
      if (startLabel) startLabel.textContent = strings.captureBarcode || strings.retryCamera;
    } finally {
      if (attempt === state.scannerAttempt) state.scannerStarting = false;
      if (startButton) startButton.disabled = false;
    }
  };

  const scanBarcodeFile = async (file) => {
    if (!file || !String(file.type || '').startsWith('image/')) {
      setNotice(strings.invalidImage);
      return;
    }
    setNotice('');
    showStatus(strings.scannerLoading);
    const attempt = ++state.barcodeFileAttempt;
    let fileReader;
    try {
      await loadRuntime(config.scannerAsset, 'Html5Qrcode', 'data-bt-barcode-runtime');
      if (attempt !== state.barcodeFileAttempt || state.mode !== 'barcode' || state.modal?.hidden) return;
      await stopScanner();
      fileReader = document.createElement('div');
      fileReader.id = `bt-visual-search-file-reader-${Date.now()}`;
      Object.assign(fileReader.style, {
        position: 'fixed',
        left: '-10000px',
        top: '0',
        width: '640px',
        height: '360px',
        overflow: 'hidden',
        pointerEvents: 'none',
        opacity: '0'
      });
      document.body.appendChild(fileReader);
      state.scanner = new window.Html5Qrcode(fileReader.id);
      const decodedText = await state.scanner.scanFile(file, false);
      if (attempt !== state.barcodeFileAttempt || state.mode !== 'barcode' || state.modal?.hidden) return;
      await completeBarcode(decodedText);
    } catch (_) {
      await stopScanner();
      if (attempt !== state.barcodeFileAttempt || state.mode !== 'barcode' || state.modal?.hidden) return;
      try {
        const cloudBarcode = await readBarcodeWithCloudVision(file);
        if (attempt !== state.barcodeFileAttempt || state.mode !== 'barcode' || state.modal?.hidden) return;
        if (cloudBarcode) {
          await completeBarcode(cloudBarcode);
          return;
        }
      } catch (_) {
        /* A clear local scan remains the fastest path; Cloud Vision is only a fallback. */
      }
      if (attempt !== state.barcodeFileAttempt || state.mode !== 'barcode' || state.modal?.hidden) return;
      showActivePanel();
      setNotice(strings.barcodeImageFailed);
    } finally {
      fileReader?.remove();
    }
  };

  const openModal = (mode, trigger) => {
    const modal = createModal();
    state.mode = mode;
    state.returnFocus = trigger;
    state.activeInput = trigger.closest('form')?.querySelector('[data-input-search], input[name="q"]') || null;
    setNotice('');
    clearStageTimers();
    modalElement('[data-bt-vs-status]')?.setAttribute('hidden', '');
    modalElement('[data-bt-vs-panel="image"]')?.toggleAttribute('hidden', mode !== 'image');
    modalElement('[data-bt-vs-panel="barcode"]')?.toggleAttribute('hidden', mode !== 'barcode');
    modalElement('[data-bt-vs-title]').textContent = mode === 'image' ? strings.imageTitle : strings.barcodeTitle;
    modalElement('[data-bt-vs-title-icon]').innerHTML = mode === 'image' ? imageIcon : barcodeIcon;
    modal.querySelectorAll('[data-bt-vs-description]').forEach((node) => {
      if (node.closest(`[data-bt-vs-panel="${mode}"]`)) {
        node.textContent = mode === 'image' ? strings.imageDescription : strings.barcodeDescription;
      }
    });
    const manualInput = modalElement('[data-bt-vs-manual-input]');
    if (manualInput) manualInput.value = '';
    const startButton = modalElement('[data-bt-vs-start-camera]');
    if (startButton) {
      delete startButton.dataset.btVsCameraFallback;
      const startLabel = startButton.querySelector('span');
      if (startLabel) startLabel.textContent = strings.startCamera;
    }
    modal.hidden = false;
    if (typeof modal.showModal === 'function') {
      try {
        if (!modal.open) modal.showModal();
      } catch (_) {
        modal.setAttribute('open', '');
      }
    } else {
      modal.setAttribute('open', '');
    }
    document.body.classList.add('bt-visual-search-open');
    window.requestAnimationFrame(() => modalElement('.bt-visual-search__close')?.focus({ preventScroll: true }));
    if (mode === 'barcode') startScanner();
  };

  function bindModalEvents(modal) {
    modal.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeModal();
    });

    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-bt-vs-close]')) {
        closeModal();
        return;
      }
      const picker = event.target.closest('[data-bt-vs-pick]');
      if (picker) {
        const type = picker.dataset.btVsPick;
        const selector = type === 'camera'
          ? '[data-bt-vs-image-camera]'
          : type === 'gallery'
            ? '[data-bt-vs-image-file]'
            : '[data-bt-vs-barcode-file]';
        const fileInput = modalElement(selector);
        if (fileInput) {
          fileInput.value = '';
          fileInput.click();
        }
        return;
      }
      if (event.target.closest('[data-bt-vs-start-camera]')) startScanner();
    });

    modalElement('[data-bt-vs-image-camera]')?.addEventListener('change', (event) => searchByImage(event.target.files?.[0]));
    modalElement('[data-bt-vs-image-file]')?.addEventListener('change', (event) => searchByImage(event.target.files?.[0]));
    modalElement('[data-bt-vs-barcode-camera]')?.addEventListener('change', (event) => scanBarcodeFile(event.target.files?.[0]));
    modalElement('[data-bt-vs-barcode-file]')?.addEventListener('change', (event) => scanBarcodeFile(event.target.files?.[0]));
    modalElement('[data-bt-vs-manual-form]')?.addEventListener('submit', (event) => {
      event.preventDefault();
      completeBarcode(modalElement('[data-bt-vs-manual-input]')?.value);
    });

    const handle = modalElement('[data-bt-vs-handle]');
    const sheet = modalElement('.bt-visual-search__sheet');
    handle?.addEventListener('pointerdown', (event) => {
      state.dragStartY = event.clientY;
      state.dragOffset = 0;
      handle.setPointerCapture?.(event.pointerId);
    });
    handle?.addEventListener('pointermove', (event) => {
      if (state.dragStartY === null) return;
      state.dragOffset = Math.max(0, event.clientY - state.dragStartY);
      sheet?.style.setProperty('--bt-vs-drag-y', `${state.dragOffset}px`);
    });
    const finishDrag = () => {
      if (state.dragStartY === null) return;
      const shouldClose = state.dragOffset > 90;
      state.dragStartY = null;
      state.dragOffset = 0;
      if (shouldClose) closeModal();
      else sheet?.style.setProperty('--bt-vs-drag-y', '0px');
    };
    handle?.addEventListener('pointerup', finishDrag);
    handle?.addEventListener('pointercancel', finishDrag);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bt-visual-search]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openModal(trigger.dataset.btVisualSearch, trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (!state.modal || state.modal.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(state.modal.querySelectorAll('button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((node) => !node.hidden && node.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:load', (event) => injectSearchTools(event.target));
  window.addEventListener('pagehide', () => stopScanner());
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && state.mode === 'barcode') stopScanner();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => injectSearchTools(), { once: true });
  } else {
    injectSearchTools();
  }
})();

// --------------------------
// Delivery Time
// --------------------------
// https://unpkg.com/dayjs@1.11.10/dayjs.min.js
import dayjs from "@theme/dayjs";
dayjs.locale('en'); // use locale globally
class orderDelivery extends VariantChangeBase {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    this.offDays          = this.config.off_day.replace(/ /g,'').split(",");
    this.nowDay           = dayjs();
    var format_day       = this.config.format_day,
        time             = this.config.time.replace("24:00:00", "23:59:59"),
        arrDayWeek       = ["SUN","MON","TUE","WED","THU","FRI","SAT"],
        dateStart        = this.config.estimateStartDate || 0,
        dateEnd          = this.config.estimateEndDate || 0,
        excludeDays      = this.config.cut_day.replace(/ /g,'').split(","),
        startDay         = dayjs(),
        i                = 0,
        endDay           = dayjs(),
        j                = 0,
        nowTime          = this.nowDay.format('HHmmss'),
        timeint          = time.replace(/ /g,'').replace(/:/g,''),

        arrDay           = themeHDN.extras.order.dayNames.replace(/ /g,'').split(","),
        arrMth           = themeHDN.extras.order.monthNames.replace(/ /g,'').split(",");
    /**
     * Check Time, if nowTime >=  timeint +1 day
     */
    if (parseInt(nowTime) >= parseInt(timeint)) {
      this.nowDay   = this.nowDay.add(1, 'day');
      startDay = startDay.add(1, 'day');
      endDay   = endDay.add(1, 'day');
    }

    /**
     * Mode: 2 - Shipping + delivery
     * Mode: 1 - Only delivery
     */

    if ( this.config.mode == '2' ) {

      // START DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
        startDay = startDay.add(1, 'day');
      }
      while (i < dateStart) {
        i++;
        startDay = startDay.add(1, 'day');
        if (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
          i--;
        }
      }

      // END DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
        endDay = endDay.add(1, 'day');
      }

      while (j < dateEnd) {
        j++;
        endDay = endDay.add(1, 'day');
        if (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
          j--;
        }
      }

    }
    else {

      // START DATE
      startDay = startDay.add(dateStart, 'day');
      while (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
        startDay = startDay.add(1, 'day');
      }

      // END DATE
      endDay = endDay.add(dateEnd, 'day');
      while (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
        endDay = endDay.add(1, 'day');
      }
      // endDay = endDay.add(this.offDaysf(endDay), 'day');

    }

    /**
     * Translate day, month
     * https://day.js.org/docs/en/display/format
     */
    arrDay = this.ArrUnique(arrDay);
    arrMth = this.ArrUnique(arrMth);

    var startDayDInt = parseInt(startDay.format('D')),
    daystStart       = startDayDInt + this.nth(startDayDInt),
    MntStart         = arrMth[ parseInt(startDay.format('M')) -1 ],
    dayStart         = arrDay[ parseInt(startDay.format('d')) ],

    EndDayDInt       = parseInt(endDay.format('D')),
    daystEnd         = EndDayDInt + this.nth( EndDayDInt ),
    MntEnd           = arrMth[ parseInt(endDay.format('M')) -1 ],
    dayEnd           = arrDay[ parseInt(endDay.format('d')) ];

    //console.log( startDayDInt, EndDayDInt )
    if($4('[data-start-delivery]', this)) $4('[data-start-delivery]', this).innerHTML = startDay.format(format_day).replace('t44',dayStart).replace('t45',daystStart).replace('t46',MntStart);
    if($4('[data-end-delivery]', this)) $4('[data-end-delivery]', this).innerHTML = endDay.format(format_day).replace('t44',dayEnd).replace('t45',daystEnd).replace('t46',MntEnd);
  }

  ArrUnique(arr) {
    var onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };
    return arr.filter( onlyUnique );
  }

  nth(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    }
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.closest(".hdt-product-info__item").style.display = "";
        if( variant.variant_state.pre_order ) {
          this.closest(".hdt-product-info__item").style.display = "none"
        }
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('order-delivery', orderDelivery);
class countdownSimple extends HTMLElement {
  x = 0;
  constructor() {
    super();

    /** Countdown
     * [days] [hours] [mins] [secs]
     */

    this.config = JSON.parse(this.getAttribute('config'));
    const time = this.config.time.replace("24:00:00", "23:59:59")

    if (time == '19041994') return;
    this.textTemp = $4("template", this).innerHTML;
    this.notHasDay  = !this.textTemp.includes('[days]');
    let today        = dayjs();

    const nowTime      = today.format('HHmmss'),
          configTime   = time.replace(/ /g,'').replace(/:/g,'')

    if (parseInt(nowTime) >= parseInt(configTime)) {
      today = today.add(1, 'day');
    }
    // Set the date we're counting down to
    // "2030-01-05 15:37:25"
    this.countDownDate = new Date(`${today.format('YYYY-MM-DD')} ${time}`).getTime();

    // Update the count down every 1 second
    this.#update();
    this.x = setInterval( this.#update.bind(this), this.textTemp.includes('[secs]') ? 1000 : 60000);
  }
  #update() {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days    = Math.floor(distance / (1000 * 60 * 60 * 24));
    let   hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (this.notHasDay) hours = days*24 + hours;

    // Display the result in the element
    this.innerHTML = this.textTemp.replace('[days]', String(days).padStart(2, '0')).replace('[hours]', String(hours).padStart(2, '0')).replace('[mins]', String(minutes).padStart(2, '0')).replace('[secs]', String(seconds).padStart(2, '0'));

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.x);
      // EXPIRED
      this.hidden = true
    }
  }
  disconnectedCallback() {
    clearInterval(this.x);
  }
}
customElements.define('hdt-countdown-simple', countdownSimple);


// Begin instagram feed api
const dataInstagramCache = {};
class instagramFeedAPI extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        this.refresh_ins();
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const {acc,id} = this.config;
        var data = sessionStorage.getItem('hdt_ins'+acc+id);
        if (data != null && data != '') {
          sessionStorage.removeItem('hdt_ins'+acc+id);
        }
      })
    }
  }
  connectedCallback() {
    this.refresh_ins();
  }
  refresh_ins(){
    const {acc,id} = this.config;

    if (acc == '') return;

    var data = sessionStorage.getItem('hdt_ins'+acc+id);

    if (data != null && data != '') {
      // calculate expiration time for content,
      // to force periodic refresh after 30 minutes
      var now = new Date(),
      expiration = new Date(JSON.parse(data).timestamp);

      expiration.setMinutes(expiration.getMinutes() + 30);

      // ditch the content if too old
      if (now.getTime() > expiration.getTime()) {
        data = null;
        sessionStorage.removeItem('hdt_ins'+acc+id);
      }
    }
    if ( data != null && data != '' ) {
      this.instagramHTML(JSON.parse(data).content,false);
    }
    else{
      if (dataInstagramCache[acc]) {
        $4('.hdt-slider__container', this).innerHTML = dataInstagramCache[acc];
        $4('.hdt-ins-loading', this)?.remove();
        const lazySlider = $4('hdt-slider-lazy', this);
        if (lazySlider) {
          lazySlider.hidden = false;
          lazySlider.InitLazy();
        }
        return;
      }

      fetch('https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token='+atob(acc))
      .then((response) => {
        if(!response.ok) {
          throw new Error("not ok"); 
        }
        return response.json()
      })
      //.then(function(res)
      .then((res) => {
        //console.log('Success:', res);
         this.instagramHTML(res.data,true);
      })
      .catch((err) => {
        $4('.hdt-ins-loading', this)?.remove();
        console.error("Instagram Feed:error fetch");
        console.error(err);
      });
    }
  }
  instagramHTML(data,saveSessionStorageIns) {
    const arrIcons = ($4('.hdt-icons-ins-svg', this).innerHTML || '').split('[hdtplit]'),
    icons = {
       image : arrIcons[0],
       video : arrIcons[1],
       carousel_album: arrIcons[2]
    },
    {id, acc, target, limit} = this.config;
    let html = '';

    data.forEach( (el, index) => {
      if (index >= limit) return 0;
      const media_type = el.media_type.toLowerCase();
      html += `<div class="hdt-slider__slide hdt-ins-type-${media_type}"><a calc-nav data-no-instant rel="nofollow" class="hdt-ins-inner hdt-block hdt-relative hdt-oh hdt-radius" href="${el.permalink}" target="${target}"><div class="hdt-ratio"><img src="${el.thumbnail_url || el.media_url}" class="hdt-ins-img" loading="lazy"></div><div class="hdt-ins-icon">${icons[media_type]}</div></a></div>`
    });
    dataInstagramCache[acc] = html;
    $4('.hdt-slider__container', this).innerHTML = html;
    $4('.hdt-ins-loading', this)?.remove();
    const lazySlider = $4('hdt-slider-lazy', this);
    if (lazySlider) {
      lazySlider.hidden = false;
      lazySlider.InitLazy();
    }

    if(saveSessionStorageIns){
      sessionStorage.setItem('hdt_ins'+acc+id, JSON.stringify({
        timestamp: new Date(),
        content: data
      }));
    }
  }
}
customElements.define('ins-feed-api', instagramFeedAPI);


// product description - readmore
class ProductDescription extends HTMLElement{
  constructor(){
    super();
    this.lm_btn = this.querySelector('.hdt-pr-des-rm');
    if(!this.lm_btn) return;
    
    this.lm_btn.addEventListener('click',()=>{
      this.classList.toggle('is--less');
    })
  }
}
customElements.define('product-description',ProductDescription);



// check purchase code
if(Shopify.designMode){

  /**
  * If it's a global variable then window[variableName] or in your case window["onlyVideo"] should do the trick.
  * https://stackoverflow.com/questions/5613834/convert-string-to-variable-name-in-javascript
  */
  function isStorageSupported(type) {
    // Return false if we are in an iframe without access to sessionStorage
    // window.self !== window.top

    var storage = (type === 'session') ? window.sessionStorage : window.localStorage;

    try {
      storage.setItem('t4s', 'test');
      storage.removeItem('t4s');
      return true;
    } catch (error) {
      return false;
    }
  };

  var ThemeCode    = atob(window[atob('Y0hWeVkyaGg=')]),
      ThemeName_base64 = window[atob('VkdobGJXVk9ZVzFsVkRR')],
      ThemeName            = atob(ThemeName_base64),
      CookieName           = 'SXNBY3RpdmVUaGVtZQ=='+ThemeName_base64,
      ShopEmail            = atob(window[atob('VTJodmNFMWxiMVEw')]),
      isTrueSet            = (sessionStorage.getItem(CookieName) === 'true' ),
      str_temp_active      = atob('I3Q0cy10ZW1wLWtleS1hY3RpdmU='), // #t4s-temp-key-active
      str_purchase         = atob('cHVyY2hhc2VfY29kZXQ0'); // purchase_codet4;

      // console.log(ThemeCode,ThemeName,ShopEmail,CookieName,str_temp_active,str_purchase)
  function alert_active_html() {
    return `<section id="${str_purchase}" style="display: flex !important">${ $4(str_temp_active).innerHTML }</section>`;
  };

  // console.log('ThemeCode', ThemeCode, isTrueSet)

  if (ThemeCode == '') {
    let dom1 = (new DOMParser).parseFromString(alert_active_html(), "text/html");
    document.body.append(dom1.body.firstElementChild);
    let dom2 = (new DOMParser).parseFromString('<div id="luffyabc194"><style>body>*:not(#purchase_codet4) {opacity: 0;pointer-events: none;</style></div>', "text/html");
    document.body.prepend(dom2.body.firstElementChild);
    sessionStorage.removeItem(CookieName);
    localStorage.removeItem(CookieName);
  }
  else if ( !isTrueSet ) {

    //console.log(ShopEmail, ThemeName, ThemeCode);

    var domain     = window.location.hostname,
    mix        = ['4','t','h','e','p','l','i','c','o','/','.',':','n','s'],
    mix_domain = mix[2]+mix[1]+mix[1]+mix[4]+mix[13]+mix[11]+mix[9]+mix[9]+mix[5]+mix[6]+mix[7]+mix[10]+mix[1]+mix[2]+mix[3]+mix[0]+mix[10]+mix[7]+mix[8]+mix[9]+mix[5]+mix[6]+mix[7]+mix[3]+mix[12]+mix[13]+mix[3]+mix[9]+mix[7]+mix[2]+mix[3]+mix[7]+'k',
    data       = {
      "shopify_domain": domain,
      "email"         : ShopEmail,
      "theme"         : ThemeName,
      "purchase_code" : ThemeCode
    };

    fetch(mix_domain, {
      "headers": {
        "accept": "*/*",
        "cache-control": "no-cache",
        "x-requested-with": "XMLHttpRequest"
      },
      "body": btoa (encodeURIComponent(JSON.stringify(data))) ,
      "method": "POST",
      "mode": "cors"
    })
    .then(function(response) {
      if(response.ok){
        return response.json()
      } throw ""
    })
    .then(function(response) {
      let dom = (new DOMParser).parseFromString(alert_active_html(), "text/html");

      if ( response.status == 1) {

        dom.body.firstElementChild.innerHTML = "<p>ACTIVATED SUCCESSFULLY. Thanks for buying my theme!</p>";
        document.body.append(dom.body.firstElementChild);

        // Set a cookie to expire in 1 hour in Javascript
        var isActived = localStorage.getItem(CookieName);
        sessionStorage.setItem(CookieName, 'true')

        if (isActived === 'true') {
          $4(atob('I3B1cmNoYXNlX2NvZGV0NA==')).remove(); // #purchase_codet4
          // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
        }
        else {
          localStorage.setItem(CookieName, "true");
          setTimeout(function(){
            $4(atob('I3B1cmNoYXNlX2NvZGV0NA==')).remove(); // #purchase_codet4
            // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
          }, 1000);
        }

      }
      else {

        var mess = response.message;
        if (mess == "No sale belonging to the current user found with that code") {

          dom.body.firstElementChild.innerHTML = "<p>Purchase code error. It is a sales reversal or a refund. :(((</p>";

        }
        else if (mess.length == 58 || mess.length == 101) {
          dom.body.firstElementChild.innerHTML = "<p>That license key doesn't appear to be valid. Please check your purchase code again!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";

        }
        else if (mess.length == 104) {
          dom.body.firstElementChild.innerHTML = "<p>The license not match with current theme.!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";
        }
        else {
          try {
            var mess = mess.split('active domain `')[1].split('`. ')[0];
          }
          catch(err) {
            //var mess = mess;
          }
          dom.body.firstElementChild.innerHTML = "<p>Your purchase code is invalided since it is being activated at another store "+mess+".<br> Please open a ticket at <a class='cg' href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> to get quick assistance.</p>";
        }
        document.body.append(dom.body.firstElementChild);

      }

    }).catch(function(e) {
    //}).catch((e)=>{
      console.error(e)
    });

  }
}
// end check purchase code

// Masonry layout + filter sorting
// Masonry Layout Component
class MasonryLayout extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.style.position = 'relative';
    // Đọc config từ thuộc tính nếu có
    const configAttr = this.getAttribute('config');
    if (configAttr) {
      try {
        const userConfig = JSON.parse(configAttr);
        this.config = { ...userConfig };
      } catch (e) {
        this.config = {
          col_dk: 5,
          col_tb: 4,
          col_mb: 2,
          gap: 30,
          selector: '.hdt-masonry-item'
        };
      }
    }
    // console.log(this.config)
    this.waitForImages().then(() => {
      this.layoutMasonry();
      this.animateItems();
      // Set transition cho resize sau khi animation ban đầu hoàn thành
      setTimeout(() => {
        items.forEach(item => {
          item.style.transition = 'left 0.3s ease, top 0.3s ease, width 0.3s ease';
        });
      }, items.length * 100 + 500); // Đợi tất cả animation ban đầu hoàn thành
    });
    window.addEventListener('resize', () => {
      this.layoutMasonry();
      // this.animateItems();
    });
  }


  waitForImages() {
    const images = Array.from(this.querySelectorAll('img'));
    // console.log(images)
    if (images.length === 0) return Promise.resolve();
    let loaded = 0;
    return new Promise(resolve => {
      images.forEach(img => {
        const item = img.closest(this.config.selector);
        function hideLoading() {
          const loading = item?.querySelector('.item-loading');
          if (loading) loading.style.display = 'none';
          img.style.display = 'block';
        }
        if (img.complete) {
          hideLoading();
          loaded++;
          if (loaded === images.length) resolve();
        } else {
          // console.log(img)
          img.style.display = 'none';
          img.addEventListener('load', () => {
            hideLoading();
            loaded++;
            if (loaded === images.length) resolve();
          }, { once: true });
          img.addEventListener('error', () => {
            hideLoading();
            loaded++;
            if (loaded === images.length) resolve();
          }, { once: true });
        }
      });
    });
  }

  layoutMasonry() {
    const items = Array.from(this.querySelectorAll(this.config.selector)).filter(item => item.style.display !== 'none');
    // console.log(items)
    const containerWidth = this.clientWidth;
    let columnCount = this.config.col_dk;
    let gap = this.config.gap;
    if (containerWidth < 768) columnCount = this.config.col_mb, gap = this.config.gap_mb;
    else if (containerWidth < 1149) columnCount = this.config.col_tb;

    const columnHeights = Array(columnCount).fill(0);
    const columnWidth = (containerWidth - gap * (columnCount - 1)) / columnCount;
    // Bước 1: set width cho tất cả item
    items.forEach(item => {
      item.style.display = 'block';
      item.style.position = 'absolute';
      item.style.width = `${columnWidth}px`;
    });
    // Bước 2: ép reflow
    items.forEach(item => void item.offsetHeight);
    // Bước 3: tính toán vị trí
    items.forEach(item => {
      const minCol = columnHeights.indexOf(Math.min(...columnHeights));
      const x = minCol * (columnWidth + gap);
      const y = columnHeights[minCol];
      item.style.left = `${x}px`;
      item.style.top = `${y}px`;
      columnHeights[minCol] += item.offsetHeight + gap;
    });
    this.style.height = Math.max(...columnHeights) + 'px';
  }

  animateItems() {
    const items = Array.from(this.querySelectorAll(this.config.selector));
    items.forEach((item, index) => {
      setTimeout(() => {
        item.style.visibility = 'visible';
        item.style.opacity = '0';
        item.style.transform = 'translateY(30px)';
        item.style.transition = 'opacity 0.5s, transform 0.5s';
        setTimeout(() => {
          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }, 10);
      }, index * 100);
    });
  }
}

// Filter Sorting Component
class FilterSorting extends HTMLElement {
  constructor() {
    super();
    this.selector = this.getAttribute('config') ? JSON.parse(this.getAttribute('config')).selector : '.hdt-masonry-item';
  }

  connectedCallback() {
    // Không render vào shadowRoot nữa, chỉ cần giữ nguyên DOM
    this.initializeFilter();
  }

  initializeFilter() {
    // Lấy các filter-item trong DOM thường
    const filterItems = this.querySelectorAll('[data-category]');
    // Lấy masonry-layout bên trong
    const masonry = this.querySelector('hdt-masonry-layout');
    if (!masonry) return;
    const items = masonry.querySelectorAll(this.selector);
    // console.log(items)

    filterItems.forEach(filter => {
      filter.addEventListener('click', () => {
        // Remove active class from all filters
        filterItems.forEach(f => f.classList.remove('hdt-active'));
        // Add active class to clicked filter
        filter.classList.add('hdt-active');

        const category = filter.getAttribute('data-category');
        items.forEach(item => {
          if (category === 'all' || item.classList.contains(category)) {
            item.style.display = 'block';
            setTimeout(() => {
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            }, 100);
          } else {
            item.style.opacity = '0';
            item.style.transform = 'translateY(20px)';
            setTimeout(() => {
              item.style.display = 'none';
            }, 300);
          }
        });
        // Gọi lại layoutMasonry sau khi filter
        setTimeout(() => {
          if (typeof masonry.layoutMasonry === 'function') {
            masonry.layoutMasonry();
          }
        }, 350); // Đợi animation ẩn/hiện xong
      });
    });
  }
}

// Đăng ký custom elements
customElements.define('hdt-masonry-layout', MasonryLayout);
customElements.define('hdt-filter-sorting', FilterSorting);


/**
  * Cookies
  * https://help.shopify.com/en/manual/your-account/privacy/cookies
  * https://shopify.dev/themes/trust-security/cookie-banner#create-a-snippet-to-host-the-banner
  * https://help.shopify.com/en/manual/your-account/privacy/privacy-preferences-manager?shpxid=965d0d2a-08E2-4654-4A13-D3F38646AC5D
  * https://shopify.dev/api/consent-tracking
*/

function convertNameCookies(name) {
  return name.replace(/=/g,'_');
}
function setCookie(name,value,days,hours) {
  var expires = "";
  if (days || hours) {
    var date = new Date();
    date.setTime(date.getTime() + (days ? days*24*60*60*1000 : hours*60*60*1000));
    expires = "; expires=" + date.toString();
  }
  document.cookie = convertNameCookies(name) + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = convertNameCookies(name) + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = convertNameCookies(name)+'=; Max-Age=-99999999;';
}

class cookiesBar extends HTMLElement {
  constructor() {
    super();
    this.cookies = JSON.parse(this.getAttribute("configs"));
    this.cookies.cookiesName = "theme4:cookies";
    this.cookiesDrawer = this.querySelector(".hdt-drawer-cookie");
    this.isShowCookiesAll = (this.cookies.show == '1');
    this.acceptBtn = this.cookiesDrawer.querySelector(".hdt-pp_cookies__accept-btn");
    this.declineBtn = this.cookiesDrawer.querySelector(".hdt-pp_cookies__decline-btn");
    this.loadCookieBanner(this);
    let self = this;
    this.acceptBtn?.addEventListener("click", this.handleAccept.bind(this));
    this.declineBtn?.addEventListener("click", this.handleDecline.bind(this));
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        const cookiesSelect = event.target.classList.contains('sys-cookies');
        if (!cookiesSelect) return;
        self.showCookiesBanner();
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const cookiesSelect = event.target.classList.contains('sys-cookies');
        if (!cookiesSelect) return;
        self.hideCookiesBanner();
      })
    }
  }
  handleAccept() {
    if (this.isShowCookiesAll) {
      setCookie(this.cookies.cookiesName, 'accepted', parseInt(this.cookies.day_next));
    }
    window.Shopify.customerPrivacy.setTrackingConsent(true, this.hideCookiesBanner.bind(this));
  }

  handleDecline() {
    if (this.isShowCookiesAll) {
      setCookie(this.cookies.cookiesName, 'accepted', parseInt(this.cookies.day_next));
    }
    window.Shopify.customerPrivacy.setTrackingConsent(false, this.hideCookiesBanner.bind(this));
  }

  showCookiesBanner() {
    this.cookiesDrawer.classList.add('cookies-show');
  }

  hideCookiesBanner() {
    this.cookiesDrawer.classList.remove('cookies-show');
  }

  initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    if ((!userCanBeTracked && userTrackingConsent === 'no_interaction') || this.isShowCookiesAll) {
      if (!Shopify.designMode) {
        this.showCookiesBanner();
      }
    }
  }

  loadCookieBanner() {

    let self = this;
    if (this.cookiesDrawer.length == 0) return;
    this.cookies.day_next = this.cookies.day_next || 60;
    this.isShowCookiesAll = (this.cookies.show == '1');
    if (getCookie(this.cookies.cookiesName) == 'accepted' || this.cookiesDrawer.hasAttribute("open")) return;
    window.Shopify.loadFeatures([
      {
        name: 'consent-tracking-api',
        version: '0.1',
      }
    ],
      function (error) {
        if (error) {
          throw error;
        }
        self.initCookieBanner();
      });
  }
}

customElements.define('sys-cookies', cookiesBar);

// --------------------------
// Newsletter
// --------------------------

class newsletterModal extends HTMLElement {
  constructor() {
    super();
    this.configs = JSON.parse(this.getAttribute('configs'));
    this.modal = this.querySelector("hdt-modal");
    if ( !Shopify.designMode && getCookie("theme4:newsletter:"+this.configs.id) == 'shown' ){
      this.modal.setAttribute('closed','');
      return;
    }
    this.dialog = this.querySelector("dialog");
    this.action_close = this.querySelectorAll('[action-close]');
    this.time_delay     = this.configs.time_delay;
    this.day_next       = this.configs.day_next;
    if (Shopify.designMode) {
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      this._shopifySection.addEventListener('shopify:section:load', () => this.modal.open());
      this._shopifySection.addEventListener('shopify:section:select', () => this.modal.open());
      this._shopifySection.addEventListener('shopify:section:deselect', () => this.modal.close());
    }
  }

  connectedCallback() {
    if (!Shopify.designMode) {
      if ( getCookie("theme4:newsletter:"+this.configs.id) == 'shown' ){
        this.modal.setAttribute('closed','');
        return;
      }
      const fnShow = this.showModal.bind(this);
      const fnShowScroll = this.showModalScroll.bind(this);
      if(this.configs.after === 'time'){
        let tm = setTimeout(fnShow,this.configs.time_delay * 1000);
        this.dialog.addEventListener(`${dialogClose}`, () => {
          clearTimeout(tm);
          this.hideModal(false, true);
        });
      }
      else {
        window.addEventListener("scroll",fnShowScroll);
        this.dialog.addEventListener(`${dialogClose}`, () => {
          window.removeEventListener("scroll", fnShowScroll);
          this.hideModal(false, true);
        });
      }
      this.actionClose();
    }
  }

  disconnectedCallback() {
  }

  showModal() {
    this.modal.open();
  }
  showModalScroll(){
    if (window.scrollY > this.configs.scroll_delay) {
      this.modal.open();
    }
  }
  hideModal(pause, off) {
    if (pause) {

    }
    if (off) {

      setCookie("theme4:newsletter:"+this.configs.id, "shown", this.day_next);
    }
  }
  actionClose(){
    let self= this;
    if(self.action_close){
      self.action_close.forEach(btn => {
        btn.addEventListener('click',function(){
          self.modal.close();
          self.hideModal(false, true);
          setTimeout(() => {
            self.remove();
          }, 500);
        })
      });
    }
  }

}
customElements.define('sys-newsletter', newsletterModal);

// --------------------------
// Exit
// --------------------------

// --------------------------
// Exit
// --------------------------

class exitModal extends HTMLElement {
  constructor() {
    super();

    // قراءة الإعدادات من خاصية configs على العنصر
    const cfgAttr = this.getAttribute('configs');
    this.configs = cfgAttr ? JSON.parse(cfgAttr) : { after: 'move_cursor', time_delay: 2, day_next: 7, id: 'exit' };

    // منع الفتح إذا سبق الظهور (خارج وضع التصميم)
    if (!window.Shopify?.designMode && typeof getCookie === 'function') {
      if (getCookie("theme4:exit:" + this.configs.id) === 'shown') return;
    }

    // عناصر المودال
    this.modal = this.querySelector("hdt-modal");
    this.dialog = this.querySelector("dialog");

    // عناصر الخصم (اختياري)
    this.btn_copy = this.querySelector('button[is="discount_copy"]');
    this.discount = this.querySelector('[is="discount"]');

    // زمن إعادة الإظهار بالأيام
    this.day_next = Number(this.configs.day_next || 7);

    // تكامل مع محرّر Shopify
    if (window.Shopify?.designMode) {
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      if (this._shopifySection) {
        this._shopifySection.addEventListener('shopify:section:load', () => this.showModal(), { passive: true });
        this._shopifySection.addEventListener('shopify:section:select', () => this.showModal(), { passive: true });
        this._shopifySection.addEventListener('shopify:section:deselect', () => this.modal?.close(), { passive: true });
      }
    }

    // ربط مستمع الإغلاق لتنظيف المستمعين
    const closeEvt = (window.ThemeEvents && ThemeEvents.dialogClose) ? ThemeEvents.dialogClose : 'close';
    this._onDialogClose = () => this.hideModal(false, true);
    this.dialog?.addEventListener(closeEvt, this._onDialogClose, { passive: true, once: true });
  }

  connectedCallback() {
    if (window.Shopify?.designMode) return;

    // لا تُظهر لو فيه كوكي مسبق
    if (typeof getCookie === 'function') {
      if (getCookie("theme4:exit:" + this.configs.id) === 'shown') return;
    }

    // منطق متى تظهر
    const mode = this.configs.after || 'move_cursor';
    if (mode === 'move_cursor') {
      if (window.innerWidth > 1150) {
        this.moveCursor();
      } else {
        this.scrollPage();
      }
    } else if (mode === 'scroll') {
      this.scrollPage();
    } else {
      this.amountTime();
    }
  }

  // تحريك المؤشر لخارج الشاشة (نية الخروج)
  moveCursor() {
    if (!document?.body) return;
    this._onMouseLeave = this.showModal.bind(this);
    document.body.addEventListener("mouseleave", this._onMouseLeave, { passive: true });

    const closeEvt = (window.ThemeEvents && ThemeEvents.dialogClose) ? ThemeEvents.dialogClose : 'close';
    this.dialog?.addEventListener(closeEvt, () => {
      document.body.removeEventListener("mouseleave", this._onMouseLeave);
      this.hideModal(false, true);
    }, { passive: true, once: true });
  }

  // التمرير لأسفل الصفحة
  scrollPage() {
    const docHeight = Math.max(
      document.documentElement.scrollHeight - document.documentElement.clientHeight - 500,
      0
    );
    this._onScroll = () => {
      if (window.scrollY >= docHeight) {
        this.showModal();
      }
    };
    window.addEventListener("scroll", this._onScroll, { passive: true });

    const closeEvt = (window.ThemeEvents && ThemeEvents.dialogClose) ? ThemeEvents.dialogClose : 'close';
    this.dialog?.addEventListener(closeEvt, () => {
      window.removeEventListener("scroll", this._onScroll);
      this.hideModal(false, true);
    }, { passive: true, once: true });
  }

  // مؤقت زمني
  amountTime() {
    this._timer = window.setTimeout(() => this.showModal(), Number(this.configs.time_delay || 2) * 1000);

    const closeEvt = (window.ThemeEvents && ThemeEvents.dialogClose) ? ThemeEvents.dialogClose : 'close';
    this.dialog?.addEventListener(closeEvt, () => {
      if (this._timer) window.clearTimeout(this._timer);
      this.hideModal(false, true);
    }, { passive: true, once: true });
  }

  // فتح المودال + دعم نسخ الكوبون
  showModal() {
    if (!this.modal) return;
    this.modal.open?.();

    if (this.btn_copy && this.discount) {
      const $tip = this.btn_copy.querySelector('.hdt-tooltip-text');

      const copyText = async (txt) => {
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(txt);
          } else {
            // fallback
            this.discount.select?.();
            this.discount.setSelectionRange?.(0, 99999);
            document.execCommand("copy");
          }
          if ($tip) $tip.innerText = `${(window.themeHDN?.extras?.exit_popup?.copied || 'Copied')}: ${txt}`;
        } catch (e) {
          if ($tip) $tip.innerText = (window.themeHDN?.extras?.exit_popup?.copy || 'Copy');
        }
      };

      const onClick = () => copyText(this.discount.value || '');
      const onLeave = () => { if ($tip) $tip.innerText = (window.themeHDN?.extras?.exit_popup?.copy || 'Copy'); };

      this._copyClick = onClick;
      this._copyLeave = onLeave;

      this.btn_copy.addEventListener('click', this._copyClick, { passive: true });
      this.btn_copy.addEventListener('mouseleave', this._copyLeave, { passive: true });
    }
  }

  // عند الإغلاق: احفظ كوكي لمنع التكرار
  hideModal(_pause, off) {
    if (off && typeof setCookie === 'function') {
      setCookie("theme4:exit:" + this.configs.id, "shown", this.day_next);
    }

    // تنظيف المستمعات
    if (this._onMouseLeave) document.body.removeEventListener("mouseleave", this._onMouseLeave);
    if (this._onScroll) window.removeEventListener("scroll", this._onScroll);
    if (this._timer) window.clearTimeout(this._timer);
    if (this.btn_copy && this._copyClick) this.btn_copy.removeEventListener('click', this._copyClick);
    if (this.btn_copy && this._copyLeave) this.btn_copy.removeEventListener('mouseleave', this._copyLeave);
  }
}

// حماية من التعريف المزدوج
if (!customElements.get('sys-exit')) {
  customElements.define('sys-exit', exitModal);
}


// ================================
// Add to cart animation
// ================================

class atcAnimation extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    this.atc_btn = this.querySelector('[data-animation]:not([disabled])');
    if(!this.config || !this.atc_btn){
      return;
    }
  }
  init(){
    let class_list = this.config.ani.split(' ');
    this.interval = setInterval(() => {
      this.atc_btn.classList.add(...class_list);
      this.timer = setTimeout(() => {
        this.atc_btn.classList.remove(...class_list);
      }, 1000);
    }, parseInt(this.config.time) * 1000);
  }
  connectedCallback(){
    this.init();
  }
  disconnectedCallback(){
    clearInterval(this.interval);
    clearTimeout(this.timer);
  }
}

customElements.define('hdt-atc-animation', atcAnimation);




class TabsBrands extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('.hdt-tab-link');
    this.tabs = this.querySelectorAll('.hdt-tab-content');
    this.addAllListeners();
  }

  addAllListeners() {
    this.links.forEach(link => {
      link.addEventListener('click', () => {
        const tabName = link.getAttribute('data-filter');
        if (tabName === 'all') {
          this.openAllTabs();
        } else {
          this.openTab(tabName);
        }
        this.links.forEach(item => {
          item.classList.remove('is--active');
        });
        if (!link.classList.contains('is--active')) {
          link.classList.add('is--active');
        }
      });
    });
  }

  openAllTabs() {
    this.tabs.forEach(content => {
      content.style.display = 'block';
      content.style.height = 'auto';
    });
    this.querySelector('[data-filter="all"]').classList.add('is--active');
  }

  openTab(tabName) {
    this.tabs.forEach(content => {
      if (content.id === tabName) {
        content.style.display = 'block';
        content.classList.add('slideInRight');
      } else {
        content.style.display = 'none';
        content.classList.remove('slideInRight');
      }
    });
  }

  connectedCallback() {
    this.addAllListeners();
  }
  disconnectedCallback() {
  }
}

customElements.define('tabs-brands', TabsBrands);




/* Copy share link (global, single init) */
(function () {
  if (window.__COPY_SHARE_INIT__) return;
  window.__COPY_SHARE_INIT__ = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-share]');
    if (!btn) return; // نكمل لو الضغط على زر نسخ
    e.preventDefault();

    var url = btn.getAttribute('data-copy-share') || btn.getAttribute('href') || '';
    if (!url) return;

    // عنصر التولتيب الصغير بجانب الزر (اختياري)
    var tip = btn.closest('li') ? btn.closest('li').querySelector('[data-copied]') : null;

    // كشف اللغة من <html lang> أو من البادئة /en
    var lang = (document.documentElement.lang || '').toLowerCase();
    var isEn = lang.startsWith('en') || location.pathname.startsWith('/en');
    var copiedTxt = isEn ? 'Copied!' : 'تم النسخ!';
    var promptMsg = isEn ? 'Copy the link:' : 'انسخ الرابط:';

    // حاول النسخ عبر Clipboard API ثم أظهر رسالة صغيرة
    var doShowTip = function () {
      if (!tip) return;
      tip.textContent = copiedTxt;
      tip.hidden = false;
      setTimeout(function () { tip.hidden = true; }, 1200);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(doShowTip).catch(function () {
        try { window.prompt(promptMsg, url); } catch (_) {}
      });
    } else {
      // fallback للمتصفحات القديمة
      try { window.prompt(promptMsg, url); } catch (_) {}
    }
  });
})();

/* Beauty Time progressive product images.
 * Product-card images request only when they approach the viewport. Secondary
 * images wait for an actual hover/focus/touch intent. The intrinsic dimensions
 * remain in the markup, so the layout never jumps while an image is pending. */
(() => {
  const selector = 'img[data-bt-progressive-image][data-bt-src]';
  const managedSelector = 'img[data-bt-image-loading]:not([data-bt-progressive-image])';
  const prepared = new WeakSet();
  const animations = new WeakMap();
  const clockTimers = new WeakMap();
  let lottiePromise = null;
  let clockDataPromise = null;

  const imageObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          imageObserver.unobserve(entry.target);
          loadImage(entry.target);
        });
      }, { rootMargin: '180px 140px', threshold: 0.01 })
    : null;

  const sourceScript = () => document.querySelector('script[data-clock-url][data-lottie-url]');

  const ensureLottie = () => {
    if (window.lottie?.loadAnimation) return Promise.resolve(window.lottie);
    if (lottiePromise) return lottiePromise;
    const source = sourceScript();
    const url = source?.dataset.lottieUrl;
    if (!url) return Promise.reject(new Error('Lottie runtime URL is unavailable'));

    lottiePromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-bt-lottie-runtime]');
      const script = existing || document.createElement('script');
      const ready = () => window.lottie?.loadAnimation
        ? resolve(window.lottie)
        : reject(new Error('Lottie runtime failed to initialize'));
      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', reject, { once: true });
      if (!existing) {
        script.src = url;
        script.defer = true;
        script.dataset.btLottieRuntime = '';
        document.head.appendChild(script);
      }
    }).catch((error) => {
      lottiePromise = null;
      throw error;
    });
    return lottiePromise;
  };

  const ensureClockData = () => {
    if (clockDataPromise) return clockDataPromise;
    const url = sourceScript()?.dataset.clockUrl;
    if (!url) return Promise.reject(new Error('Clock animation URL is unavailable'));
    clockDataPromise = fetch(url, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Clock animation request failed: ${response.status}`);
        return response.json();
      })
      .catch((error) => {
        clockDataPromise = null;
        throw error;
      });
    return clockDataPromise;
  };

  const loadingContainer = (image) => {
    if (image.classList.contains('hdt-card-product__media--hover')) return null;
    return image.closest([
      '.hdt-card-product__media-wrapp',
      '.hdt-product__media',
      '.hdt-mini-cart__img',
      '.hdt-page-cart__img',
      '.hdt-minicart-recommendations__item--image > a'
    ].join(',')) || image.parentElement;
  };

  const createLoader = (image) => {
    const wrapper = loadingContainer(image);
    if (!wrapper) return null;
    let loader = wrapper.querySelector(':scope > .bt-product-image-loader');
    if (!loader) {
      loader = document.createElement('span');
      loader.className = 'bt-product-image-loader';
      if (wrapper.matches('.hdt-product__media')) loader.classList.add('bt-product-image-loader--media');
      if (wrapper.matches('.hdt-mini-cart__img, .hdt-page-cart__img, .hdt-minicart-recommendations__item--image > a')) {
        loader.classList.add('bt-product-image-loader--small');
      }
      loader.setAttribute('aria-hidden', 'true');
      const canvas = document.createElement('span');
      canvas.className = 'bt-product-image-loader__clock';
      loader.appendChild(canvas);
      wrapper.appendChild(loader);
    }
    wrapper.classList.add('bt-product-image-is-loading');
    return loader;
  };

  const mountClock = async (loader) => {
    if (!loader || animations.has(loader)) return;
    try {
      const [lottie, animationData] = await Promise.all([ensureLottie(), ensureClockData()]);
      if (!loader.isConnected || animations.has(loader)) return;
      const data = typeof structuredClone === 'function'
        ? structuredClone(animationData)
        : JSON.parse(JSON.stringify(animationData));
      const animation = lottie.loadAnimation({
        container: loader.firstElementChild,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: data,
        rendererSettings: { preserveAspectRatio: 'xMidYMid meet', progressiveLoad: true }
      });
      animations.set(loader, animation);
      loader.hidden = false;
    } catch (_) {
      /* The reserved image space stays stable even if animation loading fails. */
    }
  };

  const clearLoader = (image) => {
    const wrapper = loadingContainer(image);
    const loader = wrapper?.querySelector(':scope > .bt-product-image-loader');
    const timer = clockTimers.get(image);
    if (timer) window.clearTimeout(timer);
    clockTimers.delete(image);
    wrapper?.classList.remove('bt-product-image-is-loading');
    if (!loader) return;
    if (loader.hidden) {
      loader.remove();
      return;
    }
    loader.classList.add('is-leaving');
    window.setTimeout(() => {
      const animation = animations.get(loader);
      animation?.destroy?.();
      animations.delete(loader);
      loader.remove();
    }, 140);
  };

  const revealImage = (image) => {
    if (image.dataset.btImageLoaded === 'true') return;
    image.dataset.btImageLoaded = 'true';
    image.classList.add('bt-product-image-loaded');
    image.style.removeProperty('opacity');
    image.style.removeProperty('color');
    if (image.classList.contains('hdt-card-product__media--hover')) {
      const card = image.closest('.hdt-card-product');
      const main = card?.querySelector('.hdt-card-product__media--main');
      card?.classList.remove('bt-secondary-image-pending');
      main?.style.removeProperty('opacity');
    }
    clearLoader(image);
  };

  const failImage = (image) => {
    if (image.dataset.btImageFailed === 'true') return;
    image.dataset.btImageFailed = 'true';
    image.classList.add('bt-product-image-failed');
    image.style.setProperty('opacity', '0', 'important');
    image.style.setProperty('color', 'transparent', 'important');
    const wrapper = loadingContainer(image);
    wrapper?.classList.add('bt-product-image-load-failed');
    clearLoader(image);
  };

  const scheduleClock = (image, loader) => {
    if (!loader || clockTimers.has(image)) return;
    loader.hidden = true;
    const timer = window.setTimeout(() => {
      clockTimers.delete(image);
      if (image.dataset.btImageLoaded === 'true' || image.dataset.btImageFailed === 'true') return;
      mountClock(loader);
    }, 180);
    clockTimers.set(image, timer);
  };

  function loadImage(image) {
    if (!image?.isConnected || image.dataset.btImageRequested === 'true') return;
    const source = image.dataset.btSrc;
    if (!source) return;

    image.dataset.btImageRequested = 'true';
    image.loading = 'eager';
    image.fetchPriority = image.classList.contains('hdt-card-product__media--main') ? 'auto' : 'low';
    const loader = createLoader(image);
    scheduleClock(image, loader);

    image.addEventListener('load', () => revealImage(image), { once: true });
    image.addEventListener('error', () => failImage(image), { once: true });
    if (image.dataset.btSrcset) image.srcset = image.dataset.btSrcset;
    image.src = source;
    if (image.complete && image.naturalWidth > 1) revealImage(image);
  }

  const prepareImage = (image) => {
    if (!image?.matches?.(selector) || prepared.has(image)) return;
    prepared.add(image);
    image.style.setProperty('opacity', '0', 'important');
    image.style.setProperty('color', 'transparent', 'important');

    if (image.classList.contains('hdt-card-product__media--hover')) {
      image.closest('.hdt-card-product')?.classList.add('bt-secondary-image-pending');
      return;
    }

    if (imageObserver) imageObserver.observe(image);
    else loadImage(image);
  };

  const prepareManagedImage = (image) => {
    if (!image?.matches?.(managedSelector) || prepared.has(image)) return;
    prepared.add(image);
    image.style.setProperty('color', 'transparent', 'important');

    if (image.complete && image.naturalWidth > 0) {
      image.dataset.btImageLoaded = 'true';
      image.classList.add('bt-product-image-loaded');
      image.style.removeProperty('color');
      return;
    }

    image.style.setProperty('opacity', '0', 'important');
    const loader = createLoader(image);
    scheduleClock(image, loader);
    image.addEventListener('load', () => revealImage(image), { once: true });
    image.addEventListener('error', () => failImage(image), { once: true });
  };

  const scan = (root = document) => {
    if (root.matches?.(selector)) prepareImage(root);
    if (root.matches?.(managedSelector)) prepareManagedImage(root);
    root.querySelectorAll?.(selector).forEach(prepareImage);
    root.querySelectorAll?.(managedSelector).forEach(prepareManagedImage);
  };

  const loadSecondaryFromIntent = (event) => {
    const card = event.target?.closest?.('.hdt-card-product');
    const image = card?.querySelector('.hdt-card-product__media--hover[data-bt-progressive-image]');
    if (!image || image.dataset.btImageLoaded === 'true') return;
    const main = card.querySelector('.hdt-card-product__media--main');
    if (main && main.dataset.btImageLoaded !== 'true') return;
    card.classList.add('bt-secondary-image-pending');
    main?.style.setProperty('opacity', '1', 'important');
    loadImage(image);
  };

  window.BTProductImages = { load: loadImage, scan };
  scan(document);
  ['pointerover', 'pointerdown', 'focusin'].forEach((eventName) => {
    document.addEventListener(eventName, loadSecondaryFromIntent, true);
  });
  ['products:update', 'cart:drawer:render', 'shopify:section:load', 'quick-view:loaded', 'quick-add:loaded'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => scan(event.target));
  });
})();

/* Beauty Time product-card secondary image preview for touch devices. */
(() => {
  const cardSelector = ".hdt-card-product.bt-card-promax";
  const mediaLinkSelector = `${cardSelector} .hdt-card-product__media-wrapp`;
  let activeCard = null;
  let gesture = null;
  let suppressedLink = null;
  let suppressClickUntil = 0;

  const clearPreview = () => {
    if (!activeCard) return;
    activeCard.classList.remove("bt-touch-secondary");
    activeCard = null;
  };

  const prepareSecondaryImage = (card) => {
    const image = card?.querySelector(".hdt-card-product__media--hover");
    if (!image) return null;
    if (window.BTProductImages?.load && image.hasAttribute('data-bt-progressive-image')) {
      window.BTProductImages.load(image);
    } else {
      image.loading = "eager";
      if (!image.getAttribute("src") && image.dataset.src) image.src = image.dataset.src;
    }
    image.closest("picture")?.querySelectorAll("source[data-srcset]").forEach((source) => {
      if (!source.srcset) source.srcset = source.dataset.srcset;
    });
    if (typeof image.decode === "function") image.decode().catch(() => {});
    return image;
  };

  const togglePreview = (card) => {
    const showSecondary = !card.classList.contains("bt-touch-secondary");
    clearPreview();
    if (!showSecondary) return;
    activeCard = card;
    card.classList.add("bt-touch-secondary");
  };

  document.addEventListener("pointerdown", (event) => {
    if (event.pointerType !== "touch" && event.pointerType !== "pen") return;
    const mediaLink = event.target.closest?.(mediaLinkSelector);
    if (!mediaLink) return;

    const card = mediaLink.closest(cardSelector);
    if (!prepareSecondaryImage(card)) return;
    gesture = {
      pointerId: event.pointerId,
      mediaLink,
      card,
      startX: event.clientX,
      startY: event.clientY,
      swiped: false
    };
  }, true);

  document.addEventListener("pointermove", (event) => {
    if (!gesture || event.pointerId !== gesture.pointerId || gesture.swiped) return;
    const deltaX = event.clientX - gesture.startX;
    const deltaY = event.clientY - gesture.startY;
    const horizontalDistance = Math.abs(deltaX);
    const verticalDistance = Math.abs(deltaY);

    if (horizontalDistance < 24 || horizontalDistance <= verticalDistance * 1.15) return;

    gesture.swiped = true;
    suppressedLink = gesture.mediaLink;
    suppressClickUntil = performance.now() + 650;
    event.preventDefault();
    togglePreview(gesture.card);
  }, { capture: true, passive: false });

  const finishGesture = (event) => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    if (gesture.swiped) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    gesture = null;
  };

  document.addEventListener("pointerup", finishGesture, true);
  document.addEventListener("pointercancel", () => {
    gesture = null;
  }, true);

  document.addEventListener("click", (event) => {
    const mediaLink = event.target.closest?.(mediaLinkSelector);
    if (
      mediaLink &&
      mediaLink === suppressedLink &&
      performance.now() < suppressClickUntil
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressedLink = null;
      return;
    }

    /* A normal tap is never intercepted: it follows the product link. */
    if (!mediaLink) clearPreview();
  }, true);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") clearPreview();
  });
  window.addEventListener("pageshow", clearPreview);
})();

/* Predictive search replaces its results without a Shopify section event.
 * Re-emit the lightweight product update event only when new rating badges
 * are actually inserted so their values are hydrated immediately. */
(() => {
  let queuedRoot = null;
  let frame = 0;

  const queueRatings = (root) => {
    queuedRoot = root;
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const target = queuedRoot;
      queuedRoot = null;
      if (target?.isConnected) {
        target.dispatchEvent(new CustomEvent("products:update", { bubbles: true }));
      }
    });
  };

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        window.BTProductImages?.scan?.(node);
        if (node.matches?.("[data-bt-rating]") || node.querySelector?.("[data-bt-rating]")) {
          queueRatings(
            node.closest?.(".hdt-search-content, .hdt-search-results-list, .hdt-search-products") ||
            node.parentElement ||
            node
          );
          return;
        }
      }
    }
  });

  const start = () => observer.observe(document.body, { subtree: true, childList: true });
  if (document.body) start();
  else document.addEventListener("DOMContentLoaded", start, { once: true });
})();

/* Chrome responsive-mode tap bridge. A real click always wins; the fallback
 * runs once only when touch/pen pointerup is not followed by a click. */
(() => {
  const tapTargetSelector = [
    ".bt-card-promax__add .hdt-card-product__btn-ultra",
    "a.hdt-loamore-btn"
  ].join(",");
  const coarsePointer = window.matchMedia("(pointer: coarse)");
  let pendingTap = null;
  const fallbackTimes = new WeakMap();

  document.addEventListener("pointerdown", (event) => {
    const target = event.target.closest?.(tapTargetSelector);
    const touchLike = event.pointerType === "touch" || event.pointerType === "pen" || coarsePointer.matches;
    if (!target || !touchLike) {
      pendingTap = null;
      return;
    }

    pendingTap = {
      target,
      pointerId: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      clicked: false
    };
  }, true);

  document.addEventListener("click", (event) => {
    const target = event.target.closest?.(tapTargetSelector);
    if (!target) return;

    const fallbackAt = fallbackTimes.get(target) || 0;
    if (event.isTrusted && fallbackAt && performance.now() - fallbackAt < 700) {
      fallbackTimes.delete(target);
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (pendingTap?.target === target) pendingTap.clicked = true;
  }, true);

  document.addEventListener("pointerup", (event) => {
    const tap = pendingTap;
    pendingTap = null;
    if (!tap || tap.pointerId !== event.pointerId) return;
    if (Math.hypot(event.clientX - tap.x, event.clientY - tap.y) > 12) return;

    window.setTimeout(() => {
      if (tap.clicked || !tap.target.isConnected) return;
      if (tap.target.matches(":disabled, [aria-disabled='true']")) return;
      if (tap.target.closest("[loadmore-btn-wrapp][loading]")) return;

      fallbackTimes.set(tap.target, performance.now());
      tap.target.click();
    }, 90);
  }, true);

  document.addEventListener("pointercancel", () => {
    pendingTap = null;
  }, true);
})();

/* Beauty Time product-image deterrence.
 * This protects normal browser interactions without interfering with product
 * links, zoom, quick view, keyboard navigation, or responsive image loading. */
(function () {
  var protectedImageSelector = [
    '.hdt-card-product img',
    'hdt-product-media img',
    '.hdt-product-media img',
    '.hdt-product__media img',
    '[data-media-type="image"] img',
    'a[href*="/products/"] img',
    '.bt-match-product img',
    '.bt-account-review-product__image img',
    '.bt-account-review-sheet__image img',
    '.bt-order-thumb',
    '.hdt-mini-cart__img img',
    '.hdt-page-cart__img img'
  ].join(',');

  function protectedImage(target) {
    var image = target && target.closest ? target.closest('img') : null;
    return image && image.matches(protectedImageSelector) ? image : null;
  }

  function markImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(protectedImageSelector).forEach(function (image) {
      image.draggable = false;
      image.setAttribute('draggable', 'false');
      image.setAttribute('data-bt-image-protected', '');
    });
  }

  document.addEventListener('contextmenu', function (event) {
    if (!protectedImage(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  document.addEventListener('dragstart', function (event) {
    if (!protectedImage(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  document.addEventListener('pointerdown', function (event) {
    var image = protectedImage(event.target);
    if (image && image.draggable) image.draggable = false;
  }, true);

  function initializeImageProtection() {
    markImages(document);
    ['products:update', 'quick-view:loaded', 'cart:drawer:render', 'shopify:section:load'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        window.requestAnimationFrame(function () { markImages(event.target); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeImageProtection, { once: true });
  } else {
    initializeImageProtection();
  }
})();



/* Mobile-safe openCart handler: add items, refresh drawer section, then open */
(function () {
  function run() {
    try {
      var qs = new URLSearchParams(location.search || '');
      var hs = new URLSearchParams((location.hash || '').replace(/^#/, ''));
      var shouldOpen = (qs.get('openCart') === '1') || (hs.get('openCart') === '1');
      var itemsStr = qs.get('i') || hs.get('i');
      if (!shouldOpen || !itemsStr) return;

      var mode = (qs.get('m') || hs.get('m') || 'replace').toLowerCase();
      if (mode !== 'append') mode = 'replace';

      // Parse "id:qty,id:qty"
      var pairs = itemsStr.split(',').map(function (s) { return s.trim(); }).filter(Boolean).map(function (p) {
        var a = p.split(':');
        var id = Number(a[0]);
        var q = Number(a[1] || 1);
        return { id: id, quantity: q > 0 ? q : 1 };
      }).filter(function (it) { return it.id > 0 && it.quantity > 0; });

      if (!pairs.length) return;

      function stripParams() {
        try {
          var url = new URL(location.href);
          url.searchParams.delete('openCart');
          url.searchParams.delete('i');
          url.searchParams.delete('m');
          var hashParams = new URLSearchParams((url.hash || '').replace(/^#/, ''));
          hashParams.delete('openCart');
          hashParams.delete('i');
          hashParams.delete('m');
          var cleanSearch = url.searchParams.toString();
          var cleanHash = hashParams.toString();
          history.replaceState(
            {},
            '',
            url.pathname +
              (cleanSearch ? '?' + cleanSearch : '') +
              (cleanHash ? '#' + cleanHash : '')
          );
        } catch (_) { /* noop */ }
      }

      async function clearCart() {
        if (mode !== 'replace') return;
        var response = await fetch(Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('Unable to clear cart');
      }

      async function addAll() {
        var response = await fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: pairs })
        });
        if (!response.ok) throw new Error('Unable to restore shared cart');
      }

      async function refreshDrawerSection() {
        var root = document.querySelector('hdt-cart-drawer');
        if (!root) return;
        var sid = root.getAttribute('section-id');
        if (!sid) return;

        var res = await fetch(Shopify.routes.root + '?section_id=' + encodeURIComponent(sid), {
          method: 'GET',
          headers: { 'Accept': 'text/html,*/*' },
          credentials: 'same-origin'
        });
        if (!res.ok) return;
        var html = await res.text();
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        // القسم يرجع بنفس هيكل <hdt-cart-drawer> في ملف القسم
        var fresh = wrap.querySelector('hdt-cart-drawer');
        if (fresh) {
          root.replaceWith(fresh);
        }
      }

      function openDrawer() {
        var root = document.querySelector('hdt-cart-drawer');
        var dlg = document.getElementById('CartDrawer');
        try {
          // لو الثيم موفّر method
          if (root && typeof root.open === 'function') { root.open(); return; }
          // fallback لعنصر <dialog>
          if (dlg && typeof dlg.showModal === 'function' && !dlg.open) { dlg.showModal(); }
        } catch (e) { /* noop */ }
      }

      (async function () {
        // امسح معلمات المشاركة فورًا كي لا تتكرر الكميات إذا أُعيد تحميل الصفحة أثناء الطلب.
        stripParams();

        // على الجوال: انتظر تهيئة الـcustom element
        if (window.customElements && customElements.whenDefined) {
          try { await customElements.whenDefined('hdt-cart-drawer'); } catch (_) { }
        }

        await clearCart();
        await addAll();

        // مهلة صغيرة للجوال ثم إعادة رسم القسم من الخادم
        var isMobile = matchMedia('(max-width: 768px)').matches;
        if (isMobile) { await new Promise(function (r) { return setTimeout(r, 200); }); }
        await refreshDrawerSection();
        if (isMobile) { await new Promise(function (r) { return setTimeout(r, 60); }); }

        openDrawer();
      })().catch(function (error) {
        console.warn('[openCart mobile-safe] error:', error);
      });
    } catch (e) {
      // في حال أي خطأ، لا نعلّق الواجهة
      console.warn('[openCart mobile-safe] error:', e);
    }
  }

  // شغّل بعد تحميل الـDOM (ومتوافق مع بعض الـPJAX/instant)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();


document.addEventListener('click', function (e) {
  var link = e.target.closest('a[data-bt-native-share], a.hdt-social-whatsapp');
  if (!link || typeof navigator.share !== 'function') return;

  var shareData = {};
  var explicitNativeShare = link.hasAttribute('data-bt-native-share');

  if (explicitNativeShare) {
    var title = link.getAttribute('data-bt-share-title') || document.title || '';
    var text = link.getAttribute('data-bt-share-text') || '';
    var shareUrl = link.getAttribute('data-bt-share-url') || '';

    if (shareUrl) {
      try { shareUrl = new URL(shareUrl, window.location.href).href; }
      catch (_) { shareUrl = ''; }
    }
    if (title) shareData.title = title;
    if (text) shareData.text = text;
    if (shareUrl) shareData.url = shareUrl;
  } else {
    // Preserve native sharing for older WhatsApp share buttons that already
    // carry their complete message in the fallback URL.
    try {
      var legacyText = new URL(link.href, window.location.href).searchParams.get('text') || '';
      if (legacyText) shareData.text = legacyText;
    } catch (_) { /* Leave the ordinary link untouched. */ }
  }

  if (!shareData.title && !shareData.text && !shareData.url) return;
  if (typeof navigator.canShare === 'function' && !navigator.canShare(shareData)) return;

  e.preventDefault();
  var fallbackUrl = link.href;
  try {
    Promise.resolve(navigator.share(shareData)).catch(function (error) {
      if (error && error.name === 'AbortError') return;
      window.location.assign(fallbackUrl);
    });
  } catch (_) {
    window.location.assign(fallbackUrl);
  }
}, { passive: false });






document.addEventListener("DOMContentLoaded", async () => {
  const url = new URL(window.location.href);
  const p   = url.searchParams;

  // 🛒 المرحلة 1: إضافة المنتج
  if (p.get("autocart") === "1") {
    const id  = document.querySelector('input[name="id"]')?.value || p.get("variant");
    const qty = parseInt(p.get("qty") || "1", 10);
    if (id) {
      await fetch("/cart/add.js", {
        method:"POST",
        headers:{ "Content-Type":"application/json" },
        body:JSON.stringify({ id, quantity:qty })
      });
      p.delete("autocart"); p.set("show_cart","1");
      return location.href = url.toString();
    }
  }

  // 🛒 المرحلة 2: فتح الدراور
  if (p.get("show_cart") === "1") {
    const open = () => {
      const root = document.querySelector("hdt-cart-drawer");
      if (root?.open) root.open();
      else document.getElementById("CartDrawer")?.showModal?.();
    };
    setTimeout(open, 400); // تأخير بسيط
    p.delete("show_cart");
    history.replaceState({}, "", url);
  }
});





(function(){
  // === Helpers ===
  function getDrawerSectionId(){
    var el = document.querySelector('hdt-cart-drawer[section-id]');
    return el ? el.getAttribute('section-id') : null;
  }
  function fetchSectionDoc(secId){
    var url = window.location.pathname + '?sections=' + encodeURIComponent(secId);
    return fetch(url, {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(json){
        var html = json && json[secId]; if(!html) throw new Error('no section html');
        return (new DOMParser()).parseFromString(html, 'text/html');
      });
  }
  function swapFromDoc(selector, freshDoc){
    var curr = document.querySelector(selector);
    var fresh = freshDoc.querySelector(selector);
    if (curr && fresh) { curr.replaceWith(fresh); }
  }

  // تحديث جزئي داخل الدروار بدون إغلاقه
  function updateDrawerPartials(){
    var secId = getDrawerSectionId();
    if(!secId) { return Promise.resolve(); }
    var scroller = document.querySelector('#CartDrawer .hdt-mini-cart__sroll');
    var scrollTop = scroller ? scroller.scrollTop : 0;

    return fetchSectionDoc(secId).then(function(doc){
      // حدّث منطقة الخصومات + المجموع
      swapFromDoc('#CartDrawer .hdt-cart-totals-discounts', doc);
      // وحدّث الـ payment terms (لأن فيها [data-cart-subtotal])
      swapFromDoc('#CartDrawer .hdt-cart-payment-terms', doc);

      // أرجع نفس موضع التمرير
      var newScroller = document.querySelector('#CartDrawer .hdt-mini-cart__sroll');
      if(newScroller) newScroller.scrollTop = scrollTop;
    }).catch(function(){
      // احتياط: لا نغلق الدروار، ولا نعمل reload
    });
  }

  // إزالة كل الأكواد عبر Ajax (بدون ريفرش)
  function removeAllDiscounts(btn){
    if(btn){ btn.disabled = true; btn.setAttribute('aria-busy','true'); }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      credentials:'same-origin',
      body: JSON.stringify({ discount: '' })
    })
    .then(function(r){ return r.json(); })
    .then(function(){ return updateDrawerPartials(); })
    .catch(function(){ /* تجاهل الأخطاء بدون إغلاق الدروار */ });
  }

  // التقط الضغط على زر الإلغاء ومنع أي Overlay ياخذ الكليك
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest && e.target.closest('.hdt-discount-remove');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    removeAllDiscounts(btn);
  }, true); // useCapture=true
})();






/* Beauty Time: pair EasySell with a safe Shopify checkout proxy on desktop. */
(function () {
  if (window.__btCartDesktopPaymentPair) return;

  var desktopQuery = window.matchMedia('(min-width: 1150px)');
  var nativeCheckout = null;
  var activeGroup = null;
  var activeActions = null;
  var checkoutProxy = null;
  var scheduledFrame = 0;

  function cartActions() {
    var page = document.getElementById('hdt-page-cart');
    return page && page.querySelector('[data-bt-cart-checkout-actions]');
  }

  function removePaymentPair() {
    if (activeGroup) {
      activeGroup.classList.remove('bt-cart-desktop-payment-pair');
      activeGroup = null;
    }
    if (activeActions) {
      activeActions.classList.remove('bt-cart-payment-pair-is-active');
      activeActions = null;
    }
    if (checkoutProxy) {
      checkoutProxy.remove();
      checkoutProxy = null;
    }
  }

  function createCheckoutProxy() {
    var proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.className = 'bt-cart-shopify-proxy hdt-btn hdt-font-semibold';
    proxy.setAttribute('data-bt-shopify-checkout-proxy', '');
    proxy.addEventListener('click', function (event) {
      event.preventDefault();
      if (nativeCheckout && nativeCheckout.isConnected && !nativeCheckout.disabled) {
        nativeCheckout.click();
      }
    });
    return proxy;
  }

  function syncCheckoutProxy() {
    if (!checkoutProxy || !nativeCheckout) return;
    var label = (nativeCheckout.textContent || '').replace(/\s+/g, ' ').trim();
    if (!label) {
      label = document.documentElement.lang.toLowerCase().indexOf('ar') === 0
        ? 'إتمام الدفع عبر شوبيفاي'
        : 'Shopify checkout';
    }
    if (checkoutProxy.textContent !== label) {
      checkoutProxy.textContent = label;
    }
    checkoutProxy.disabled = !!nativeCheckout.disabled;
    checkoutProxy.setAttribute(
      'aria-label',
      nativeCheckout.getAttribute('aria-label') || label
    );
  }

  function syncPaymentPair() {
    scheduledFrame = 0;

    var actions = cartActions();
    nativeCheckout = actions && actions.querySelector('[data-bt-native-checkout]');

    var pageEasySellButton = document.querySelector('#hdt-page-cart #es-form-button');
    var easySellButton = pageEasySellButton || Array.from(document.querySelectorAll('#es-form-button')).find(function (button) {
      return !button.closest('[hidden]') && button.getClientRects().length > 0;
    });
    var easySellGroup = easySellButton && easySellButton.closest('.es-cta-group');

    if (!desktopQuery.matches || !nativeCheckout || !easySellGroup) {
      removePaymentPair();
      return;
    }

    if (activeGroup && activeGroup !== easySellGroup) {
      removePaymentPair();
    }

    activeGroup = easySellGroup;
    activeActions = actions;
    activeGroup.classList.add('bt-cart-desktop-payment-pair');
    activeActions.classList.add('bt-cart-payment-pair-is-active');
    if (!checkoutProxy) {
      checkoutProxy = createCheckoutProxy();
    }
    syncCheckoutProxy();
    if (checkoutProxy.parentElement !== activeGroup) {
      activeGroup.appendChild(checkoutProxy);
    }
  }

  function schedulePaymentPair() {
    if (scheduledFrame) return;
    scheduledFrame = window.requestAnimationFrame(syncPaymentPair);
  }

  function startPaymentPair() {
    if (!document.getElementById('hdt-page-cart')) return;

    schedulePaymentPair();

    [250, 700, 1500, 3000, 6000].forEach(function (delay) {
      window.setTimeout(schedulePaymentPair, delay);
    });

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', schedulePaymentPair);
    } else {
      desktopQuery.addListener(schedulePaymentPair);
    }

    [
      'cart:update',
      'cart:reload',
      'cart:main:render',
      'shopify:section:load'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, schedulePaymentPair);
    });
  }

  window.__btCartDesktopPaymentPair = { refresh: schedulePaymentPair };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPaymentPair, { once: true });
  } else {
    startPaymentPair();
  }
})();

/* Beauty Time: clear the entire cart with one lightweight Ajax request. */
(() => {
  'use strict';
  if (window.__btClearCartReady) return;
  window.__btClearCartReady = true;
  const clearConfirmTimers = new WeakMap();
  const clearOriginalLabels = new WeakMap();

  async function clearEntireCart(button) {
    const rootUrl = window.Shopify?.routes?.root || '/';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${rootUrl}cart/clear.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({})
      });
      if (!response.ok) throw new Error(`Cart clear failed: ${response.status}`);

      await response.json().catch(() => null);
      document.querySelectorAll('hdt-cart-count').forEach((count) => {
        count.textContent = '0';
      });
      setClearButtonsVisibility(0);
      window.location.assign(rootUrl);
    } catch (error) {
      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      const isArabic = document.documentElement.lang.toLowerCase().startsWith('ar');
      window.alert(isArabic
        ? 'تعذر إفراغ السلة الآن. يرجى المحاولة مرة أخرى.'
        : 'The cart could not be cleared. Please try again.');
    }
  }

  function setClearButtonsVisibility(itemCount) {
    const hasItems = Number(itemCount) > 0;
    document.querySelectorAll('[data-bt-clear-cart]').forEach((button) => {
      button.hidden = !hasItems;
    });
  }

  function createLiveCartProduct(item, quantityLabel) {
    const product = document.createElement('article');
    product.className = 'bt-clear-cart-modal__product';
    product.setAttribute('role', 'listitem');

    const imageWrap = document.createElement('span');
    imageWrap.className = 'bt-clear-cart-modal__image';
    const imageUrl = item.image || item.featured_image?.url || '';
    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = item.product_title || item.title || '';
      image.width = 120;
      image.height = 120;
      image.loading = 'lazy';
      image.decoding = 'async';
      imageWrap.appendChild(image);
    }

    const copy = document.createElement('span');
    copy.className = 'bt-clear-cart-modal__product-copy';
    const title = document.createElement('strong');
    title.textContent = item.product_title || item.title || '';
    copy.appendChild(title);
    if (item.variant_title && item.variant_title !== 'Default Title') {
      const variant = document.createElement('small');
      variant.textContent = item.variant_title;
      copy.appendChild(variant);
    }

    const quantity = document.createElement('span');
    quantity.className = 'bt-clear-cart-modal__quantity';
    quantity.appendChild(document.createTextNode(`${quantityLabel} `));
    const quantityValue = document.createElement('bdi');
    quantityValue.textContent = String(item.quantity || 1);
    quantity.appendChild(quantityValue);

    product.append(imageWrap, copy, quantity);
    return product;
  }

  function renderLiveCart(modal, cartData) {
    if (!modal || !cartData) return;
    const products = modal.querySelector('.bt-clear-cart-modal__products');
    if (!products) return;
    const quantityLabel = modal.dataset.btCartQtyLabel ||
      (document.documentElement.lang.toLowerCase().startsWith('ar') ? 'الكمية' : 'Qty');
    const fragment = document.createDocumentFragment();
    (cartData.items || []).forEach((item) => {
      fragment.appendChild(createLiveCartProduct(item, quantityLabel));
    });
    products.replaceChildren(fragment);
    setClearButtonsVisibility(cartData.item_count);
  }

  async function fetchLiveCart(signal) {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootUrl}cart.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
      signal
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  }

  async function refreshClearCartModal(modal) {
    if (!modal) return null;
    modal.__btCartAbortController?.abort();
    const controller = new AbortController();
    modal.__btCartAbortController = controller;
    try {
      const cartData = await fetchLiveCart(controller.signal);
      if (!modal.isConnected || controller.signal.aborted) return null;
      renderLiveCart(modal, cartData);
      return cartData;
    } finally {
      if (modal.__btCartAbortController === controller) {
        delete modal.__btCartAbortController;
      }
    }
  }

  function restoreClearButton(button) {
    const original = clearOriginalLabels.get(button);
    const label = button.querySelector('span:not(.bt-clock-canvas)');
    if (original && label) label.textContent = original.text;
    if (original?.ariaLabel) button.setAttribute('aria-label', original.ariaLabel);
    if (original?.title) button.setAttribute('title', original.title);
    else button.removeAttribute('title');
    button.classList.remove('is-confirming');
    delete button.dataset.confirming;
    const timer = clearConfirmTimers.get(button);
    if (timer) window.clearTimeout(timer);
    clearConfirmTimers.delete(button);
  }

  function requestClearConfirmation(button, isArabic) {
    const label = button.querySelector('span:not(.bt-clock-canvas)');
    clearOriginalLabels.set(button, {
      text: label?.textContent || '',
      ariaLabel: button.getAttribute('aria-label') || '',
      title: button.getAttribute('title') || ''
    });
    if (label) label.textContent = isArabic ? 'تأكيد الحذف' : 'Confirm clear';
    button.setAttribute('aria-label', isArabic ? 'اضغطي مرة أخرى لتأكيد حذف الكل' : 'Press again to confirm clearing the cart');
    button.setAttribute('title', isArabic ? 'اضغطي مرة أخرى للتأكيد' : 'Press again to confirm');
    button.dataset.confirming = 'true';
    button.classList.add('is-confirming');
    clearConfirmTimers.set(button, window.setTimeout(() => restoreClearButton(button), 4200));
  }

  function closeClearCartModal(modal, restoreFocus) {
    if (!modal) return;
    const trigger = modal.__btClearCartTrigger;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    delete modal.__btClearCartTrigger;
    if (restoreFocus && trigger?.isConnected) trigger.focus({ preventScroll: true });
  }

  async function openClearCartModal(button) {
    const scope = button.closest('#CartDrawer, #hdt-page-cart');
    const modal = scope?.querySelector('[data-bt-clear-cart-modal]');
    if (!modal) return false;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    let cartData = null;
    try {
      cartData = await refreshClearCartModal(modal);
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('[Beauty Time cart] Unable to refresh clear-cart list.', error);
    } finally {
      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }

    if (cartData && Number(cartData.item_count) < 1) return false;
    if (!modal.isConnected) return false;
    modal.__btClearCartTrigger = button;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => {
      const panel = modal.querySelector('.bt-clear-cart-modal__panel');
      const cancel = modal.querySelector('.bt-clear-cart-modal__cancel');
      (cancel || panel)?.focus({ preventScroll: true });
    });
    return true;
  }

  let cartControlSyncTimer = 0;
  let cartControlSyncController = null;

  function cartCountFromEvent(event) {
    const detail = event?.detail || {};
    const values = [
      detail.itemCount,
      detail.item_count,
      detail.resource?.item_count,
      detail.cartData?.item_count,
      detail.data?.item_count
    ];
    return values.find((value) => Number.isFinite(Number(value)));
  }

  function scheduleCartControlSync(event) {
    const knownCount = cartCountFromEvent(event);
    if (knownCount !== undefined) {
      setClearButtonsVisibility(knownCount);
      return;
    }

    window.clearTimeout(cartControlSyncTimer);
    cartControlSyncTimer = window.setTimeout(async () => {
      cartControlSyncController?.abort();
      cartControlSyncController = new AbortController();
      const controller = cartControlSyncController;
      try {
        const cartData = await fetchLiveCart(controller.signal);
        if (!controller.signal.aborted) setClearButtonsVisibility(cartData.item_count);
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('[Beauty Time cart] Unable to sync cart controls.', error);
      } finally {
        if (cartControlSyncController === controller) cartControlSyncController = null;
      }
    }, 90);
  }

  ['cart:update', 'cart:reload', 'cart:count:update', 'cart:drawer:render', 'cart:main:render'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleCartControlSync);
  });

  document.addEventListener('click', (event) => {
    const cancel = event.target.closest?.('[data-bt-clear-cart-cancel]');
    if (cancel) {
      event.preventDefault();
      closeClearCartModal(cancel.closest('[data-bt-clear-cart-modal]'), true);
      return;
    }

    const confirm = event.target.closest?.('[data-bt-clear-cart-confirm]');
    if (confirm && !confirm.disabled) {
      event.preventDefault();
      clearEntireCart(confirm);
      return;
    }

    const button = event.target.closest?.('[data-bt-clear-cart]');
    if (!button || button.disabled) return;
    event.preventDefault();

    if (button.hasAttribute('data-bt-clear-cart-dialog') || button.hasAttribute('data-bt-clear-cart-drawer')) {
      openClearCartModal(button);
      return;
    }

    const isArabic = document.documentElement.lang.toLowerCase().startsWith('ar');
    if (button.dataset.confirming !== 'true') {
      requestClearConfirmation(button, isArabic);
      return;
    }
    const timer = clearConfirmTimers.get(button);
    if (timer) window.clearTimeout(timer);
    clearConfirmTimers.delete(button);
    button.classList.remove('is-confirming');
    clearEntireCart(button);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const modal = document.querySelector('[data-bt-clear-cart-modal]:not([hidden])');
    if (!modal) return;
    event.preventDefault();
    event.stopPropagation();
    closeClearCartModal(modal, true);
  }, true);
})();


/* ====== BEGIN: promax additions from NEW theme file ====== */


// ---- Merged from NEW: class ConfettiElement
class ConfettiElement extends HTMLElement {
  constructor() {
      super();
      
      // Globals
      this.canvas = null;
      this.ctx = null;
      this.W = 0;
      this.H = 0;
      this.mp = window.matchMedia('(max-width: 767px)').matches ? 64 : 96;
      this.particles = [];
      this.angle = 0;
      this.tiltAngle = 0;
      this.confettiActive = true;
      this.animationComplete = true;
      this.deactivationTimerHandler = null;
      this.reactivationTimerHandler = null;
      this.animationHandler = null;

      this.whenShow = null;
      this.hideAfterShow = null;
      this.isShow = [];
      
      // Particle colors
      this.particleColors = {
          colorOptions: ["DodgerBlue", "OliveDrab", "Gold", "pink", "SlateBlue", "lightblue", "Violet", "PaleGreen", "SteelBlue", "SandyBrown", "Chocolate", "Crimson"],
          colorIndex: 0,
          colorIncrementer: 0,
          colorThreshold: 10,
          getColor: function () {
              if (this.colorIncrementer >= 10) {
                  this.colorIncrementer = 0;
                  this.colorIndex++;
                  if (this.colorIndex >= this.colorOptions.length) {
                      this.colorIndex = 0;
                  }
              }
              this.colorIncrementer++;
              return this.colorOptions[this.colorIndex];
          }
      };
      
      // Bind methods
      this.handleResize = this.handleResize.bind(this);
  }
  
connectedCallback() {
  this.init();
  this.setupEventListeners();
}

disconnectedCallback() {
  this.cleanup();
  this.removeEventListeners();
}

// Confetti Particle Factory
createConfettiParticle(color) {
  const ctx = this.ctx;
  const W = this.W;
  const H = this.H;
  const mp = this.mp;

  return {
    x: Math.random() * W,
    y: (Math.random() * H) - H,
    r: this.randomFromTo(10, 30),
    d: (Math.random() * mp) + 10,
    color: color,
    tilt: Math.floor(Math.random() * 10) - 10,
    tiltAngleIncremental: (Math.random() * 0.07) + 0.05,
    tiltAngle: 0,

    draw: function() {
      ctx.beginPath();
      ctx.lineWidth = this.r / 2;
      ctx.strokeStyle = this.color;
      ctx.moveTo(this.x + this.tilt + (this.r / 4), this.y);
      ctx.lineTo(this.x + this.tilt, this.y + this.tilt + (this.r / 4));
      return ctx.stroke();
    }
  };
}

init() {
  // Keep the first page render light: create the full-screen canvas only when
  // a reward celebration is actually requested.
  window.addEventListener('resize', this.handleResize);
}

setupEventListeners() {
  this.handleConfettiStart = this.handleConfettiStart.bind(this);
  this.handleConfettiPause = this.handleConfettiPause.bind(this);
  this.handleProgressBarChange = this.handleProgressBarChange.bind(this);
  this.handleCartDrawerClose = this.pause.bind(this);

  document.addEventListener('confetti:start', this.handleConfettiStart);
  document.addEventListener('confetti:pause', this.handleConfettiPause);

  document.addEventListener('progressBarChange', this.handleProgressBarChange);

  this.cartDrawer = document.querySelector('#CartDrawer');
  this.cartDrawer?.addEventListener(dialogClose, this.handleCartDrawerClose);
}

safeShowPopover() {
  try {
    if (typeof this.showPopover === 'function' && !this.matches(':popover-open')) {
      this.showPopover();
    }
  } catch (_) {}
}

safeHidePopover() {
  try {
    if (typeof this.hidePopover === 'function' && this.matches(':popover-open')) {
      this.hidePopover();
    }
  } catch (_) {}
}

removeEventListeners() {
  document.removeEventListener('confetti:start', this.handleConfettiStart);
  document.removeEventListener('confetti:pause', this.handleConfettiPause);
  document.removeEventListener('progressBarChange', this.handleProgressBarChange);

  this.cartDrawer?.removeEventListener(dialogClose, this.handleCartDrawerClose);
}

  handleProgressBarChange(event){
    clearTimeout(this.whenShow);
    clearTimeout(this.hideAfterShow);
    if(this.isShow.length == 1 && parseInt(event.detail.rangeValue) == 1){
      this.handlePauseAnimation();
      return;
    }
    if(parseInt(event.detail.rangeValue) == 1 && this.isShow.length <= 1 ){
      this.safeShowPopover();
      this.start();
      this.isShow.push(event.detail.rangeValue);
    }else{
      this.isShow.pop(1);
    }
    this.handlePauseAnimation();
    // console.log(this.isShow);
  }
  handlePauseAnimation(){
    this.whenShow = setTimeout(() => {
      this.pause();
      this.hideAfterShow = setTimeout(() => {
        this.safeHidePopover();
      }, 5000);
    }, 3000);
  }
  handleConfettiStart(event) {
      // Check if this specific element should respond to the event
    if (event.detail && event.detail.target && event.detail.target !== this) {
        return; // Ignore if targeted at another element
    }
    this.safeShowPopover();
    this.start();
  }
  
  handleConfettiPause(event) {
    clearTimeout(this.whenShow);
    clearTimeout(this.hideAfterShow);
      // Check if this specific element should respond to the event
    if (event.detail && event.detail.target && event.detail.target !== this) {
        return; // Ignore if targeted at another element
    }
    this.pause();
    
    this.hideAfterShow = setTimeout(() => {
      this.safeHidePopover();
    }, 5000);
  }
  
  cleanup() {
    window.removeEventListener('resize', this.handleResize);
    this.removeEventListeners();
    this.clearTimers();
    this.stopConfetti();
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }
  
  handleResize() {
    this.W = window.innerWidth;
    this.H = window.innerHeight;
    if (this.canvas) {
        this.canvas.width = this.W;
        this.canvas.height = this.H;
    }
  }

  setGlobals() {
    // Create canvas if it doesn't exist
    let canvas = this.querySelector('[data-confetti-canvas]');
    if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.setAttribute('data-confetti-canvas', '');
        canvas.style.cssText = 'position: fixed; inset: 0; display: none; z-index: 2147483000; pointer-events: none;';
        this.appendChild(canvas);
    }
    
    this.canvas = canvas;
    this.ctx = this.canvas.getContext('2d');
    this.W = window.innerWidth;
    this.H = window.innerHeight;
    this.canvas.width = this.W;
    this.canvas.height = this.H;
  }
  
  initializeConfetti() {
    if (!this.canvas || !this.ctx) {
        this.setGlobals();
    }
    if (!this.canvas || !this.ctx) {
      return;
    }
    
    // Ngừng animation hiện tại trước khi bắt đầu cái mới
    this.clearTimers();
    
    this.canvas.style.display = 'block';
    this.particles = [];
    this.animationComplete = false;
    this.confettiActive = true;
    
    for (let i = 0; i < this.mp; i++) {
        const particleColor = this.particleColors.getColor();
        this.particles.push(this.createConfettiParticle(particleColor));
    }
    
    this.startConfetti();
  }
  
  draw() {
    if (!this.ctx) return [];
    
    this.ctx.clearRect(0, 0, this.W, this.H);
    const results = [];
    
    for (let i = 0; i < this.mp && i < this.particles.length; i++) {
        if (this.particles[i] && this.particles[i].draw) {
            results.push(this.particles[i].draw());
        }
    }
    
    this.update();
    return results;
  }
  
  randomFromTo(from, to) {
    return Math.floor(Math.random() * (to - from + 1) + from);
  }
  
  update() {
    let remainingFlakes = 0;
    let particle;
    this.angle += 0.01;
    this.tiltAngle += 0.1;
    
    for (let i = 0; i < this.mp && i < this.particles.length; i++) {
        particle = this.particles[i];
        if (this.animationComplete) return;
        
        if (!this.confettiActive && particle.y < -15) {
            particle.y = this.H + 100;
            continue;
        }
        
        this.stepParticle(particle, i);
        
        if (particle.y <= this.H) {
            remainingFlakes++;
        }
        
        this.checkForReposition(particle, i);
    }
    
    if (remainingFlakes === 0) {
        this.stopConfetti();
    }
  }
  
  checkForReposition(particle, index) {
    if ((particle.x > this.W + 20 || particle.x < -20 || particle.y > this.H) && this.confettiActive) {
      if (index % 5 > 0 || index % 2 === 0) { // 66.67% of the flakes
          this.repositionParticle(particle, Math.random() * this.W, -10, Math.floor(Math.random() * 10) - 10);
      } else {
        if (Math.sin(this.angle) > 0) {
            // Enter from the left
            this.repositionParticle(particle, -5, Math.random() * this.H, Math.floor(Math.random() * 10) - 10);
        } else {
            // Enter from the right
            this.repositionParticle(particle, this.W + 5, Math.random() * this.H, Math.floor(Math.random() * 10) - 10);
        }
      }
    }
  }
  
  stepParticle(particle, particleIndex) {
    particle.tiltAngle += particle.tiltAngleIncremental;
    particle.y += (Math.cos(this.angle + particle.d) + 3 + particle.r / 2) / 2;
    particle.x += Math.sin(this.angle);
    particle.tilt = (Math.sin(particle.tiltAngle - (particleIndex / 3))) * 15;
  }
  
  repositionParticle(particle, xCoordinate, yCoordinate, tilt) {
    particle.x = xCoordinate;
    particle.y = yCoordinate;
    particle.tilt = tilt;
  }
  
  startConfetti() {
    // Đảm bảo chỉ có 1 animation loop chạy
    if (this.animationHandler) {
      cancelAnimationFrame(this.animationHandler);
      this.animationHandler = null;
    }
    
    this.W = window.innerWidth;
    this.H = window.innerHeight;
    if (this.canvas) {
      this.canvas.width = this.W;
      this.canvas.height = this.H;
    }
    
    const animloop = () => {
      if (this.animationComplete) return null;
      this.animationHandler = requestAnimationFrame(animloop);
      return this.draw();
    };
    
    animloop();
  }
  
  clearTimers() {
    if (this.reactivationTimerHandler) {
      clearTimeout(this.reactivationTimerHandler);
    }
    if (this.animationHandler) {
      cancelAnimationFrame(this.animationHandler);
      this.animationHandler = null;
    }
  }
  
  deactivateConfetti() {
    this.confettiActive = false;
  }
  
  stopConfetti() {
    this.animationComplete = true;
    if (this.ctx) {
        this.ctx.clearRect(0, 0, this.W, this.H);
    }
    if (this.canvas) {
        this.canvas.style.display = 'none';
    }
  }
  
  restartConfetti() {
    this.clearTimers();
    this.stopConfetti();
    this.reactivationTimerHandler = setTimeout(() => {
      this.confettiActive = true;
      this.animationComplete = false;
      this.initializeConfetti();
    }, 100);
  }
  
  forceStopConfetti() {
    this.clearTimers();
    this.stopConfetti();
  }

  
  // Public API methods
  start() {
    // Chỉ start nếu chưa có animation đang chạy
    if (this.animationComplete || !this.confettiActive) {
      this.initializeConfetti();
    }
  }
  
  pause() {
    this.deactivateConfetti();
  }
  
  stop() {
    this.forceStopConfetti();
  }
  
  restart() {
    this.restartConfetti();
  }
}
// Guarded customElements registration for ConfettiElement
if (!customElements.get('confetti-element')) { customElements.define('confetti-element', ConfettiElement); }
// ---- Merged from NEW: class FaviconCartBadge
class FaviconCartBadge extends HTMLElement {
  constructor() {
    super();

    // Private properties
    this._badgeQueue = [];
    this._currentBadge = null;
    this._isReady = false;
    this._isVideoPlaying = false;
    this._canvas = null;
    this._context = null;
    this._originalImage = null;
    this._iconElements = [];
    this._canvasWidth = 32;
    this._canvasHeight = 32;
    this._animationTimeout = null;
    this._videoTimeout = null;

    // Default settings
    this._settings = {
      bgColor: { r: 221, g: 0, b: 0 },
      textColor: { r: 255, g: 255, b: 255 },
      fontFamily: "sans-serif",
      fontStyle: "bold",
      type: "circle",
      position: "down",
      animation: "slide",
      elementId: null,
      element: null
    };

    // Browser detection
    this._browser = {
      ff: typeof InstallTrigger !== 'undefined',
      chrome: !!window.chrome,
      opera: !!window.opera || navigator.userAgent.indexOf('Opera') >= 0,
      ie: false,
      safari: Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0
    };
    this._browser.supported = this._browser.chrome || this._browser.ff || this._browser.opera;

    // Animation configurations
    this._animationTypes = {
      fade: [
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0.1 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0.2 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0.3 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0.4 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0.5 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0.6 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0.7 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0.8 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 0.9 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 1 }
      ],
      none: [
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 1 }
      ],
      pop: [
        { x: 1, y: 1, w: 0, h: 0, o: 1 },
        { x: 0.9, y: 0.9, w: 0.1, h: 0.1, o: 1 },
        { x: 0.8, y: 0.8, w: 0.2, h: 0.2, o: 1 },
        { x: 0.7, y: 0.7, w: 0.3, h: 0.3, o: 1 },
        { x: 0.6, y: 0.6, w: 0.4, h: 0.4, o: 1 },
        { x: 0.5, y: 0.5, w: 0.5, h: 0.5, o: 1 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 1 }
      ],
      popFade: [
        { x: 0.75, y: 0.75, w: 0, h: 0, o: 0 },
        { x: 0.65, y: 0.65, w: 0.1, h: 0.1, o: 0.2 },
        { x: 0.6, y: 0.6, w: 0.2, h: 0.2, o: 0.4 },
        { x: 0.55, y: 0.55, w: 0.3, h: 0.3, o: 0.6 },
        { x: 0.5, y: 0.5, w: 0.4, h: 0.4, o: 0.8 },
        { x: 0.45, y: 0.45, w: 0.5, h: 0.5, o: 0.9 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 1 }
      ],
      slide: [
        { x: 0.4, y: 1, w: 0.6, h: 0.6, o: 1 },
        { x: 0.4, y: 0.9, w: 0.6, h: 0.6, o: 1 },
        { x: 0.4, y: 0.9, w: 0.6, h: 0.6, o: 1 },
        { x: 0.4, y: 0.8, w: 0.6, h: 0.6, o: 1 },
        { x: 0.4, y: 0.7, w: 0.6, h: 0.6, o: 1 },
        { x: 0.4, y: 0.6, w: 0.6, h: 0.6, o: 1 },
        { x: 0.4, y: 0.5, w: 0.6, h: 0.6, o: 1 },
        { x: 0.4, y: 0.4, w: 0.6, h: 0.6, o: 1 }
      ]
    };

    this._animationDuration = 40;
  }

  static get observedAttributes() {
    return ['cart-count', 'bg-color', 'text-color', 'font-family', 'font-style', 'type', 'position', 'animation', 'event-name'];
  }

connectedCallback() {
  this._initialize();
}

disconnectedCallback() {
  this._cleanup();
}

attributeChangedCallback(name, oldValue, newValue) {
  if (!this._isReady) return;

  switch (name) {
    case 'cart-count':
      this.setBadge(parseInt(newValue) || 0);
      break;
    case 'bg-color':
      this._settings.bgColor = this._hexToRgb(newValue);
      break;
    case 'text-color':
      this._settings.textColor = this._hexToRgb(newValue);
      break;
    case 'font-family':
      this._settings.fontFamily = newValue;
      break;
    case 'font-style':
      this._settings.fontStyle = newValue;
      break;
    case 'type':
      this._settings.type = newValue;
      break;
    case 'position':
      this._settings.position = newValue.toLowerCase();
      break;
    case 'animation':
      this._settings.animation = newValue;
      break;
    case 'event-name':
      this._setupEventListener(newValue || 'cartCount');
      break;
  }
}

_initialize() {
  // Parse attributes
  this._parseAttributes();

  // Adjust animations for position
  this._adjustAnimationPosition();

  // Get favicon elements
  this._iconElements = this._getIcons();

  // Create canvas
  this._canvas = document.createElement("canvas");
  this._originalImage = document.createElement("img");

  // Load original favicon
  const currentIcon = this._iconElements[this._iconElements.length - 1];
  if (currentIcon && currentIcon.hasAttribute("href")) {
    this._originalImage.setAttribute("crossOrigin", "anonymous");
    this._originalImage.onload = () => {
      this._canvasHeight = this._originalImage.height > 0 ? this._originalImage.height : 32;
      this._canvasWidth = this._originalImage.width > 0 ? this._originalImage.width : 32;
      this._canvas.height = this._canvasHeight;
      this._canvas.width = this._canvasWidth;
      this._context = this._canvas.getContext("2d");
      this._ready();
    };
    this._originalImage.setAttribute("src", currentIcon.getAttribute("href"));
  } else {
    this._canvasHeight = 32;
    this._canvasWidth = 32;
    this._originalImage.height = this._canvasHeight;
    this._originalImage.width = this._canvasWidth;
    this._canvas.height = this._canvasHeight;
    this._canvas.width = this._canvasWidth;
    this._context = this._canvas.getContext("2d");
    this._ready();
  }

  // Setup event listener
  const eventName = this.getAttribute('event-name') || 'cartCount';
  this._setupEventListener(eventName);
}
  _parseAttributes() {
    const bgColor = this.getAttribute('bg-color') || '#d00';
    const textColor = this.getAttribute('text-color') || '#fff';

    this._settings.bgColor = this._hexToRgb(bgColor);
    this._settings.textColor = this._hexToRgb(textColor);
    this._settings.fontFamily = this.getAttribute('font-family') || 'sans-serif';
    this._settings.fontStyle = this.getAttribute('font-style') || 'bold';
    this._settings.type = this.getAttribute('type') || 'circle';
    this._settings.position = (this.getAttribute('position') || 'down').toLowerCase();
    this._settings.animation = this.getAttribute('animation') || 'slide';
  }

  _adjustAnimationPosition() {
    const isUp = this._settings.position.indexOf("up") > -1;
    const isLeft = this._settings.position.indexOf("left") > -1;

    if (isUp || isLeft) {
      for (let type in this._animationTypes) {
        for (let i = 0; i < this._animationTypes[type].length; i++) {
          let frame = this._animationTypes[type][i];
          if (isUp) {
            if (frame.y < 0.6) {
              frame.y = frame.y - 0.4;
            } else {
              frame.y = frame.y - 2 * frame.y + (1 - frame.w);
            }
          }
          if (isLeft) {
            if (frame.x < 0.6) {
              frame.x = frame.x - 0.4;
            } else {
              frame.x = frame.x - 2 * frame.x + (1 - frame.h);
            }
          }
          this._animationTypes[type][i] = frame;
        }
      }
    }
  }

  _setupEventListener(eventName) {
    if (this._eventListener) {
      document.removeEventListener(this._currentEventName, this._eventListener);
    }

    this._currentEventName = eventName;
    this._eventListener = (event) => {
      // console.log(event);
      if (event.detail && typeof event.detail.item_count !== 'undefined') {
        this.setBadge(event.detail.item_count);
      }
    };

    document.addEventListener(eventName, this._eventListener);
  }

  _ready() {
    this._isReady = true;
    this.reset();

    // Set initial cart count
    const cart_count = parseInt(this.getAttribute('cart-count')) || 0;
    if (cart_count > 0) {
      this.setBadge(cart_count);
    }
  }

  _cleanup() {
    clearTimeout(this._animationTimeout);
    clearTimeout(this._videoTimeout);

    if (this._eventListener && this._currentEventName) {
      document.removeEventListener(this._currentEventName, this._eventListener);
    }
  }

  _hexToRgb(hex) {
    hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => {
      return r + r + g + g + b + b;
    });
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : { r: 221, g: 0, b: 0 };
  }

  _getIcons() {
    const elementId = this.getAttribute('element-id');
    let icons = [];

    if (elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        icons = [element];
        element.setAttribute("href", element.getAttribute("src"));
      }
    } else {
      // Find existing favicon links
      const headLinks = document.getElementsByTagName("head")[0].getElementsByTagName("link");
      for (let i = 0; i < headLinks.length; i++) {
        if (/(^|\s)icon(\s|$)/i.test(headLinks[i].getAttribute("rel"))) {
          icons.push(headLinks[i]);
        }
      }

      // Create favicon link if none exists
      if (icons.length === 0) {
        icons = [document.createElement("link")];
        icons[0].setAttribute("rel", "icon");
        document.getElementsByTagName("head")[0].appendChild(icons[0]);
      }
    }

    // Set type to PNG for all icons
    icons.forEach(icon => {
      icon.setAttribute("type", "image/png");
    });

    return icons;
  }

  _setIcon(canvas) {
    const url = canvas.toDataURL("image/png");
    this._setIconSrc(url);
  }

  _setIconSrc(url) {
    if (this._browser.ff || this._browser.opera) {
      // Firefox/Opera specific handling
      const old = this._iconElements[this._iconElements.length - 1];
      const newIcon = document.createElement("link");
      this._iconElements = [newIcon];
      if (this._browser.opera) {
        newIcon.setAttribute("rel", "icon");
      }
      newIcon.setAttribute("rel", "icon");
      newIcon.setAttribute("type", "image/png");
      document.getElementsByTagName("head")[0].appendChild(newIcon);
      newIcon.setAttribute("href", url);
      if (old.parentNode) {
        old.parentNode.removeChild(old);
      }
    } else {
      // Other browsers
      this._iconElements.forEach(icon => {
        icon.setAttribute("href", url);
      });
    }
  }

  _normalizeValues(values) {
    values.n = typeof values.n === "number" ? Math.abs(values.n | 0) : values.n;
    values.x = this._canvasWidth * values.x;
    values.y = this._canvasHeight * values.y;
    values.w = this._canvasWidth * values.w;
    values.h = this._canvasHeight * values.h;
    values.len = (values.n + "").length;
    return values;
  }

  _renderCircle(values) {
    let isWide = false;
    values = this._normalizeValues(values);

    // Adjust width for longer numbers
    if (values.len === 2) {
      values.x = values.x - (values.w * 0.4);
      values.w = values.w * 1.4;
      isWide = true;
    } else if (values.len >= 3) {
      values.x = values.x - (values.w * 0.65);
      values.w = values.w * 1.65;
      isWide = true;
    }

    this._context.clearRect(0, 0, this._canvasWidth, this._canvasHeight);
    this._context.drawImage(this._originalImage, 0, 0, this._canvasWidth, this._canvasHeight);
    this._context.beginPath();
    this._context.font = this._settings.fontStyle + " " + Math.floor(values.h * (values.n > 99 ? 0.85 : 1)) + "px " + this._settings.fontFamily;
    this._context.textAlign = "center";

    // Draw badge shape
    if (isWide) {
      // Rounded rectangle for wider badges
      this._context.moveTo(values.x + values.w / 2, values.y);
      this._context.lineTo(values.x + values.w - values.h / 2, values.y);
      this._context.quadraticCurveTo(values.x + values.w, values.y, values.x + values.w, values.y + values.h / 2);
      this._context.lineTo(values.x + values.w, values.y + values.h - values.h / 2);
      this._context.quadraticCurveTo(values.x + values.w, values.y + values.h, values.x + values.w - values.h / 2, values.y + values.h);
      this._context.lineTo(values.x + values.h / 2, values.y + values.h);
      this._context.quadraticCurveTo(values.x, values.y + values.h, values.x, values.y + values.h - values.h / 2);
      this._context.lineTo(values.x, values.y + values.h / 2);
      this._context.quadraticCurveTo(values.x, values.y, values.x + values.h / 2, values.y);
    } else {
      // Perfect circle
      this._context.arc(values.x + values.w / 2, values.y + values.h / 2, values.h / 2, 0, 2 * Math.PI);
    }

    // Fill badge background
    this._context.fillStyle = `rgba(${this._settings.bgColor.r},${this._settings.bgColor.g},${this._settings.bgColor.b},${values.o})`;
    this._context.fill();
    this._context.closePath();
    this._context.beginPath();
    this._context.stroke();

    // Draw text
    this._context.fillStyle = `rgba(${this._settings.textColor.r},${this._settings.textColor.g},${this._settings.textColor.b},${values.o})`;

    if (typeof values.n === "number" && values.n > 999) {
      this._context.fillText((values.n > 9999 ? 9 : Math.floor(values.n / 1000)) + "k+",
        Math.floor(values.x + values.w / 2),
        Math.floor(values.y + values.h - (values.h * 0.2)));
    } else {
      this._context.fillText(values.n,
        Math.floor(values.x + values.w / 2),
        Math.floor(values.y + values.h - (values.h * 0.15)));
    }
    this._context.closePath();
  }

  _renderRectangle(values) {
    values = this._normalizeValues(values);

    // Adjust width for longer numbers
    if (values.len === 2) {
      values.x = values.x - (values.w * 0.4);
      values.w = values.w * 1.4;
    } else if (values.len >= 3) {
      values.x = values.x - (values.w * 0.65);
      values.w = values.w * 1.65;
    }

    this._context.clearRect(0, 0, this._canvasWidth, this._canvasHeight);
    this._context.drawImage(this._originalImage, 0, 0, this._canvasWidth, this._canvasHeight);
    this._context.beginPath();
    this._context.font = this._settings.fontStyle + " " + Math.floor(values.h * (values.n > 99 ? 0.9 : 1)) + "px " + this._settings.fontFamily;
    this._context.textAlign = "center";

    // Draw rectangle
    this._context.fillStyle = `rgba(${this._settings.bgColor.r},${this._settings.bgColor.g},${this._settings.bgColor.b},${values.o})`;
    this._context.fillRect(values.x, values.y, values.w, values.h);

    // Draw text
    this._context.fillStyle = `rgba(${this._settings.textColor.r},${this._settings.textColor.g},${this._settings.textColor.b},${values.o})`;

    if (typeof values.n === "number" && values.n > 999) {
      this._context.fillText((values.n > 9999 ? 9 : Math.floor(values.n / 1000)) + "k+",
        Math.floor(values.x + values.w / 2),
        Math.floor(values.y + values.h - (values.h * 0.2)));
    } else {
      this._context.fillText(values.n,
        Math.floor(values.x + values.w / 2),
        Math.floor(values.y + values.h - (values.h * 0.15)));
    }
    this._context.closePath();
  }

  _mergeObjects(obj1, obj2) {
    const result = {};
    for (let key in obj1) {
      result[key] = obj1[key];
    }
    for (let key in obj2) {
      result[key] = obj2[key];
    }
    return result;
  }

  _runAnimation(options, callback, reverse, frameIndex) {
    const frames = this._animationTypes[document.hidden || document.msHidden || document.webkitHidden || document.mozHidden ? "none" : this._settings.animation];

    frameIndex = reverse === true
      ? (frameIndex !== undefined ? frameIndex : frames.length - 1)
      : (frameIndex !== undefined ? frameIndex : 0);

    callback = callback || function () { };

    if (frameIndex < frames.length && frameIndex >= 0) {
      const renderMethod = this._settings.type === 'rectangle' ? this._renderRectangle : this._renderCircle;
      renderMethod.call(this, this._mergeObjects(options, frames[frameIndex]));

      this._videoTimeout = setTimeout(() => {
        if (reverse) {
          frameIndex -= 1;
        } else {
          frameIndex += 1;
        }
        this._runAnimation(options, callback, reverse, frameIndex);
      }, this._animationDuration);

      this._setIcon(this._canvas);
    } else {
      callback();
    }
  }

  _start() {
    if (this._isReady && !this._isVideoPlaying && this._badgeQueue.length > 0) {
      this._isVideoPlaying = true;

      const processBadge = () => {
        // Apply badge options
        ["type", "animation", "bgColor", "textColor", "fontFamily", "fontStyle"].forEach(prop => {
          if (prop in this._badgeQueue[0].options) {
            this._settings[prop] = this._badgeQueue[0].options[prop];
          }
        });

        this._runAnimation(this._badgeQueue[0].options, () => {
          this._currentBadge = this._badgeQueue[0];
          this._isVideoPlaying = false;
          if (this._badgeQueue.length > 0) {
            this._badgeQueue.shift();
            this._start();
          }
        }, false);
      };

      if (this._currentBadge) {
        this._runAnimation(this._currentBadge.options, () => {
          processBadge();
        }, true);
      } else {
        processBadge();
      }
    }
  }

  // Public methods
  setBadge(number, options = {}) {
    if (!this._isReady) return;

    try {
      if (typeof number === "number" ? number > 0 : number !== "") {
        const badgeOptions = {
          type: "badge",
          options: { n: number }
        };

        if ("animation" in options && this._animationTypes[options.animation + ""]) {
          badgeOptions.options.animation = options.animation + "";
        }

        if ("type" in options && (options.type === 'circle' || options.type === 'rectangle')) {
          badgeOptions.options.type = options.type + "";
        }

        ["bgColor", "textColor"].forEach(prop => {
          if (prop in options) {
            badgeOptions.options[prop] = this._hexToRgb(options[prop]);
          }
        });

        ["fontStyle", "fontFamily"].forEach(prop => {
          if (prop in options) {
            badgeOptions.options[prop] = options[prop];
          }
        });

        this._badgeQueue.push(badgeOptions);

        if (this._badgeQueue.length > 100) {
          throw new Error("Too many badges requests in queue.");
        }

        this._start();
      } else {
        this.reset();
      }
    } catch (error) {
      throw new Error("Error setting badge. Message: " + error.message);
    }
  }

  reset() {
    if (this._isReady) {
      this._badgeQueue = [];
      this._currentBadge = false;
      this._isVideoPlaying = false;
      this._context.clearRect(0, 0, this._canvasWidth, this._canvasHeight);
      this._context.drawImage(this._originalImage, 0, 0, this._canvasWidth, this._canvasHeight);
      this._setIcon(this._canvas);
      clearTimeout(this._videoTimeout);
      clearTimeout(this._animationTimeout);
    }
  }

  // Getters for current settings
  get cart_count() {
    return parseInt(this.getAttribute('cart-count')) || 0;
  }

  set cart_count(value) {
    this.setAttribute('cart-count', value);
  }

  get bgColor() {
    return this.getAttribute('bg-color') || '#d00';
  }

  set bgColor(value) {
    this.setAttribute('bg-color', value);
  }

  get textColor() {
    return this.getAttribute('text-color') || '#fff';
  }

  set textColor(value) {
    this.setAttribute('text-color', value);
  }
}
// Guarded customElements registration for FaviconCartBadge
if (!customElements.get('favicon-cart-badge')) { customElements.define('favicon-cart-badge', FaviconCartBadge); }

// --------------------------
// Readmore / Less (improved)
// --------------------------

class readmoreLess extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('[is="readmoreLessBtn"]');
    this.content = this.querySelector('[is="readmoreLessContent"]');
    this.defaultHeight = parseInt(this.getAttribute('height')) || 120;
    this.expanded = false;
  }

  connectedCallback() {
    if (!this.btn || !this.content) return;

    // Lazy-init: يبدأ فقط عند ظهور العنصر في الشاشة
    const observer = new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) {
        obs.disconnect();
        this.init();
      }
    }, { threshold: 0.1 });

    observer.observe(this);
  }

  init() {
    // لو المحتوى قصير، أخفِ الزر
    if (this.content.scrollHeight <= this.defaultHeight) {
      this.btn.style.display = 'none';
      return;
    }

    // استخدم CSS variable للارتفاع
    this.updateHeight();
    this.btn.addEventListener('click', () => this.toggle());
    window.addEventListener('resize', () => this.updateHeight(), { passive: true });
  }

  updateHeight() {
    this.content.style.setProperty('--readmore-height', `${this.defaultHeight}px`);
    if (!this.expanded) {
      this.content.style.maxHeight = `var(--readmore-height)`;
    }
  }

  toggle() {
    this.expanded = !this.expanded;
    if (this.expanded) {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
      this.btn.textContent = this.btn.dataset.less || 'Read less';
    } else {
      this.content.style.maxHeight = `var(--readmore-height)`;
      this.btn.textContent = this.btn.dataset.more || 'Read more';
    }
  }
}

// حماية من التعريف المكرر
if (!customElements.get('readmore-less')) {
  customElements.define('readmore-less', readmoreLess);
}


(function () {
  if (window.__btCartRewardCelebration) return;

  var state = {
    scope: '',
    stage: '',
    rank: -1,
    frame: 0,
    stopTimer: 0,
    activeConfetti: null
  };

  function isVisible(element) {
    if (!element || element.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return element.getClientRects().length > 0;
  }

  function activePanel(root) {
    var scope = root.getAttribute('data-reward-scope');
    return scope === 'omr'
      ? root.querySelector('[data-bt-omr-bar]')
      : root.querySelector('[data-bt-non-omr-bar]');
  }

  function visibleRewardRoot() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-bt-cart-rewards]'));
    for (var i = 0; i < roots.length; i++) {
      if (isVisible(activePanel(roots[i]))) return roots[i];
    }
    return null;
  }

  function stageRank(scope, stage) {
    if (scope === 'omr') {
      if (stage === 'coupon_success') return 2;
      if (stage === 'coupon') return 1;
      return 0;
    }
    return stage === 'success' ? 1 : 0;
  }

  function dispatchConfetti(name, target) {
    if (!target) return;
    document.dispatchEvent(new CustomEvent(name, {
      detail: { target: target, source: 'cart-reward' }
    }));
  }

  function celebrate(root) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var target = root.querySelector('[data-bt-reward-confetti]');
    if (!target) return;

    var hadActiveConfetti = !!state.activeConfetti;
    window.clearTimeout(state.stopTimer);
    if (hadActiveConfetti) {
      dispatchConfetti('confetti:pause', state.activeConfetti);
    }

    state.activeConfetti = target;
    var delay = hadActiveConfetti ? 60 : 0;

    window.setTimeout(function () {
      dispatchConfetti('confetti:start', target);
      state.stopTimer = window.setTimeout(function () {
        dispatchConfetti('confetti:pause', target);
        if (state.activeConfetti === target) state.activeConfetti = null;
      }, 1800);
    }, delay);
  }

  function checkRewards() {
    var root = visibleRewardRoot();
    if (!root) return;

    var scope = root.getAttribute('data-reward-scope') || 'other';
    var stage = root.getAttribute('data-reward-stage') || (scope === 'omr' ? 'shipping' : 'progress');
    var rank = stageRank(scope, stage);

    if (state.rank < 0 || state.scope !== scope) {
      state.scope = scope;
      state.stage = stage;
      state.rank = rank;
      if (rank > 0) celebrate(root);
      return;
    }

    if (rank > state.rank) celebrate(root);

    state.scope = scope;
    state.stage = stage;
    state.rank = rank;
  }

  function scheduleCheck() {
    window.cancelAnimationFrame(state.frame);
    state.frame = window.requestAnimationFrame(checkRewards);
  }

  window.__btCartRewardCelebration = {
    refresh: scheduleCheck
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCheck, { once: true });
  } else {
    scheduleCheck();
  }

  [
    'cart:update',
    'cart:reload',
    'cart:drawer:render',
    'cart:main:render',
    'dialog:open',
    'currency:applied',
    'currency:update',
    'currency:changed',
    'shopify:section:load'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleCheck);
  });

  document.addEventListener('dialog:close', function () {
    if (!state.activeConfetti) return;
    dispatchConfetti('confetti:pause', state.activeConfetti);
    state.activeConfetti = null;
    window.clearTimeout(state.stopTimer);
  }, true);
})();



(function () {
  function getText(el) {
    return (el?.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function getButtonTotalText() {
    const btn = document.querySelector('.es-total-placeholder.money');
    if (!btn) return null;
    return getText(btn) || null;
  }

  function findTopTotalElement() {
    const root = document.querySelector('.total-value');
    if (!root) return null;

    const rows = Array.from(root.children).filter(isVisible);

    for (const row of rows) {
      const rowText = getText(row);
      if (rowText.includes('المجموع')) {
        const moneyEl = row.querySelector('.money');
        if (moneyEl) return moneyEl;
      }
    }

    const allMoney = Array.from(root.querySelectorAll('.money')).filter(isVisible);
    return allMoney.length ? allMoney[allMoney.length - 1] : null;
  }

  function patchTopTotalOnly() {
    const correctText = getButtonTotalText();
    if (!correctText) return;

    const topEl = findTopTotalElement();
    if (!topEl) return;

    if (getText(topEl) !== correctText) {
      topEl.textContent = correctText;
    }
  }

  let scheduled = false;
  function schedulePatch() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      patchTopTotalOnly();
    });
  }

  function afterCartChange() {
    schedulePatch();
    setTimeout(patchTopTotalOnly, 100);
    setTimeout(patchTopTotalOnly, 500);
  }

  ['cart:update', 'cart:reload', 'cart:drawer:render', 'cart:main:render'].forEach(function (eventName) {
    document.addEventListener(eventName, afterCartChange);
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('#es-form-button, .es-cta-group, .es-modal, .es-popup')) {
      afterCartChange();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchTopTotalOnly);
  } else {
    patchTopTotalOnly();
  }

  setTimeout(patchTopTotalOnly, 300);
  setTimeout(patchTopTotalOnly, 900);
})();




(function(){
  function ensureCloseBtn(dlg){
    if(!dlg) return;
    if(dlg.querySelector(':scope > .hdt-dialog-btn__close')) return;
    var btn = document.createElement('button');
    btn.className = 'hdt-s-text hdt-dialog-btn__close';
    btn.setAttribute('ref','closeButton');
    btn.setAttribute('aria-controls', dlg.id);
    btn.setAttribute('aria-label','سكر');
    btn.setAttribute('formmethod','dialog');
    btn.innerHTML = '<svg part="hdt-close-icon" class="hdt-icon hdt-icon-close" role="presentation" fill="none" focusable="false" width="16" height="14" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg>';
    dlg.appendChild(btn);
  }

  function getCurrentCurrencyISO(){
    try{
      var a = localStorage.getItem('hdt_currency_iso');
      var b = localStorage.getItem('T4Currency');
      var raw = (a || b || (window.Shopify && Shopify.currency && Shopify.currency.active) || '').toString();
      return raw.toUpperCase().split('|')[0].replace(/[^A-Z]/g,'').slice(0,3) || null;
    }catch(_){ return null; }
  }

  function getCurrentLangCode(){
    var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return htmlLang.split('-')[0] || htmlLang || null;
  }

  function markCurrentCurrency(){
    var dlg = document.getElementById('popover-currencies');
    if(!dlg) return;
    var iso = getCurrentCurrencyISO();
    if(!iso) return;
    dlg.querySelectorAll('[value],[data-value],[role="option"][value],li>button,li>a').forEach(function(el){
      var code = (el.getAttribute('data-currency')||el.getAttribute('value')||el.getAttribute('data-value')||el.textContent||'')
        .toUpperCase().split('|')[0].replace(/[^A-Z]/g,'').slice(0,3);
      el.classList.remove('k5d-current');
      if(el.getAttribute('aria-selected')==='true'||el.classList.contains('is-active')||code===iso){
        el.classList.add('k5d-current');
      }
    });
  }

  function markCurrentLanguage(){
    var dlg = document.getElementById('popover-languages');
    if(!dlg) return;
    var lang = getCurrentLangCode();
    if(!lang) return;
    dlg.querySelectorAll('button[name="language_code"],[role="option"][name="language_code"]').forEach(function(b){
      var v = (b.getAttribute('value')||'').toLowerCase();
      b.classList.remove('k5d-current');
      if(b.getAttribute('aria-selected')==='true'||v===lang||v.startsWith(lang+'-')){
        b.classList.add('k5d-current');
      }
    });
  }

  function hideEmptyCurrencyTiles(){
    var wrap = document.querySelector('#popover-currencies');
    if(!wrap) return;
    wrap.querySelectorAll('[value],[data-value],[role="option"][value],li>button,li>a')
      .forEach(function(b){
        var label = (b.textContent||'').trim();
        var val = (b.getAttribute('value')||b.getAttribute('data-value')||'').trim();
        if(!label && !val) b.style.display='none';
      });
  }

  function addFlagIfMissing(){
    var wrap = document.querySelector('#popover-currencies');
    if(!wrap) return;
    function codeFrom(el){
      return (el.getAttribute('value')||el.getAttribute('data-value')||el.textContent||'')
        .toUpperCase().split('|')[0].replace(/[^A-Z]/g,'').slice(0,3);
    }
    function flagIso2(iso3){
      var map={USD:'US',EUR:'EU',GBP:'GB',AED:'AE',SAR:'SA',QAR:'QA',KWD:'KW',BHD:'BH',OMR:'OM'};
      return (map[iso3]||iso3.slice(0,2)||'US').toLowerCase();
    }
    wrap.querySelectorAll('[value],[data-value],[role="option"][value],li>button,li>a')
      .forEach(function(el){
        if(el.querySelector('img')) return;
        var iso = codeFrom(el);
        if(!/^[A-Z]{3}$/.test(iso)) return;
        var img = document.createElement('img');
        img.src='//cdn.shopify.com/static/images/flags/'+flagIso2(iso)+'.svg';
        img.width=22; img.height=15; img.alt=iso;
        el.insertBefore(img,el.firstChild);
      });
  }

  function run(){
    if(!window.matchMedia('(max-width:767px)').matches) return;
    var dlgLang=document.getElementById('popover-languages');
    var dlgCurr=document.getElementById('popover-currencies');
    ensureCloseBtn(dlgLang);
    ensureCloseBtn(dlgCurr);
    hideEmptyCurrencyTiles();
    addFlagIfMissing();
    markCurrentCurrency();
    markCurrentLanguage();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run);
  else run();

  document.addEventListener('currency:applied',run);
  document.addEventListener('currency:update',run);
  document.addEventListener('richlist:change',run);
})();

(function () {
  // فعّل التأثير فقط عند وجود ?app=1 في الرابط
  if (!/\bapp=1\b/.test(location.search)) return;

  function hideKnownChrome() {
    var selectors = [
      // Header / Footer / Announcement / Nav
      "header", "[role='banner']",
      "#shopify-section-header", "[id^='shopify-section-header']",
      ".site-header", ".header-wrapper", "[class*='Header__']",
      ".announcement-bar", ".AnnouncementBar", "[class*='announcement']",
      "footer", "[role='contentinfo']",
      "#shopify-section-footer", "[id^='shopify-section-footer']",
      ".site-footer", ".Footer",
      ".navbar", ".nav", ".menu", ".menu-drawer", ".drawer", ".mobile-nav",
      ".sticky-header", "[class*='sticky'][class*='header']",

      // Hero / heading overlays الشائعة في قوالب HDT
      ".hdt-heading-image", ".hdt-h-overlay",

      // مسارات breadcrumbs والأشرطة الثانوية
      ".breadcrumbs", "[class*='Breadcrumb']"
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("height", "0px", "important");
        el.style.setProperty("min-height", "0px", "important");
        el.style.setProperty("margin", "0px", "important");
        el.style.setProperty("padding", "0px", "important");
      });
    });
  }

  function hidePageTitlesOnly() {
    var titleSelectors = [
      "h1.page-title", "#PageTitle", ".title-wrapper", ".SectionHeader__Heading",
      "h1.sr-only",
      "h1.shopify-block[id*='__heading_liquid']",
      "[id^='block-'][id*='__heading_liquid'].hdt-heading-liquid",
      ".hdt-heading-liquid.hdt-text-4xl.hdt-font-1"
    ];

    titleSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("height", "0px", "important");
        el.style.setProperty("margin", "0px", "important");
        el.style.setProperty("padding", "0px", "important");
      });
    });

    // إخفاء أي H1 يطابق عنوان الصفحة
    var docTitle = (document.title || "").trim();
    document.querySelectorAll("h1, .SectionHeader__Heading, .page-title").forEach(function (h) {
      var t = (h.textContent || "").trim();
      if (t && docTitle && (t === docTitle || t === docTitle.replace(/\s*\|\s*.*/,""))) {
        h.style.setProperty("display", "none", "important");
        h.style.setProperty("visibility", "hidden", "important");
        h.style.setProperty("height", "0px", "important");
        h.style.setProperty("margin", "0px", "important");
        h.style.setProperty("padding", "0px", "important");
      }
    });

    // لو العنوان داخل H1 يحتوي بلوك داخلي
    document.querySelectorAll("[id^='block-'][id*='__heading_liquid']").forEach(function (inner) {
      var h1 = inner.closest("h1");
      if (h1) {
        h1.style.setProperty("display", "none", "important");
        h1.style.setProperty("visibility", "hidden", "important");
        h1.style.setProperty("height", "0px", "important");
        h1.style.setProperty("margin", "0px", "important");
        h1.style.setProperty("padding", "0px", "important");
      }
    });
  }

  function keepOnlyMain() {
    var candidates = Array.from(document.querySelectorAll(
      "#MainContent, main, [role='main'], .Main, .PageContent, .main-content, #app-main"
    ));
    var main = candidates
      .filter(function (el) { return el && el.offsetParent !== null; })
      .sort(function (a, b) { return b.offsetHeight - a.offsetHeight; })[0] || document.body;

    // إخفاء كل ما هو خارج المحتوى
    Array.from(document.body.children).forEach(function (child) {
      if (child !== main) {
        child.style.setProperty("display", "none", "important");
        child.style.setProperty("visibility", "hidden", "important");
        child.style.setProperty("height", "0px", "important");
        child.style.setProperty("margin", "0px", "important");
        child.style.setProperty("padding", "0px", "important");
      }
    });

    // إزالة المسافات البيضاء العلوية نهائياً
    document.documentElement.style.setProperty("margin", "0", "important");
    document.documentElement.style.setProperty("padding", "0", "important");
    document.body.style.setProperty("margin", "0", "important");
    document.body.style.setProperty("padding", "0", "important");
    main.style.setProperty("margin-top", "0", "important");
    main.style.setProperty("padding-top", "0", "important");
    main.style.setProperty("margin", "0", "important");
    main.style.setProperty("padding", "20px", "important");
    main.style.setProperty("width", "100%", "important");
    main.style.setProperty("max-width", "100%", "important");
    main.style.setProperty("box-sizing", "border-box", "important");

    document.body.style.setProperty("background", "#fff", "important");
    document.body.style.setProperty("color", "#333", "important");
    document.documentElement.style.setProperty("overflow-x", "hidden", "important");
    document.body.style.setProperty("overflow-x", "hidden", "important");
  }

  function applyAll() {
    hideKnownChrome();
    hidePageTitlesOnly();
    keepOnlyMain();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll);
  } else {
    applyAll();
  }

  window.addEventListener("load", applyAll);

  try {
    new MutationObserver(function () { applyAll(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  setInterval(applyAll, 1000);
})();
